<template>
  <b-card no-body>
    <b-modal ref="adminSpecialModal" size="lg" hide-header hide-footer>
      <b-container>
        <b-row>
          <b-col>
            <b-card
              no-body
              class="mb-1"
              v-for="(option, opIndex) in selectedField.special_select_options"
              :key="opIndex + '-opti'"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle="'accordion-' + opIndex"
                  variant="unknown"
                  >{{
                    option.data[selectedField.special_select_fields[0]]
                  }}</b-button
                >
              </b-card-header>
              <b-collapse
                :id="'accordion-' + opIndex"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-row
                    v-for="(
                      field, fIndex
                    ) in selectedField.special_select_fields"
                    :key="fIndex + '-fi'"
                  >
                    <b-col cols="3" class="text-right"> {{ field }}: </b-col>
                    <b-col>
                      <b-input
                        v-model="option.data[field]"
                        :disabled="$store.state.login.schoolLevel < 2"
                      />
                    </b-col>
                  </b-row>
                  <b-row v-if="$store.state.login.schoolLevel >= 2">
                    <b-col
                      class="text-right"
                      @click="saveSpecialOption(option)"
                    >
                      <b-button pill variant="primary"> Guardar </b-button>
                    </b-col>
                    <b-col
                      class="text-left"
                      v-if="$store.state.login.isAdmin"
                      @click="deleteSpecialOption(option, opIndex)"
                    >
                      <b-button pill variant="danger"> Eliminar </b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="'add'" variant="success"
                  >Añadir</b-button
                >
              </b-card-header>
              <b-collapse :id="'add'" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-row> <h3>Añadir opción</h3> </b-row>
                  <b-row
                    v-for="(specialOption, sIndex) in selectedSelector"
                    :key="sIndex + '-s'"
                  >
                    <b-col>
                      {{ specialOption }}
                    </b-col>
                    <b-col>
                      <b-input v-model="newOption[specialOption]"> </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-right">
                      <b-button
                        variant="primary"
                        pill
                        @click="addSpecialOption"
                      >
                        Añadir
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal ref="extra-oas-modal" hide-footer>
      <b-container>
        <h3>Agregar otros OAs</h3>
        <b-select v-model="subjectFilter">
          <b-select-option :value="''">
            Seleccione filtro de asignatura
          </b-select-option>
          <b-select-option
            v-for="(subject, subjectIndex) in subjectOptions"
            :key="subjectIndex + '-subject'"
            :value="subject"
          >
            {{ subject }}
          </b-select-option>
        </b-select>
        <div
          v-for="(extraOA, extraIndex) in extraOAs.filter((oa) =>
            oa.subject.includes(subjectFilter)
          )"
          :key="extraIndex + '-extra'"
        >
          <b-row
            v-if="
              field_values[extraKey] &&
              !field_values[extraKey]['oas'].includes(extraOA.id)
            "
          >
            <b-col @click="setOA(extraOA.id)">
              <b-checkbox
                v-model="field_values[extraKey]['oas']"
                :value="extraOA.id"
                size="lg"
                @input="updateOas(extraKey, extraOA.id)"
              >
                <!-- {{ extraOA }} -->
                <strong>{{ extraOA.subject }} - {{ extraOA.name }}</strong>
                <img
                  :src="starIcon"
                  v-if="extraOA.priority === 1"
                  width="22px"
                />
                <br />
                {{ extraOA.summary ? extraOA.summary : extraOA.description }}
              </b-checkbox>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </b-modal>

    <b-modal
      ref="add-dimension-modal"
      title="Agregar dimensión"
      @ok="confirmAddDimension"
      ok-title="Agregar"
      cancel-title="Cancelar"
    >
      <p v-if="addDimensionTarget && addDimensionTarget.area" class="text-muted">
        Agregando dimensión a:
        <strong>{{ addDimensionTarget.area.headerText }}</strong>
      </p>
      <b-form-group label="Nombre de la dimensión">
        <b-form-input v-model="newDimensionName" placeholder="Ej: Memoria episódica" />
      </b-form-group>
    </b-modal>

    <b-overlay :show="blockAllInputs && !is_backup">
      <b-container fluid class="mt-3">
        <b-alert show dismissible>
          <b-row>
            <b-col>
              <strong>Campos requeridos faltantes: {{ errors.amount }}</strong>
              <b-button v-b-toggle.errors-collapse variant="primary" class="ml-2">
                Ver
              </b-button>
            </b-col>
          </b-row>
          <b-collapse id="errors-collapse" class="mt-2">
            <h3>Campos requeridos faltantes</h3>
            <b-container>
              <ul>
                <li
                  class="w-100"
                  v-for="(page, pIndex) in errors.pages"
                  :key="pIndex + '-p'"
                >
                  <h2 class="w-100">
                    {{ page.name }}
                  </h2>
                  <ul v-if="page.fields">
                    <li
                      v-for="(field, fIndex) in page.fields"
                      :key="fIndex + '-f'"
                    >
                      <p>
                        {{ field.name ? 'El campo "' + field.name + '"' : "" }}
                        {{
                          field.kind === 1
                            ? "necesita ser llenado o superó el límite de caracteres"
                            : ""
                        }}
                        {{
                          field.kind === 3
                            ? "necesita tener al menos un campo con el logro alcanzado especificado"
                            : ""
                        }}
                        {{
                          field.kind === 4
                            ? "necesita tener un usuario seleccionado"
                            : ""
                        }}
                        {{
                          field.kind === 5
                            ? "necesita tener una opción seleccionada"
                            : ""
                        }}
                        {{
                          field.kind === 6
                            ? "necesita tener al menos un oa seleccionado"
                            : ""
                        }}
                        {{
                          field.kind === 7
                            ? "necesita tener al menos una opción marcada"
                            : ""
                        }}
                      </p>
                    </li>
                  </ul>
                  <ul v-else-if="Object.keys(page).length > 1">
                    <li
                      v-for="(item, kIndex) in Object.keys(page).filter(
                        (key) => key !== 'name'
                      )"
                      :key="kIndex + '-key'"
                    >
                      {{ item }}
                      <document-online-error-field :item="page[item]" />
                    </li>
                  </ul>
                  <div v-else>Página sin errores</div>
                </li>
              </ul>
            </b-container>
          </b-collapse>
        </b-alert>
      </b-container>
      <b-tabs justified card v-model="pageIndex">
        <b-tab
          v-for="(page, pIndex) in document.document_template.pages"
          :key="pIndex + '-page'"
        >
          <template #title>
            <strong>
              {{ page.name ? page.name : "Página " + (pIndex + 1) }}
            </strong>
          </template>
          <b-container v-if="!page.rows.length">
            <b-row>
              <b-col class="text-center">
                <b-spinner />
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid class="mt-3" v-else>
            <b-row v-if="$store.state.login.schoolLevel > 1">
              <b-col class="text-right">
                <b-button
                  variant="primary"
                  pill
                  v-if="!editing"
                  @click="editing = true"
                >
                  <v-icon name="pen" />
                </b-button>
                <b-button variant="danger" pill v-else @click="editing = false">
                  <v-icon name="arrow-left" /> Salir del modo edición
                </b-button>
              </b-col>
            </b-row>
            <b-row v-if="Object.keys(achievementData).length">
              <b-col class="text-center">
                Porcentaje de avance en
                {{ page.name ? page.name : "Página " + (pIndex + 1) }}
              </b-col>
            </b-row>
            <b-row
              v-if="Object.keys(achievementData).length && pIndex === pageIndex"
            >
              <b-col
                class="text-center"
                :key="pIndex"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  .echarts {
                    width: 100%;
                    .div {
                      width: 100%;
                    }
                    .canvas {
                      width: 100%;
                    }
                  }
                "
              >
                <chart
                  style="width: 100%"
                  :options="chartOptionsBar"
                  v-if="achievementData"
                ></chart>
              </b-col>
            </b-row>
            <template v-for="(row, rIndex) in page.rows">
            <b-row
              :key="rIndex + '-row'"
              class="my-0 py-1"
              v-show="!shouldHideEmptyMirrorRow(row, page)"
              :style="
                row.fields.length === 2 &&
                !row.fields[0].kind &&
                row.fields[1].kind
                  ? 'border-bottom: 2px solid #bb8800'
                  : ''
              "
            >
              <b-col
                v-for="(field, fIndex) in row.fields"
                :key="fIndex + '-field'"
                cols="12"
                :md="field.size"
                :id="isQuestionField(field) ? 'question-' + field.key : null"
                class="my-0 py-0"
                :class="{
                  'question-field': isQuestionField(field),
                  'question-focused':
                    isQuestionField(field) &&
                    field.key === focusedQuestionKey &&
                    !isAchievementField(field),
                }"
              >
                <!-- Aux wrapper: BCol is a functional component, so native
                     listeners on it are ignored; this plain div focuses the
                     question on any click / focus inside it. -->
                <div
                  class="question-inner"
                  @click="onQuestionInteract(field)"
                  @focusin="onQuestionInteract(field)"
                >
                <div
                  v-if="!field.kind && !emptyFields.includes(field.id)"
                  class="h-100 d-flex align-items-center"
                >
                  <p
                    v-if="!field.is_title"
                    class="w-100"
                    :class="
                      row.fields.length === 2 &&
                      !row.fields[0].kind &&
                      row.fields[1].kind
                        ? 'text-left'
                        : 'text-center'
                    "
                  >
                    {{ field.text }}
                  </p>
                  <div v-else>
                    <h1
                      v-if="field.style === 1"
                      class="w-100"
                      :class="
                        row.fields.length === 2 &&
                        !row.fields[0].kind &&
                        row.fields[1].kind
                          ? 'text-left'
                          : 'text-center'
                      "
                    >
                      {{ field.text }}
                    </h1>
                    <h2 v-if="field.style === 2">{{ field.text }}</h2>
                    <h6 v-if="field.style === 3">
                      <strong>{{ field.text }}</strong>
                      <small
                        v-if="editing && $store.state.login.isAdmin && page.name === 'OBJETIVOS POR ESPECIALIDAD' && headerAreaOf(row.id, page.id)"
                        class="text-muted ml-2"
                        style="font-weight: normal"
                      >
                        Variable Jinja: <code>extras.{{ headerAreaOf(row.id, page.id).slug }}</code>
                      </small>
                    </h6>
                    <div
                      v-if="field.style === 3 && isEmptyMirrorAchievementArea(headerAreaOf(row.id, page.id), page)"
                      class="eda-empty-source-wrap"
                    >
                      <div class="eda-empty-source">
                        <p class="eda-empty-source-lead">
                          Aún no hay objetivos para evaluar en
                          <strong>{{ extractAreaLabel(field.text) }}</strong>
                        </p>
                        <template
                          v-if="
                            sourceInfoForArea(headerAreaOf(row.id, page.id))
                              .no_source
                          "
                        >
                          <p class="eda-empty-source-text">
                            {{
                              sourceInfoForArea(headerAreaOf(row.id, page.id))
                                .message
                            }}
                          </p>
                        </template>
                        <template v-else>
                          <p class="eda-empty-source-text">
                            Primero debes marcar en el
                            <strong>{{
                              sourceInfoForArea(headerAreaOf(row.id, page.id))
                                .source_document_name || "documento fuente"
                            }}</strong>
                            del <strong>mismo estudiante</strong> qué
                            indicadores quieres puntuar aquí (marca las casillas
                            ✓ en cada dimensión). Después vuelve al Estado de
                            Avance y podrás asignar Logrado, Parcialmente
                            logrado o No logrado.
                          </p>
                          <p
                            v-if="
                              sourceInfoForArea(headerAreaOf(row.id, page.id))
                                .student_name
                            "
                            class="eda-empty-source-student"
                          >
                            Estudiante:
                            <strong>{{
                              sourceInfoForArea(headerAreaOf(row.id, page.id))
                                .student_name
                            }}</strong>
                          </p>
                          <button
                            type="button"
                            class="eda-empty-source-btn"
                            :disabled="
                              achievementSourceLoading[
                                headerAreaOf(row.id, page.id).slug
                              ]
                            "
                            @click.stop="
                              openAchievementSource(
                                headerAreaOf(row.id, page.id),
                                page
                              )
                            "
                          >
                            {{
                              sourceActionLabel(headerAreaOf(row.id, page.id))
                            }}
                          </button>
                        </template>
                      </div>
                    </div>
                    <h6 v-if="field.style === 4">
                      {{ field.text }}
                    </h6>
                    <h6
                      v-if="field.style === 5"
                      class="w-100"
                      :class="
                        row.fields.length === 2 &&
                        !row.fields[0].kind &&
                        row.fields[1].kind
                          ? 'text-left'
                          : 'text-center'
                      "
                    >
                      {{ field.text }}
                    </h6>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.STRING">
                  <label :for="field.key">{{ field.name }}</label>
                  <div class="text-input-row">
                    <b-form-input
                      type="text"
                      class="form-control text-input-control"
                      no-resize
                      :id="field.key"
                      @focus="blockInput(field.key)"
                      @blur="unblockInput(field.key)"
                      @keyup.enter="continueFromSection(field.key)"
                      :disabled="blockedInputs.includes(field.key)"
                      :formatter="
                        (text) => {
                          return getFormatter(field.max_length)(text);
                        }
                      "
                      v-model="field_values[field.key]"
                      :state="
                        field.is_required
                          ? field.max_length
                            ? field_values[field.key] &&
                              field_values[field.key].length <=
                                field.max_length &&
                              field_values[field.key].length > 0
                              ? null
                              : false
                            : field_values[field.key] &&
                              field_values[field.key].length > 0
                            ? null
                            : false
                          : null
                      "
                      data-toggle="popover"
                    />
                    <b-button
                      v-if="focusedQuestionKey === field.key"
                      class="text-input-ok"
                      @click.stop="continueFromSection(field.key)"
                    >
                      OK <v-icon name="chevron-right" class="ml-1" />
                    </b-button>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.BOOL" class="bool-field">
                  <label class="bool-label">{{ field.name }}</label>
                  <div class="bool-options">
                    <button
                      type="button"
                      class="bool-btn bool-btn-yes"
                      :class="{ 'bool-btn-active': isBoolYes(field.key) }"
                      @click.stop="onBoolSelect(field.key, true)"
                    >
                      Sí
                    </button>
                    <button
                      type="button"
                      class="bool-btn bool-btn-no"
                      :class="{ 'bool-btn-active': isBoolNo(field.key) }"
                      @click.stop="onBoolSelect(field.key, 'false')"
                    >
                      No
                    </button>
                  </div>
                </div>
                <div
                  v-if="field.kind === questionKinds.USER_CHECKBOX_ACHIEVEMENT"
                >
                  <div v-if="field.options.map((opt) => opt.level).filter(
                    (level, index, self) => self.indexOf(level) === index
                  ).length > 1">
                    <b-form-select v-model="field.level">
                      <b-form-select-option 
                        v-for="level in field.options.map((opt) => opt.level).filter(
                          (level, index, self) => self.indexOf(level) === index
                        )"
                        :key="level"
                        :value="level"
                      >
                        {{ level }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div v-if="field.titles.length">
                    <b-row>
                      <b-col>
                        <h3>
                          {{ field.name }}
                        </h3>
                      </b-col>
                    </b-row>
                    <div
                      class="uca-group"
                      v-for="
                      (title, tIndex) in field.titles.filter((title) =>
                        field.options.filter((opt) =>
                          title.options.includes(opt.id) && opt.level === field.level).length > 0)"
                        :key="tIndex + '-title'"
                    >
                      <b-row class="uca-group-row ach-group-row">
                        <b-col cols="12" class="uca-group-title">
                          <strong>{{ title.text}}</strong>
                        </b-col>
                        <b-col cols="12" class="ach-group-list">
                          <div
                            v-for="(option, oIndex) in field.options.filter(
                            (opt) => title.options.includes(opt.id) && opt.level === field.level).sort((a, b) => a.id - b.id)"
                            :key="oIndex + '-option'"
                            :id="'ach-row-' + field.key + '__' + option.id"
                            :class="[
                              'ach-row',
                              'ach-group-item',
                              {
                                'ach-row-focused':
                                  focusedAchievementRow ===
                                  field.key + '__' + option.id,
                              },
                            ]"
                          >
                            <div class="ach-info">
                              <div class="ach-desc">{{ option.text }}</div>
                            </div>
                            <div class="ach-actions">
                              <div class="ach-options">
                                <button
                                  v-for="(t, tIndex2) in field.table_titles"
                                  :key="t + tIndex2 + 'title'"
                                  type="button"
                                  class="ach-btn"
                                  :class="{
                                    'ach-btn-selected':
                                      field_values[field.key][option.id] ===
                                      tIndex2,
                                  }"
                                  @click="
                                    onAchievementSelect(
                                      field,
                                      option.id,
                                      tIndex2
                                    )
                                  "
                                >
                                  {{ t }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row v-if="showAddOption(field)" class="uca-add-row">
                        <b-col cols="4">
                          <b-form-input
                            v-model="addExtra[field.key+title.id]"
                            placeholder="Escribe aca si deseas añadir una nueva sugerencia"
                          />
                        </b-col>
                        <b-col cols="3">
                          <b-button
                            pill
                            variant="primary"
                            @click="addOption(field.key, field.options, field.level, title)"
                          >
                            Añadir +
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="!editing">
                      <b-row>
                        <b-col>
                          <h3>
                            {{ field.name }}
                          </h3>
                        </b-col>
                      </b-row>
                      <b-row
                        :id="'ach-row-' + field.key + '__' + opt.id"
                        :class="[
                          'uca-option-row',
                          'ach-row',
                          {
                            'ach-row-focused':
                              focusedAchievementRow ===
                              field.key + '__' + opt.id,
                          },
                        ]"
                        v-for="(opt, oIndex) in field.options.filter((opt) => opt.level===field.level)"
                        :key="oIndex + '-opt'"
                      >
                        <b-col cols="12" md="6" class="ach-info">
                          <div class="ach-desc">{{ opt.text }}</div>
                        </b-col>
                        <b-col cols="12" md="6" class="ach-actions">
                          <div class="ach-options">
                            <button
                              v-for="(title, tIndex) in field.table_titles"
                              :key="title + tIndex"
                              type="button"
                              class="ach-btn"
                              :class="{
                                'ach-btn-selected':
                                  field_values[field.key][opt.id] === tIndex,
                              }"
                              @click="
                                onAchievementSelect(field, opt.id, tIndex)
                              "
                            >
                              {{ title }}
                            </button>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row v-if="showAddOption(field)" class="uca-add-row">
                        <b-col cols="4">
                          <b-form-input
                            v-model="addExtra[field.key]"
                            placeholder="Escribe aca si deseas añadir una nueva sugerencia"
                          />
                        </b-col>
                        <b-col cols="3">
                          <b-button
                            pill
                            variant="primary"
                            @click="addOption(field.key, field.options, field.level)"
                          >
                            Añadir +
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <div v-else>
                      <b-row
                        v-for="(opt, oIndexDA) in field.options"
                        :key="oIndexDA + '-opt-d'"
                      >
                        <b-col cols="6">
                          {{ opt.text }}
                        </b-col>
                        <b-col cols="3" class="text-center" v-if="!opt.is_global">
                          <b-button
                            variant="danger"
                            pill
                            @click="deleteOption(opt.id, field.options, oIndexDA)"
                          >
                            Eliminar
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.USER_SELECTOR">
                  <b-row>
                    <b-col cols="12" md="6">
                      <h3>
                        {{ field.name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <!-- Single-use (chatbot) mode reuses the same select: it is
                       populated (by DynamicDocumentForm) with the logged-in user
                       only for the selector matching their chosen role; the
                       others stay empty. -->
                  <b-row>
                    <b-col cols="12" md="4">
                      <div @click.stop>
                        <b-select
                          v-model="field_values[field.key]"
                          @change="onSelectorChange(field.key)"
                        >
                          <b-select-option :value="''">
                            Seleccione opción
                          </b-select-option>
                          <b-select-option
                            v-for="(user, uIndex) in field.user_select_options"
                            :key="uIndex + '-us'"
                            :value="user.id"
                          >
                            {{ user.full_name }}
                          </b-select-option>
                        </b-select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="
                      field_values[field.key] &&
                      field.user_select_options.filter(
                        (obj) => obj.id === field_values[field.key]
                      ).length
                    "
                  >
                    <b-col>
                      Nombre:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['full_name']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col>
                      E-mail:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['email']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col>
                      RUT:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['rut']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col>
                      Registro Secreduc:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['secreduc']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col>
                      Rol:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['role']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col>
                      Teléfono:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['phone']
                        "
                        disabled
                      />
                    </b-col>
                    <b-col
                      v-if="
                        field.user_select_options.filter(
                          (obj) => obj.id === field_values[field.key]
                        )[0]['origin']
                      "
                    >
                      Procedencia:
                      <b-input
                        :value="
                          field.user_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0]['origin']
                        "
                        disabled
                      />
                    </b-col>
                  </b-row>
                </div>
                <div v-if="field.kind === questionKinds.SPECIAL_SELECTOR">
                  <b-row>
                    <b-col>
                      <h3>
                        {{ field.name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <div @click.stop>
                        <b-select
                          v-model="field_values[field.key]"
                          @change="onSelectorChange(field.key)"
                        >
                          <b-select-option :value="undefined">
                            Seleccione opción
                          </b-select-option>
                          <b-select-option
                            v-for="(
                              option, oIndex
                            ) in field.special_select_options"
                            :key="oIndex + '-ss'"
                            :value="option.id"
                          >
                            {{ option.data[field.special_select_fields[0]] }}
                          </b-select-option>
                        </b-select>
                      </div>
                    </b-col>
                    <b-col class="text-left">
                      <b-button
                        pill
                        variant="primary"
                        @click="openAddOption(field)"
                      >
                        <strong>+</strong>
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="
                      field_values[field.key] !== '' &&
                      field.special_select_options.filter(
                        (obj) => obj.id === field_values[field.key]
                      ).length
                    "
                  >
                    <b-col
                      v-for="(ssf, ssIndex) in field.special_select_fields"
                      :key="ssIndex + '-sss'"
                    >
                      {{ ssf }}:
                      <b-input
                        :value="
                          field.special_select_options.filter(
                            (obj) => obj.id === field_values[field.key]
                          )[0].data[ssf]
                        "
                        disabled
                      />
                    </b-col>
                  </b-row>
                </div>
                <!-- SPECIAL_MULTI_SELECTOR: register any number of custom
                     entries (sub-fields declared by the template) and tick
                     as many as apply. -->
                <div v-if="field.kind === questionKinds.SPECIAL_MULTI_SELECTOR">
                  <!-- same heading treatment as the USER_SELECTOR professionals
                       so both blocks read as one section -->
                  <b-row>
                    <b-col cols="12" md="6">
                      <h3>
                        {{ field.name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <div
                    v-if="!field.special_select_options.length"
                    class="text-muted mb-2"
                  >
                    Aún no hay registros. Use "Agregar" para crear uno.
                  </div>
                  <b-form-checkbox
                    v-for="(option, oIndex) in field.special_select_options"
                    :key="oIndex + '-sms'"
                    :checked="isMultiSelected(field.key, option.id)"
                    @change="onMultiSelectToggle(field.key, option.id)"
                    class="my-1"
                  >
                    {{ multiOptionLabel(field, option) }}
                  </b-form-checkbox>
                  <b-button
                    pill
                    size="sm"
                    variant="outline-primary"
                    class="mt-2"
                    @click="openAddOption(field)"
                  >
                    <strong>+</strong> Agregar
                  </b-button>
                  <!-- Multi-pick: never auto-advance on toggle (the user may
                       tick several), so the guided flow needs an explicit
                       "Continuar" like the other multi-answer kinds. -->
                  <b-button
                    v-if="focusedQuestionKey === field.key"
                    class="suggestions-continue-btn"
                    @click.stop="continueFromSection(field.key)"
                  >
                    Continuar
                    <v-icon name="chevron-right" class="ml-1" />
                  </b-button>
                </div>
                <div v-if="field.kind === questionKinds.OA_FIELD">
                  <b-row>
                    <b-col>
                      <h3>
                        {{ field.name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table-simple borderless class="responsive-card-table">
                        <b-thead>
                          <b-tr>
                            <b-th> Asignatura </b-th>
                            <b-th> Obj. </b-th>
                            <b-th> Utilizar </b-th>
                            <b-th v-if="field.oas_options.length">
                              Criterios a considerar
                            </b-th>
                            <b-th>{{
                              field.oas_options.length
                                ? "Objetivo adecuado"
                                : "Habilidades Implicadas"
                            }}</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr
                            v-for="(oa, oIndex) in field.oas"
                            :key="oIndex + '-oa'"
                            style="border-bottom: 2px solid #bb8800"
                          >
                            <b-td data-label="Asignatura">
                              {{ oa.subject }}
                            </b-td>
                            <b-td style="width: 400px" data-label="Objetivo">
                              <strong>{{ oa.name }} </strong>
                              <img
                                :src="starIcon"
                                v-if="oa.priority === 1"
                                width="22px"
                              />
                              <br />
                              {{ oa.description }}
                            </b-td>
                            <b-td @click="setOA(oa.id)" data-label="Utilizar">
                              <b-checkbox
                                v-if="field_values[field.key]"
                                v-model="field_values[field.key]['oas']"
                                :value="oa.id"
                                size="lg"
                                @input="updateOas(field.key, oa.id)"
                              />
                            </b-td>
                            <b-td v-if="field.oas_options.length" data-label="Criterios a considerar">
                              <div
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    oa.id
                                  ) &&
                                  field_values[field.key]['values'][oa.id]
                                "
                              >
                                <b-form-checkbox
                                  v-for="(
                                    option, oaOptIndex
                                  ) in field.oas_options"
                                  :key="oaOptIndex + '-oaOpt'"
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criteria'
                                    ]
                                  "
                                  @change="updateInput(field.key)"
                                  :value="oaOptIndex"
                                  >{{ option }}</b-form-checkbox
                                >
                              </div>
                              <div v-else>
                                <b-form-checkbox
                                  disabled
                                  v-for="(
                                    option, oaOptIndex
                                  ) in field.oas_options"
                                  :key="oaOptIndex + '-oaOpt'"
                                  >{{ option }}</b-form-checkbox
                                >
                              </div>
                            </b-td>
                            <b-td :data-label="field.oas_options.length ? 'Objetivo adecuado' : 'Habilidades Implicadas'">
                              <b-textarea
                                class="auto-grow-textarea"
                                rows="4"
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    oa.id
                                  ) &&
                                  field_values[field.key]['values'][oa.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][oa.id][
                                    'target'
                                  ]
                                "
                                @input="autoGrowTextarea($event)"
                                @blur="updateInput(field.key)"
                              />
                            </b-td>
                          </b-tr>
                          <b-tr
                            v-for="(exOA, exoIndex) in field.extra_oas"
                            :key="exoIndex + '-exoa'"
                            style="border-bottom: 2px solid #bb8800"
                          >
                            <b-td
                              data-label="Asignatura"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                            >
                              {{ exOA.subject }}
                            </b-td>
                            <b-td
                              style="width: 400px"
                              data-label="Objetivo"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                            >
                              <strong>{{ exOA.name }} </strong>
                              <img
                                :src="starIcon"
                                v-if="exOA.priority === 1"
                                width="22px"
                              />
                              <br />
                              {{ exOA.description }}
                            </b-td>
                            <b-td
                              data-label="Utilizar"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                              @click="setOA(exOA.id)"
                            >
                              <b-checkbox
                                v-if="field_values[field.key]"
                                v-model="field_values[field.key]['oas']"
                                :value="exOA.id"
                                size="lg"
                                @input="updateOas(field.key, exOA.id)"
                              />
                            </b-td>
                            <b-td
                              data-label="Criterios a considerar"
                              v-if="
                                field_values[field.key]['oas'].includes(
                                  exOA.id
                                ) && field.oas_options.length
                              "
                            >
                              <div
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                              >
                                <b-form-checkbox
                                  v-for="(
                                    option, oaOptIndex
                                  ) in field.oas_options"
                                  :key="oaOptIndex + '-oaOpt'"
                                  v-model="
                                    field_values[field.key]['values'][exOA.id][
                                      'criteria'
                                    ]
                                  "
                                  @change="updateInput(field.key)"
                                  :value="oaOptIndex"
                                  >{{ option }}</b-form-checkbox
                                >
                              </div>
                              <div v-else>
                                <b-form-checkbox
                                  disabled
                                  v-for="(
                                    option, oaOptIndex
                                  ) in field.oas_options"
                                  :key="oaOptIndex + '-oaOpt'"
                                  >{{ option }}</b-form-checkbox
                                >
                              </div>
                            </b-td>
                            <b-td
                              :data-label="field.oas_options.length ? 'Objetivo adecuado' : 'Habilidades Implicadas'"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                            >
                              <b-textarea
                                class="auto-grow-textarea"
                                rows="4"
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'target'
                                  ]
                                "
                                @input="autoGrowTextarea($event)"
                                @blur="updateInput(field.key)"
                              />
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-button
                      variant="primary"
                      pill
                      @click="openExtraOAs(field.extra_oas, field.key)"
                    >
                      Añadir OAs de otras asignaturas
                    </b-button>
                  </b-row>
                </div>
                <div v-if="field.kind === questionKinds.CUSTOM_CHECKBOX">
                  <b-row>
                    <strong>{{ field.name }}</strong>
                  </b-row>
                  <b-row>
                    <b-col v-if="!editing">
                      <strong
                        class="text-danger"
                        v-if="
                          field.is_required &&
                          !Boolean(
                            field_values[field.key] &&
                              field_values[field.key].length
                          )
                        "
                      >
                        Seleccione al menos una opción
                      </strong>
                      <!-- Multi-select option buttons (same look as the
                           CUSTOM_RADIO ones); clicking toggles selection. The
                           list scrolls within itself (max 50vh) so the add /
                           continue controls below stay reachable. -->
                      <div class="cr-scroll">
                        <div
                          class="cr-options"
                          :class="{
                            'cr-options--cols': !field.size || field.size >= 12,
                          }"
                        >
                          <button
                            v-for="option in visibleCheckboxOptions(field)"
                            :key="option.id"
                            type="button"
                            class="cr-option"
                            :class="{
                              'cr-option-selected':
                                isCheckboxOptionSelected(field, option),
                            }"
                            @click="toggleCheckboxOption(field.key, option.id)"
                          >
                            <v-icon
                              v-if="isCheckboxOptionSelected(field, option)"
                              name="check-circle"
                              class="cr-option-check"
                            />
                            <span>{{ option.text }}</span>
                          </button>
                        </div>
                      </div>
                    </b-col>
                    <b-col v-else>
                      <ul>
                        <li
                          v-for="(
                            option, oIndexDC
                          ) in field.custom_checkbox_options"
                          :key="oIndexDC + '-DC'"
                          @change="updateInput(field.key)"
                        >
                          {{ option.text }}
                          <b-button
                            @click="
                              deleteOption(
                                option.id,
                                field.custom_checkbox_options,
                                oIndexDC
                              )
                            "
                            v-if="!option.is_global"
                            variant="danger"
                            size="sm"
                            pill
                          >
                            <v-icon name="times" />
                          </b-button>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <!-- Footer (outside the scroll): add-suggestion + continue. -->
                  <div
                    v-if="showAddOption(field) || focusedQuestionKey === field.key"
                    class="cr-footer"
                  >
                    <div class="cr-footer-add">
                      <b-button
                        v-if="showAddOption(field) && !addOptionRevealed[field.key]"
                        class="cr-add-toggle"
                        pill
                        @click.stop="$set(addOptionRevealed, field.key, true)"
                      >
                        <v-icon name="plus" class="mr-1" /> Añadir sugerencia
                      </b-button>
                      <div
                        v-else-if="showAddOption(field)"
                        class="cr-add-input"
                      >
                        <b-input
                          placeholder="Escribe la nueva sugerencia"
                          type="text"
                          size="sm"
                          :formatter="
                            (text) => {
                              return getFormatter(field.max_length)(text);
                            }
                          "
                          v-model="addCheckboxOption[field.key]"
                        />
                        <b-button
                          class="cr-add-confirm"
                          pill
                          @click.stop="
                            addCheckOption(
                              field.key,
                              field.custom_checkbox_options
                            )
                          "
                        >
                          <v-icon name="plus" />
                        </b-button>
                        <small
                          v-if="field.max_length"
                          class="cr-add-hint"
                        >
                          Máximo {{ field.max_length }} caracteres
                        </small>
                      </div>
                    </div>
                    <b-button
                      v-if="focusedQuestionKey === field.key"
                      class="suggestions-continue-btn"
                      @click.stop="continueFromSection(field.key)"
                    >
                      Continuar
                      <v-icon name="chevron-right" class="ml-1" />
                    </b-button>
                  </div>
                </div>
                <div
                  v-if="
                    field.kind === questionKinds.CHECKBOX_ACHIEVEMENT &&
                    field.checkbox_achievement_options.length
                  "
                >
                  <b-row>
                    <b-col>
                      <h3>{{ field.name }}</h3>
                    </b-col>
                  </b-row>
                  <b-row
                    :id="'ach-row-' + field.key + '__' + opt.id"
                    :class="[
                      'uca-option-row',
                      'ach-row',
                      {
                        'ach-row-focused':
                          focusedAchievementRow === field.key + '__' + opt.id,
                      },
                    ]"
                    v-for="(opt, oIndex) in field.checkbox_achievement_options"
                    :key="oIndex + '-opt'"
                  >
                    <b-col cols="12" md="6" class="ach-info">
                      <div class="ach-desc">
                        {{ opt.checkbox_option }}
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="ach-actions">
                      <div class="ach-options">
                        <button
                          v-for="(title, tIndex) in field.table_titles"
                          :key="title + tIndex"
                          type="button"
                          class="ach-btn"
                          :class="{
                            'ach-btn-selected':
                              field_values[field.key][opt.id] === tIndex,
                          }"
                          @click="onAchievementSelect(field, opt.id, tIndex)"
                        >
                          {{ title }}
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div
                  v-if="
                    field.kind === questionKinds.OA_ACHIEVEMENT &&
                    field.oa_achievement_options.length
                  "
                >
                  <b-row>
                    <h3>
                      {{ field.name }}
                    </h3>
                  </b-row>
                  <b-row
                    :id="'ach-row-' + field.key + '__' + opt.id"
                    :class="[
                      'uca-option-row',
                      'ach-row',
                      {
                        'ach-row-focused':
                          focusedAchievementRow === field.key + '__' + opt.id,
                      },
                    ]"
                    v-for="(opt, oIndex) in field.oa_achievement_options"
                    :key="oIndex + '-opt'"
                  >
                    <b-col cols="12" md="6" class="ach-info">
                      <div class="ach-badges">
                        <b-badge
                          v-if="opt.oa_filter_response.oa.subject"
                          class="ach-badge ach-badge-subject"
                        >
                          {{ opt.oa_filter_response.oa.subject }}
                        </b-badge>
                        <b-badge
                          v-if="opt.oa_filter_response.oa.name"
                          class="ach-badge ach-badge-name"
                        >
                          {{ opt.oa_filter_response.oa.name }}
                        </b-badge>
                      </div>
                      <div class="ach-desc">
                        {{ opt.oa_filter_response.oa.description }}
                      </div>
                      <div
                        v-if="opt.oa_filter_response.target"
                        class="ach-target"
                      >
                        <span class="ach-target-label">
                          {{
                            field.key.startsWith("SPECIALMARK_")
                              ? "Adecuación Curricular:"
                              : "Habilidades:"
                          }}
                        </span>
                        {{ opt.oa_filter_response.target }}
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="ach-actions">
                      <div class="ach-options">
                        <button
                          v-for="(level, lvIndex) in oaAchievementLevels"
                          :key="lvIndex"
                          type="button"
                          class="ach-btn"
                          :class="[
                            level.cls,
                            {
                              'ach-btn-selected':
                                field_values[field.key][opt.id] === lvIndex,
                            },
                          ]"
                          @click="onAchievementSelect(field, opt.id, lvIndex)"
                        >
                          {{ level.label }}
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div
                  v-if="field.kind === questionKinds.CUSTOM_RADIO"
                  class="cr-card"
                >
                  <div class="cr-title">
                    <span class="cr-title-bar"></span>
                    <span class="cr-title-text">{{ field.name }}</span>
                  </div>
                  <strong
                    class="text-danger cr-required"
                    v-if="field.is_required && !field_values[field.key]"
                  >
                    Seleccione una opción
                  </strong>
                  <!-- Admin editing: list with per-option delete (template
                       authoring). -->
                  <ul v-if="editing">
                    <li
                      v-for="(
                        option, oIndexDR
                      ) in field.custom_checkbox_options"
                      :key="oIndexDR + '-DR'"
                    >
                      {{ option.text }}
                      <b-button
                        @click="
                          deleteOption(
                            option.id,
                            field.custom_checkbox_options,
                            oIndexDR
                          )
                        "
                        v-if="!option.is_global"
                        variant="danger"
                        size="sm"
                        pill
                      >
                        <v-icon name="times" />
                      </b-button>
                    </li>
                  </ul>
                  <!-- Filling: clickable option buttons; selecting one
                       collapses the rest (toggle re-reveals them). A full-row
                       field (size 12) shows two per row; a narrower field
                       (e.g. half row) lists them one per row. -->
                  <div v-else class="cr-scroll">
                    <div
                      class="cr-options"
                      :class="{
                        'cr-options--cols': !field.size || field.size >= 12,
                      }"
                    >
                      <template
                        v-for="option in field.custom_checkbox_options"
                      >
                        <button
                          type="button"
                          :key="option.id"
                          v-if="
                            !field_values[field.key] ||
                            radioExpanded[field.key] ||
                            field_values[field.key] === option.id
                          "
                          class="cr-option"
                          :class="{
                            'cr-option-selected':
                              field_values[field.key] === option.id,
                          }"
                          @click.stop="selectRadioOption(field.key, option.id)"
                        >
                          <v-icon
                            v-if="field_values[field.key] === option.id"
                            name="check-circle"
                            class="cr-option-check"
                          />
                          <span>{{ option.text }}</span>
                        </button>
                      </template>
                    </div>
                  </div>
                  <button
                    type="button"
                    v-if="!editing && field_values[field.key]"
                    class="cr-toggle"
                    @click="toggleRadioOptions(field.key)"
                  >
                    {{
                      radioExpanded[field.key]
                        ? "Ocultar las demás opciones"
                        : "Ver otras opciones"
                    }}
                  </button>
                  <!-- Add a custom option (persisted in the normal modal,
                       kept local in the chatbot). Shown only while the field is
                       focused; the input appears after clicking the button. -->
                  <div v-if="showAddOption(field)" class="cr-footer-add mt-2">
                    <b-button
                      v-if="!addOptionRevealed[field.key]"
                      class="cr-add-toggle"
                      pill
                      @click.stop="$set(addOptionRevealed, field.key, true)"
                    >
                      <v-icon name="plus" class="mr-1" /> Añadir sugerencia
                    </b-button>
                    <div v-else class="cr-add-input">
                      <b-input
                        placeholder="Escribe la nueva sugerencia"
                        type="text"
                        size="sm"
                        :formatter="
                          (text) => {
                            return getFormatter(field.max_length)(text);
                          }
                        "
                        v-model="addCheckboxOption[field.key]"
                      />
                      <b-button
                        class="cr-add-confirm"
                        pill
                        @click.stop="
                          addCheckOption(
                            field.key,
                            field.custom_checkbox_options
                          )
                        "
                      >
                        <v-icon name="plus" />
                      </b-button>
                      <small v-if="field.max_length" class="cr-add-hint">
                        Máximo {{ field.max_length }} caracteres
                      </small>
                    </div>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.TEXT">
                  <label :for="field.key">{{ field.name }}</label>
                  <b-form-textarea
                    class="form-control auto-grow-textarea"
                    size="sm"
                    rows="3"
                    :id="field.key"
                    @focus="blockInput(field.key)"
                    @blur="unblockInput(field.key)"
                    @input="autoGrowTextarea($event)"
                    :disabled="blockedInputs.includes(field.key)"
                    :formatter="
                      (text) => {
                        return getFormatter(field.max_length)(text);
                      }
                    "
                    v-model="field_values[field.key]"
                    :state="
                      field.is_required
                        ? field.max_length
                          ? field_values[field.key] &&
                            field_values[field.key].length <=
                              field.max_length &&
                            field_values[field.key].length > 0
                            ? null
                            : false
                          : field_values[field.key] &&
                            field_values[field.key].length > 0
                          ? null
                          : false
                        : null
                    "
                  />
                </div>
                <div v-if="field.kind === questionKinds.TEXT_OPTIONS">
                  <div class="cr-title">
                    <span class="cr-title-bar"></span>
                    <span class="cr-title-text">{{ field.name }}</span>
                  </div>
                  <b-form-textarea
                    v-if="revealedTextInput[field.key] || !canPickTextOption(field)"
                    class="form-control"
                    size="sm"
                    rows="4"
                    :id="field.key"
                    @focus="showTextOptionsSuggestions(field.key)"
                    @blur="(e) => hideTextOptionsSuggestions(field.key, e)"
                    :disabled="blockedInputs.includes(field.key)"
                    :formatter="
                      (text) => {
                        return getFormatter(field.max_length)(text);
                      }
                    "
                    v-model="field_values[field.key]"
                    :state="
                      field.is_required
                        ? field.max_length
                          ? field_values[field.key] &&
                            field_values[field.key].length <=
                              field.max_length &&
                            field_values[field.key].length > 0
                            ? null
                            : false
                          : field_values[field.key] &&
                            field_values[field.key].length > 0
                          ? null
                          : false
                        : null
                    "
                  />
                  <div
                    v-if="revealedTextInput[field.key]"
                    class="mt-2 mb-2 d-flex align-items-center"
                    style="gap: 20px;"
                  >
                    <a
                      href="#"
                      class="view-suggestions-link"
                      @click.prevent="toggleTextOptionsSuggestions(field.key)"
                    >
                      <v-icon name="pen" class="mr-1" />
                      Ver sugerencias
                    </a>
                    <!-- Without related keys the AI's only context is what the
                         user already wrote, so it is offered once there is text. -->
                    <a
                      v-if="canUseTextOptionAI(field)"
                      href="#"
                      class="view-suggestions-link"
                      @click.prevent="generateTextOptionsAI(field.key)"
                      :class="{ 'disabled': textOptionsAILoading[field.key] }"
                    >
                      <span v-if="textOptionsAILoading[field.key]">
                        <b-spinner small class="mr-1" />
                      </span>
                      <span v-else>🤖</span>
                      Generar con IA
                    </a>
                  </div>
                  <div
                    v-if="
                      focusedTextOptionsFields[field.key] ||
                      !revealedTextInput[field.key]
                    "
                    class="text-options-suggestions mt-2"
                    :ref="'textOptionsSuggestions_' + field.key"
                  >
                  <!-- Canned suggestions seed an empty field; AI suggestions
                       rework what is already written. Whichever does not apply
                       is simply not offered - no explanatory notice, it read as
                       an error to users. -->
                  <div
                    v-if="aiGeneratedOptions[field.key] && canUseTextOptionAI(field)"
                    class="mt-3"
                  >
                    <div class="suggestions-label mb-2">
                      <small class="text-muted">
                        Opciones generadas con IA
                        <span v-if="!hasRelatedKeys(field)">
                          (reemplazan el texto actual)
                        </span>:
                      </small>
                    </div>
                    <div
                      class="suggestions-list-vertical"
                      :class="{
                        'suggestions-list-vertical--cols':
                          !field.size || field.size >= 12,
                      }"
                    >
                      <b-button
                        v-if="aiGeneratedOptions[field.key].brief"
                        variant="unknown"
                        size="sm"
                        class="mb-2 suggestion-button suggestion-button-vertical"
                        block
                        @mousedown.prevent="applyTextOptionAI(field, aiGeneratedOptions[field.key].brief)"
                      >
                        Breve: {{ aiGeneratedOptions[field.key].brief }}
                      </b-button>
                      <b-button
                        v-if="aiGeneratedOptions[field.key].medium"
                        variant="unknown"
                        size="sm"
                        class="mb-2 suggestion-button suggestion-button-vertical"
                        block
                        @mousedown.prevent="applyTextOptionAI(field, aiGeneratedOptions[field.key].medium)"
                      >
                        Media: {{ aiGeneratedOptions[field.key].medium }}
                      </b-button>
                      <b-button
                        v-if="aiGeneratedOptions[field.key].detailed"
                        variant="unknown"
                        size="sm"
                        class="mb-2 suggestion-button suggestion-button-vertical"
                        block
                        @mousedown.prevent="applyTextOptionAI(field, aiGeneratedOptions[field.key].detailed)"
                      >
                        Detallada: {{ aiGeneratedOptions[field.key].detailed }}
                      </b-button>
                    </div>
                  </div>
                    <div v-if="field.custom_checkbox_options && field.custom_checkbox_options.length > 0 && canPickTextOption(field)">
                      <div class="suggestions-label mb-2">
                        <small class="text-muted">Sugerencias:</small>
                      </div>
                      <div
                        class="suggestions-list-vertical"
                        :class="{
                          'suggestions-list-vertical--cols':
                            !field.size || field.size >= 12,
                        }"
                      >
                        <b-button
                          v-for="option in field.custom_checkbox_options"
                          :key="option.id"
                          variant="unknown"
                          size="sm"
                          class="mb-2 suggestion-button suggestion-button-vertical"
                          block
                          @mousedown.prevent="addTextOption(field.key, option.text, field.custom_checkbox_options)"
                        >
                          {{ option.text }}
                        </b-button>
                      </div>
                    </div>
                    <!-- Footer (sticky): add-suggestion on the left, continue on
                         the right. The new-option input is hidden until the
                         "Añadir sugerencia" button is clicked. -->
                    <div class="suggestions-footer suggestions-footer--split">
                      <div class="cr-footer-add">
                        <b-button
                          v-if="!addOptionRevealed[field.key]"
                          class="cr-add-toggle"
                          pill
                          @click.stop="$set(addOptionRevealed, field.key, true)"
                        >
                          <v-icon name="plus" class="mr-1" /> Añadir sugerencia
                        </b-button>
                        <div v-else class="cr-add-input">
                          <b-input
                            placeholder="Escribe la nueva sugerencia"
                            type="text"
                            size="sm"
                            :formatter="
                              (text) => {
                                return getFormatter(field.max_length)(text);
                              }
                            "
                            v-model="addCheckboxOption[field.key]"
                          />
                          <b-button
                            class="cr-add-confirm"
                            pill
                            @click.stop="
                              addCheckOption(
                                field.key,
                                field.custom_checkbox_options
                              )
                            "
                          >
                            <v-icon name="plus" />
                          </b-button>
                          <small v-if="field.max_length" class="cr-add-hint">
                            Máximo {{ field.max_length }} caracteres
                          </small>
                        </div>
                      </div>
                      <b-button
                        class="suggestions-continue-btn"
                        @click.stop="continueFromSection(field.key)"
                      >
                        Continuar
                        <v-icon name="chevron-right" class="ml-1" />
                      </b-button>
                    </div>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.TEXT_EJES_ACHIEVEMENT">
                  <div class="cr-title">
                    <span class="cr-title-bar"></span>
                    <span class="cr-title-text">{{ field.name }}</span>
                  </div>
                  <b-form-textarea
                    v-if="revealedTextInput[field.key]"
                    class="form-control auto-grow-textarea"
                    size="sm"
                    rows="4"
                    :id="field.key"
                    @focus="showEjesAchievementSuggestions(field.key)"
                    @blur="(e) => hideEjesAchievementSuggestions(field.key, e)"
                    @input="autoGrowTextarea($event)"
                    :disabled="blockedInputs.includes(field.key)"
                    :formatter="
                      (text) => {
                        return getFormatter(field.max_length)(text);
                      }
                    "
                    v-model="field_values[field.key]"
                    :state="
                      field.is_required
                        ? field.max_length
                          ? field_values[field.key] &&
                            field_values[field.key].length <=
                              field.max_length &&
                            field_values[field.key].length > 0
                            ? null
                            : false
                          : field_values[field.key] &&
                            field_values[field.key].length > 0
                          ? null
                          : false
                        : null
                    "
                  />
                  <div
                    v-if="revealedTextInput[field.key]"
                    class="mt-2 mb-2 d-flex align-items-center"
                    style="gap: 20px;"
                  >
                    <a
                      href="#"
                      class="view-suggestions-link"
                      @click.prevent="toggleEjesAchievementSuggestions(field.key)"
                    >
                      <v-icon name="pen" class="mr-1" />
                      Ver rúbrica por ejes
                    </a>
                  <!-- <a
                    href="#"
                    class="view-suggestions-link text-danger"
                    @click.prevent="clearEjesAchievements(field.key, field)"
                  >
                    <v-icon name="trash" class="mr-1" />
                    Reiniciar logros
                  </a> -->
                    <!-- <a
                      href="#"
                      class="view-suggestions-link"
                      @click.prevent="generateEjesAchievementAI(field.key)"
                      :class="{ 'disabled': ejesAchievementAILoading[field.key] }"
                    >
                      <span v-if="ejesAchievementAILoading[field.key]">
                        <b-spinner small class="mr-1" />
                      </span>
                      <span v-else>🤖</span>
                      Generar con IA
                    </a> -->
                  </div>
                  <div
                    v-if="
                      focusedEjesAchievementFields[field.key] ||
                      !revealedTextInput[field.key]
                    "
                    class="text-options-suggestions ejes-rubric mt-2"
                    :ref="'ejesAchievementSuggestions_' + field.key"
                  >
                    <b-row class="mb-3 ejes-rubric-header">
                      <b-col>
                        <h5>Rúbrica por ejes de {{ getSubareasText(field) }}</h5>
                        <small class="text-muted">
                          Marque logros (L), en proceso (P) o necesita mejorar (N) en cada eje. Las opciones usadas se eliminarán.
                        </small>
                      </b-col>
                      <b-col cols="auto">
                        <b-form-select v-model="ejesLevel[field.key]" size="sm" @change="resetSubareaFilter(field.key)">
                          <b-form-select-option v-for="level in [...new Set(field.ejes.map(e => e.level))]" :key="level" :value="level">
                            {{ levels.find(l => l[0] === level)[1] }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-col>
                      <b-col cols="auto">
                        <b-form-select v-model="ejesSubarea[field.key]" size="sm">
                          <b-form-select-option :value="null">Todas las subáreas</b-form-select-option>
                          <b-form-select-option v-for="subarea in getAvailableSubareas(field)" :key="subarea" :value="subarea">
                            {{ subarea }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <transition-group
                      tag="div"
                      name="eje-fade"
                      class="row mt-3"
                    >
                      <b-col
                        v-for="eje in getVisibleEjes(field)"
                        :key="getEjeKey(eje)"
                        cols="12"
                        md="6"
                        lg="4"
                        class="mb-3"
                      >
                        <b-card class="h-100 eje-card">
                          <b-card-title class="mb-3">
                            <strong>{{ eje.name }}</strong>
                          </b-card-title>
                          <div v-if="(eje.oas && eje.oas.length > 0) || (eje.user_test_tags && eje.user_test_tags.length > 0)" class="mb-3">
                            <transition-group name="oa-fade" tag="div">
                              <div
                                v-for="oa in visibleOas(field, eje)"
                                :key="oa.id"
                                class="oa-item mb-2 d-flex align-items-center justify-content-between"
                                :class="{
                                  'eje-hint-row': isEjesHintTarget(field, eje, oa),
                                  'oa-item-focused': isFirstUnansweredOa(field, eje, oa),
                                }"
                              >
                                <span class="oa-text flex-grow-1 mr-2">{{ oa.name || oa.description }}</span>
                                <div class="achievement-selector d-flex">
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-l"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'L')"
                                  >
                                    L
                                  </button>
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-p"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'P')"
                                  >
                                    P
                                  </button>
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-n"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'N')"
                                  >
                                    N
                                  </button>
                                </div>
                              </div>
                            </transition-group>
                            <transition-group name="oa-fade" tag="div">
                              <div
                                v-for="oa in visibleUserTags(field, eje)"
                                :key="oa.id"
                                class="oa-item mb-2 d-flex align-items-center justify-content-between"
                                :class="{
                                  'eje-hint-row': isEjesHintTarget(field, eje, oa),
                                  'oa-item-focused': isFirstUnansweredOa(field, eje, oa),
                                }"
                              >
                                <span class="oa-text flex-grow-1 mr-2">{{ oa.name }}</span>
                                <div class="achievement-selector d-flex">
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-l"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'L')"
                                  >
                                    L
                                  </button>
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-p"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'P')"
                                  >
                                    P
                                  </button>
                                  <button
                                    type="button"
                                    class="achievement-btn achievement-n"
                                    @click="setAchievement(field.key, getEjeKey(eje), oa.id, 'N')"
                                  >
                                    N
                                  </button>
                                </div>
                              </div>
                            </transition-group>
                          </div>
                          <div v-else class="mb-3 text-muted">
                            <small>No hay objetivos de aprendizaje disponibles</small>
                          </div>
                          <div
                            v-if="showAddOption(field)"
                            class="add-option-section mt-3 pt-3 border-top"
                          >
                            <b-row class="align-items-center">
                              <b-col cols="10" class="px-2">
                                <b-input
                                  :value="getAddEjeOptionValue(field.key, eje)"
                                  @input="setAddEjeOptionValue(field.key, eje, $event)"
                                  placeholder="Añadir ítem..."
                                  size="sm"
                                />
                              </b-col>
                              <b-col cols="2" class="px-2 text-center">
                                <button
                                  type="button"
                                  class="add-option-btn"
                                  @click="addUserTestTag(getAddEjeOptionValue(field.key, eje), eje, field.key)"
                                >
                                  +
                                </button>
                              </b-col>
                            </b-row>
                          </div>
                        </b-card>
                      </b-col>
                    </transition-group>
                    <div class="suggestions-footer">
                      <b-button
                        class="suggestions-continue-btn"
                        @click.stop="continueFromSection(field.key)"
                      >
                        Continuar
                        <v-icon name="chevron-right" class="ml-1" />
                      </b-button>
                    </div>
                  </div>
                </div>
                <div v-if="field.kind === questionKinds.OA_PROGRESSION">
                  <b-row>
                    <b-col>
                      <h3>
                        {{ field.name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <!-- FROM HERE -->
                  <b-row>
                    <b-col>
                      <b-table-simple borderless class="oa-progression-table responsive-card-table">
                        <b-thead>
                          <b-tr>
                            <b-th> Objetivo </b-th>
                            <b-th> Usar </b-th>
                            <b-th> Criterios </b-th>
                            <b-th> Tipo </b-th>
                            <b-th> Adecuación manual / IA </b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr
                            v-for="(oa, oIndex) in field.oas"
                            :key="oIndex + '-oa'"
                            style="border-bottom: 2px solid #bb8800"
                          >
                            <b-td
                              style="width: 280px"
                              data-label="Objetivo"
                              :style="
                                oa.id in field_values[field.key]['values'] &&
                                'criPro' in
                                  field_values[field.key]['values'][oa.id] &&
                                field_values[field.key]['values'][oa.id][
                                  'criPro'
                                ].includes(4)
                                  ? 'text-decoration: line-through; text-decoration-color: red'
                                  : ''
                              "
                            >
                              <span class="oa-subject-chip" v-if="oa.subject">{{
                                oa.subject
                              }}</span>
                              <div class="oa-name-line">
                                <strong>{{ oa.name }}</strong>
                                <img
                                  :src="starIcon"
                                  v-if="oa.priority === 1"
                                  width="22px"
                                />
                              </div>
                              {{ oa.description }}
                            </b-td>
                            <b-td @click="setOA(oa.id)" data-label="Usar">
                              <b-checkbox
                                v-if="field_values[field.key]"
                                v-model="field_values[field.key]['oas']"
                                :value="oa.id"
                                size="lg"
                                @input="updateOas(field.key, oa.id)"
                              />
                            </b-td>
                            <b-td @click="setOA(oa.id)" style="width: 100px" data-label="Criterios">
                              <div @click="setCheck(0)">
                                <b-checkbox
                                  v-if="
                                    field_values[field.key] &&
                                    field_values[field.key]['oas'].includes(
                                      oa.id
                                    ) &&
                                    field_values[field.key]['values'][oa.id]
                                  "
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criPro'
                                    ]
                                  "
                                  :value="0"
                                  @input="
                                    check === 0 ? updateInput(field.key) : ''
                                  "
                                >
                                  Graduación del nivel de complejidad
                                </b-checkbox>
                              </div>
                              <div @click="setCheck(1)">
                                <b-checkbox
                                  v-if="
                                    field_values[field.key] &&
                                    field_values[field.key]['oas'].includes(
                                      oa.id
                                    ) &&
                                    field_values[field.key]['values'][oa.id]
                                  "
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criPro'
                                    ]
                                  "
                                  :value="1"
                                  @input="
                                    check === 1 ? updateInput(field.key) : ''
                                  "
                                >
                                  Priorización
                                </b-checkbox>
                              </div>
                              <div @click="setCheck(2)">
                                <b-checkbox
                                  v-if="
                                    field_values[field.key] &&
                                    field_values[field.key]['oas'].includes(
                                      oa.id
                                    ) &&
                                    field_values[field.key]['values'][oa.id]
                                  "
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criPro'
                                    ]
                                  "
                                  :value="2"
                                  @input="
                                    check === 2 ? updateInput(field.key) : ''
                                  "
                                >
                                  Temporalización
                                </b-checkbox>
                              </div>
                              <div @click="setCheck(3)">
                                <b-checkbox
                                  v-if="
                                    field_values[field.key] &&
                                    field_values[field.key]['oas'].includes(
                                      oa.id
                                    ) &&
                                    field_values[field.key]['values'][oa.id]
                                  "
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criPro'
                                    ]
                                  "
                                  :value="3"
                                  @input="
                                    check === 3 ? updateInput(field.key) : ''
                                  "
                                >
                                  Enriquecimiento del curriculum
                                </b-checkbox>
                              </div>
                              <div @click="setCheck(4)">
                                <b-checkbox
                                  v-if="
                                    field_values[field.key] &&
                                    field_values[field.key]['oas'].includes(
                                      oa.id
                                    ) &&
                                    field_values[field.key]['values'][oa.id]
                                  "
                                  v-model="
                                    field_values[field.key]['values'][oa.id][
                                      'criPro'
                                    ]
                                  "
                                  :value="4"
                                  @input="
                                    check === 4 ? updateInput(field.key) : ''
                                  "
                                >
                                  Eliminación del aprendizaje
                                </b-checkbox>
                              </div>
                            </b-td>
                            <b-td data-label="Tipo">
                              <div
                                v-if="field_values[field.key] && field_values[field.key]['values'][oa.id]"
                                class="tipo-button-group"
                              >
                                <button
                                  type="button"
                                  :class="['tipo-button', {
                                    selected: progMode(field.key, oa.id) === 'manual',
                                    'pulse-attention': !progMode(field.key, oa.id),
                                  }]"
                                  @click="setMode(field.key, oa.id, 'manual')"
                                >
                                  Manual / IA
                                </button>
                                <button
                                  type="button"
                                  :class="['tipo-button', {
                                    selected: progMode(field.key, oa.id) === 'select',
                                    'pulse-attention': !progMode(field.key, oa.id),
                                  }]"
                                  @click="setMode(field.key, oa.id, 'select')"
                                >
                                  Progresión MINEDUC
                                </button>
                              </div>
                            </b-td>
                            <b-td data-label="Adecuación manual / IA" v-if="field_values[field.key] && field_values[field.key]['values'][oa.id] && field_values[field.key]['values'][oa.id]['mode'] === 'manual'">
                              <div v-if="AIButtons[oa.id]" class="adaptation-button-group">
                                <button 
                                  v-for="nivel in AIButtons[oa.id].niveles" 
                                  :key="nivel.nivel+'-'+oa.id" 
                                  :class="['adaptation-button', { 'selected': field_values[field.key] && field_values[field.key]['values'][oa.id] && field_values[field.key]['values'][oa.id]['objetivo_adecuado'] === nivel.objetivo_adecuado }]"
                                  @click="setManual(field.key, oa.id, nivel.objetivo_adecuado)"
                                >
                                  {{ nivel.nivel }}
                                </button>
                              </div>
                              <b-textarea
                                class="auto-grow-textarea"
                                rows="4"
                                placeholder="Escribe la adecuación manualmente..."
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    oa.id
                                  ) &&
                                  field_values[field.key]['values'][oa.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][oa.id][
                                    'manual'
                                  ]
                                "
                                @input="autoGrowTextarea($event)"
                                @blur="updateInput(field.key)"
                                :disabled="
                                  oa.id in field_values[field.key]['values'] &&
                                  'select' in
                                    field_values[field.key]['values'][oa.id] &&
                                  field_values[field.key]['values'][oa.id][
                                    'select'
                                  ].length > 0
                                "
                              />
                              <b-button variant="outline-primary" pill
                                @click="generateAI(oa.id, field_values[field.key]['values'][oa.id]['criPro'], oa.description, oa.subject)"
                                :class="['mt-2', 'generar-ia-btn', {
                                  'pulse-attention': !AIButtonLoading && !field_values[field.key]['values'][oa.id]['manual'],
                                }]"
                                :disabled="AIButtonLoading"
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    oa.id
                                  ) &&
                                  field_values[field.key]['values'][oa.id]
                                "
                              >
                                <span v-if="AIButtonLoading"><b-spinner small/></span>
                                <span v-else>Generar con IA 🤖</span>
                              </b-button>
                            </b-td>
                            <b-td data-label="Adecuación manual / IA" v-if="field_values[field.key] && field_values[field.key]['values'][oa.id] && field_values[field.key]['values'][oa.id]['mode'] === 'select'">
                              <b-select
                                :disabled="
                                  !oa.progressions.length ||
                                  (oa.id in field_values[field.key]['values'] &&
                                    'manual' in
                                      field_values[field.key]['values'][
                                        oa.id
                                      ] &&
                                    field_values[field.key]['values'][oa.id][
                                      'manual'
                                    ].length > 0)
                                "
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    oa.id
                                  ) &&
                                  field_values[field.key]['values'][oa.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][oa.id][
                                    'select'
                                  ]
                                "
                                @input="updateInput(field.key)"
                              >
                                <b-select-option :value="''">
                                  Selecciona un OA de la progresión como
                                  adecuación
                                </b-select-option>
                                <b-select-option
                                  v-for="(
                                    progression, pIndex
                                  ) in oa.progressions"
                                  :key="pIndex + '-progresssion-' + oa.id"
                                  :value="progression.id"
                                >
                                  {{ progression.grade }} -
                                  {{ progression.name }}
                                </b-select-option>
                              </b-select>
                              <div
                                v-if="
                                  field_values[field.key]['values'][oa.id] &&
                                  field_values[field.key]['values'][oa.id][
                                    'select'
                                  ] &&
                                  field_values[field.key]['values'][oa.id][
                                    'select'
                                  ]
                                "
                              >
                                <b-textarea
                                  v-model="
                                    oa.progressions.filter(
                                      (p) =>
                                        p.id ===
                                        field_values[field.key]['values'][
                                          oa.id
                                        ]['select']
                                    )[0].description
                                  "
                                  disabled
                                />
                              </div>
                            </b-td>
                          </b-tr>
                          <b-tr
                            v-for="(exOA, exoIndex) in field.extra_oas"
                            :key="exoIndex + '-exoa'"
                            style="border-bottom: 2px solid #bb8800"
                          >
                            <b-td
                              style="width: 280px"
                              data-label="Objetivo"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                              :style="
                                exOA.id in field_values[field.key]['values'] &&
                                'criPro' in
                                  field_values[field.key]['values'][exOA.id] &&
                                field_values[field.key]['values'][exOA.id][
                                  'criPro'
                                ].includes(4)
                                  ? 'text-decoration: line-through; text-decoration-color: red'
                                  : ''
                              "
                            >
                              <span class="oa-subject-chip" v-if="exOA.subject">{{
                                exOA.subject
                              }}</span>
                              <div class="oa-name-line">
                                <strong>{{ exOA.name }}</strong>
                                <img
                                  :src="starIcon"
                                  v-if="exOA.priority === 1"
                                  width="22px"
                                />
                              </div>
                              {{ exOA.description }}
                            </b-td>
                            <b-td
                              data-label="Usar"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                              @click="setOA(exOA.id)"
                            >
                              <b-checkbox
                                v-if="field_values[field.key]"
                                v-model="field_values[field.key]['oas']"
                                :value="exOA.id"
                                size="lg"
                                @input="updateOas(field.key, exOA.id)"
                              />
                            </b-td>
                            <b-td
                              data-label="Criterios"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                              "
                              style="width: 100px"
                            >
                              <b-checkbox
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'criPro'
                                  ]
                                "
                                :value="0"
                              >
                                Graduación del nivel de complejidad
                              </b-checkbox>
                              <b-checkbox
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'criPro'
                                  ]
                                "
                                :value="1"
                              >
                                Priorización
                              </b-checkbox>
                              <b-checkbox
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'criPro'
                                  ]
                                "
                                :value="2"
                              >
                                Temporalización
                              </b-checkbox>
                              <b-checkbox
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'criPro'
                                  ]
                                "
                                :value="3"
                              >
                                Enriquecimiento del curriculum
                              </b-checkbox>
                              <b-checkbox
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'criPro'
                                  ]
                                "
                                :value="4"
                              >
                                Eliminación del aprendizaje
                              </b-checkbox>
                            </b-td>
                            <b-td data-label="Tipo" v-if="field_values[field.key] && field_values[field.key]['oas'].includes(exOA.id)">
                              <div
                                v-if="field_values[field.key] && field_values[field.key]['values'][exOA.id]"
                                class="tipo-button-group"
                              >
                                <button
                                  type="button"
                                  :class="['tipo-button', {
                                    selected: progMode(field.key, exOA.id) === 'manual',
                                    'pulse-attention': !progMode(field.key, exOA.id),
                                  }]"
                                  @click="setMode(field.key, exOA.id, 'manual')"
                                >
                                  Manual / IA
                                </button>
                                <button
                                  type="button"
                                  :class="['tipo-button', {
                                    selected: progMode(field.key, exOA.id) === 'select',
                                    'pulse-attention': !progMode(field.key, exOA.id),
                                  }]"
                                  @click="setMode(field.key, exOA.id, 'select')"
                                >
                                  Progresión MINEDUC
                                </button>
                              </div>
                            </b-td>
                            <b-td
                              data-label="Adecuación manual / IA"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                                && field_values[field.key]['values'][exOA.id]['mode'] === 'manual'
                              "
                            >
                              <div v-if="AIButtons[exOA.id]" class="adaptation-button-group">
                                <button 
                                  v-for="nivel in AIButtons[exOA.id].niveles" 
                                  :key="nivel.nivel+'-'+exOA.id" 
                                  :class="['adaptation-button', { 'selected': field_values[field.key] && field_values[field.key]['values'][exOA.id] && field_values[field.key]['values'][exOA.id]['objetivo_adecuado'] === nivel.objetivo_adecuado }]"
                                  @click="setManual(field.key, exOA.id, nivel.objetivo_adecuado)"
                                >
                                  {{ nivel.nivel }}
                                </button>
                              </div>
                              <b-textarea
                                class="auto-grow-textarea"
                                rows="4"
                                placeholder="Escribe la adecuación manualmente..."
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'manual'
                                  ]
                                "
                                @input="autoGrowTextarea($event)"
                                @blur="updateInput(field.key)"
                                :disabled="
                                  exOA.id in
                                    field_values[field.key]['values'] &&
                                  'select' in
                                    field_values[field.key]['values'][
                                      exOA.id
                                    ] &&
                                  field_values[field.key]['values'][exOA.id][
                                    'select'
                                  ].length > 0
                                "
                              />
                              <b-button variant="outline-primary" pill size="sm"
                                @click="generateAI(
                                  exOA.id,
                                  field_values[field.key]['values'][exOA.id][
                                      'criPro'
                                    ],
                                  exOA.description,
                                  exOA.subject
                                )"
                                :class="['mt-2', 'generar-ia-btn', 'pulse-attention']"
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                  && !field_values[field.key]['values'][exOA.id]['manual']
                                ">
                                Generar con IA 🤖
                              </b-button>
                            </b-td>
                            <b-td
                              data-label="Adecuación manual / IA"
                              v-if="
                                field_values[field.key]['oas'].includes(exOA.id)
                                && field_values[field.key]['values'][exOA.id]['mode'] === 'select'
                              "
                            >
                              <b-select
                                :disabled="
                                  !exOA.progressions.length ||
                                  (exOA.id in
                                    field_values[field.key]['values'] &&
                                    'manual' in
                                      field_values[field.key]['values'][
                                        exOA.id
                                      ] &&
                                    field_values[field.key]['values'][exOA.id][
                                      'manual'
                                    ].length > 0)
                                "
                                v-if="
                                  field_values[field.key] &&
                                  field_values[field.key]['oas'].includes(
                                    exOA.id
                                  ) &&
                                  field_values[field.key]['values'][exOA.id]
                                "
                                v-model="
                                  field_values[field.key]['values'][exOA.id][
                                    'select'
                                  ]
                                "
                              >
                                <b-select-option :value="''">
                                  Selecciona un OA de la progresión como
                                  adecuación
                                </b-select-option>
                                <b-select-option
                                  v-for="(
                                    progression, pIndex
                                  ) in exOA.progressions"
                                  :key="pIndex + '-progresssion-' + exOA.id"
                                  :value="progression.id"
                                >
                                  {{ progression.grade }} -
                                  {{ progression.name }}
                                </b-select-option>
                              </b-select>
                              <div
                                v-if="
                                  field_values[field.key]['values'][exOA.id] &&
                                  field_values[field.key]['values'][exOA.id][
                                    'select'
                                  ]
                                "
                              >
                                <b-textarea
                                  v-model="
                                    exOA.progressions.filter(
                                      (p) =>
                                        p.id ===
                                        field_values[field.key]['values'][
                                          exOA.id
                                        ]['select']
                                    )[0].description
                                  "
                                  disabled
                                />
                              </div>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-button
                      variant="primary"
                      pill
                      @click="openExtraOAs(field.extra_oas, field.key)"
                    >
                      Añadir OAs no prioritarios o de otras asignaturas
                    </b-button>
                  </b-row>
                </div>
                </div>
              </b-col>
              <b-col
                v-if="row.school && editing && $store.state.login.isAdmin && page.name === 'OBJETIVOS POR ESPECIALIDAD'"
                cols="1"
                class="d-flex align-items-center justify-content-end"
              >
                <b-button
                  size="sm"
                  variant="outline-danger"
                  @click="deleteDimension(row, page)"
                  title="Eliminar dimensión"
                >
                  <v-icon name="trash" />
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-if="editing && $store.state.login.isAdmin && page.name === 'OBJETIVOS POR ESPECIALIDAD' && areaEndingAt(row.id, page.id)"
              :key="rIndex + '-add-btn'"
              class="mt-1 mb-2"
            >
              <b-col class="text-right">
                <b-button
                  size="sm"
                  variant="outline-warning"
                  @click="openAddDimensionModal(page, areaEndingAt(row.id, page.id))"
                >
                  + Agregar dimensión a {{ areaEndingAt(row.id, page.id).headerText }}
                </b-button>
              </b-col>
            </b-row>
            </template>
            <!-- Page navigation: previous / next page at the bottom of every
                 page (the "Continuar" question protocol no longer changes the
                 page, so the user moves between pages here). -->
            <b-row
              v-if="document.document_template.pages.length > 1"
              class="page-nav-row mt-4 mb-2"
            >
              <b-col class="d-flex justify-content-between align-items-center">
                <b-button
                  v-if="pIndex > 0"
                  pill
                  variant="outline-primary"
                  class="page-nav-btn"
                  @click="goToPrevPage"
                >
                  <v-icon name="chevron-left" class="mr-1" /> Página anterior
                </b-button>
                <span v-else></span>
                <b-button
                  v-if="pIndex < document.document_template.pages.length - 1"
                  :id="'page-next-btn-' + pIndex"
                  pill
                  variant="outline-primary"
                  class="page-nav-btn"
                  @click="goToNextPage"
                >
                  Página siguiente <v-icon name="chevron-right" class="ml-1" />
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
      <template #overlay>
        <div class="text-center">
          <p v-if="blockAllInputs" id="cancel-label">
            Recarga el sitio para voler a conectarte.
          </p>
        </div>
      </template>
    </b-overlay>
  </b-card>
</template>
<script>
import documentSocket from "../../../mixins/documentSocket";
import redpieService from "../../../services/redpieService";
import documentOnlineService from "../../../services/documentOnlineService";
import DocumentOnlineErrorField from "./DocumentOnlineErrorField";
import informationService from "../../../services/informationService";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";

export default {
  components: { DocumentOnlineErrorField },
  props: {
    document: {
      type: Object,
      required: true,
    },
    leave: {
      type: Boolean,
      required: false,
    },
    is_backup: {
      type: Boolean,
      required: false,
    },
    // Chatbot (studentless) mode: the documentSocket mixin skips all
    // socket/ping/persistence, answers stay in the local field_values only.
    localMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    // When opening a source PAI/PACI from an empty EDA section, jump straight
    // to the page + field that needs completing.
    initialPageIndex: {
      type: Number,
      required: false,
      default: null,
    },
    initialFocusKey: {
      type: String,
      required: false,
      default: null,
    },
  },
  mixins: [documentSocket],
  watch: {
    pageRequireGraph() {
      if (this.pageRequireGraph) {
        this.getPageGraphData();
      }
    },
    editing() {
      if (this.editing) {
        return this.$bvModal.msgBoxOk(
          "Al entrar al modo edición podrás eliminar sugerencias que hayan agregado en tu colegio" +
            " en las preguntas de selección múltiple y única. Realiza esta acción con precaución, ya que" +
            " al eliminar una sugerencia dejará de estar disponible en documentos en las que se haya marcado.",
          {
            okTitle: "De acuerdo",
          }
        );
      }
    },
    leave() {
      if (this.leave) {
        this.leaveDocument();
      }
    },
    fillableFields() {
      this.$emit("fields", this.fillableFields);
    },
    field_values: {
      async handler() {
        await new Promise((r) => setTimeout(r, 1000));
        if (!this.is_backup && this.pageRequireGraph) {
          this.getPageGraphData();
        }
        // Auto-grow textareas when field values change
        this.$nextTick(() => {
          this.autoGrowAllTextareas();
        });
      },
      deep: true,
    },
    pageIndex() {
      this.editing = false;
      // Evita que el gráfico de la página anterior quede "pegado" al volver a
      // una página ya cargada: los watchers pageRequireGraph/field_values no se
      // re-disparan en ese caso (pageRequireGraph sigue en true entre páginas de
      // logro y field_values no cambia), así que refrescamos el gráfico acá.
      this.achievementData = {};
      this.chartOptionsBar = {};
      this.getPageInfo();
      if (this.pageRequireGraph) {
        this.getPageGraphData();
      }
      // Auto-grow textareas when page changes
      this.$nextTick(() => {
        this.autoGrowAllTextareas();
      });
    },
    "document.id"(newId, oldId) {
      if (newId && newId !== oldId) {
        this.achievementSourceCache = {};
        this.achievementSourceLoading = {};
      }
    },
  },
  data() {
    return {
      newDimensionName: "",
      addDimensionTarget: null,
      ejesLevel: {

      },
      ejesSubarea: {

      },
      oaClicked: null,
      check: null,
      addButton: require("../../../assets/img/online_doc_add.svg"),
      retrievedContext: [],
      extraEvents: {},
      touchedFields: [],
      pageIndex: 0,
      pageResponses: {},
      addExtra: {},
      newOption: {},
      selectedSelector: [],
      selectedField: {},
      starIcon: require("../../../assets/img/icono-estrella.svg"),
      extraOAs: [],
      extraKey: "",
      subjectFilter: "",
      emptyFields: [],
      AIButtons: {},
      AIButtonLoading: false,
      // localMode (chatbot) CUSTOM_RADIO: which fields have their unselected
      // options expanded (keyed by field.key). Once an option is picked the
      // others collapse; this re-reveals them.
      radioExpanded: {},
      // TEXT_OPTIONS / TEXT_EJES_ACHIEVEMENT: fields whose text input has been
      // revealed via "Continuar". While a field is empty and not revealed, the
      // textarea is hidden and its suggestions / ejes section shows directly.
      revealedTextInput: {},
      // Guided flow: the key of the question currently in focus (highlighted +
      // scrolled to). "Continuar" advances it to the next question / page; on
      // page change the first question is focused automatically.
      focusedQuestionKey: null,
      // TEXT_EJES_ACHIEVEMENT: per-field flag set true once the user has set an
      // achievement on any eje. Until then the first OA of the first card shows
      // a pulsing hint so the user notices the L/P/N options are clickable.
      ejesHintDismissed: {},
      // CUSTOM_CHECKBOX / CUSTOM_RADIO: per-field flag set true once the user
      // clicks "Añadir sugerencia" — reveals the new-option input (kept hidden
      // behind the button until then).
      addOptionRevealed: {},
      // Achievement kinds: the composite key (fieldKey__optId) of the option
      // row currently in focus inside an achievement field. Drives the
      // row-level guided flow (focus the first unanswered row, advance on
      // select).
      focusedAchievementRow: null,
      achievementSourceLoading: {},
      achievementSourceCache: {},
      // OA_ACHIEVEMENT fixed levels (value = index), rendered as title buttons
      // with semantic colours (green / orange / red / gray).
      oaAchievementLevels: [
        { label: "Logrado", cls: "ach-l" },
        { label: "Parcialmente logrado", cls: "ach-p" },
        { label: "No logrado", cls: "ach-n" },
        { label: "No trabajado", cls: "ach-nt" },
      ],
      questionKinds: {
        STRING: 1,
        BOOL: 2,
        USER_CHECKBOX_ACHIEVEMENT: 3,
        USER_SELECTOR: 4,
        SPECIAL_SELECTOR: 5,
        OA_FIELD: 6,
        CUSTOM_CHECKBOX: 7,
        CHECKBOX_ACHIEVEMENT: 8,
        OA_ACHIEVEMENT: 9,
        CUSTOM_RADIO: 10,
        TEXT: 11,
        OA_PROGRESSION: 12,
        TEXT_OPTIONS: 13,
        TEXT_EJES_ACHIEVEMENT: 14,
        SPECIAL_MULTI_SELECTOR: 15,
      },
      addCheckboxOption: {},
      addEjeOption: {},
      achievementData: {},
      chartOptionsBar: {},
      editing: false,
      focusedTextOptionsFields: {},
      focusedEjesAchievementFields: {},
      textOptionsAILoading: {},
      ejesAchievementAILoading: {},
      aiGeneratedOptions: {}, // Store AI-generated options per field key
      levels: []
    };
  },
  created() {
    this.field_values = this.document.context;
    this.touchedFields = [];
    const pages =
      (this.document.document_template &&
        this.document.document_template.pages) ||
      [];
    this.pageIndex =
      this.initialPageIndex != null &&
      this.initialPageIndex >= 0 &&
      this.initialPageIndex < pages.length
        ? this.initialPageIndex
        : 0;
    this.getLevels();
    this.getPageInfo().then(() => {
      // Transform achievements after page info is loaded
      // This ensures field.ejes data is available
      this.$nextTick(() => {
        this.transformAchievementsFromBackend();
        this.initRevealedTextInput();
        // Auto-grow all textareas after content is loaded
        this.autoGrowAllTextareas();
        // Jump to the section that needs completing (source PAI/PACI opened
        // from an empty EDA area).
        if (this.initialFocusKey) {
          this.scrollToSourceField(this.initialFocusKey);
        }
      });
      
      if (!this.is_backup) {
        this.checkAutoUpdateDocument();
        this.$store.dispatch("setFieldValues", this.field_values);
        this.joinDocument(this.document.id);
        this.emptyFields = this.getEmptyFields();
      }
    });
  },
  mounted() {
    // Auto-grow textareas on mount
    this.$nextTick(() => {
      this.autoGrowAllTextareas();
    });
    // Add document click listener to hide suggestions when clicking outside
    this.handleDocumentClick = (event) => {
      this.handleClickOutsideSuggestions(event);
    };
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // Remove document click listener on component destruction
    if (this.handleDocumentClick) {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  },
  methods: {
    // CUSTOM_RADIO: pick an option (single value, same shape the old
    // checkbox-radio wrote) and collapse the rest. Selecting a NEW option also
    // advances the guided flow to the next question / page (re-clicking the
    // current one just clears it, no advance).
    selectRadioOption(key, optionId) {
      const current = this.field_values[key];
      const cleared = current === optionId;
      this.$set(this.field_values, key, cleared ? "" : optionId);
      this.$set(this.radioExpanded, key, false);
      this.updateInput(key);
      if (!cleared) {
        this.goToNextQuestion(key);
      }
    },
    toggleRadioOptions(key) {
      this.$set(this.radioExpanded, key, !this.radioExpanded[key]);
    },
    // BOOL field (Sí / No buttons). "Sí" stores boolean `true`; "No" stores the
    // STRING "false" — not boolean false, which the backend drops on save (a
    // falsy value). The backend renders only "true"/"True" as yes and anything
    // else (incl. "false") as no, so "false" persists AND renders correctly.
    // Re-clicking the active one clears it (back to unanswered "").
    onBoolSelect(key, value) {
      const isSame =
        (value === true && this.isBoolYes(key)) ||
        (value === "false" && this.isBoolNo(key));
      const next = isSame ? "" : value;
      this.$set(this.field_values, key, next);
      this.updateInput(key);
      if (next !== "") {
        this.goToNextQuestion(key);
      }
    },
    // BOOL value matchers — tolerate every representation the value can take
    // across the chatbot (boolean), a fresh click (string) and a backend reload
    // (get_context returns boolean True / "" ).
    isBoolYes(key) {
      const v = this.field_values[key];
      return v === true || v === "true" || v === "True" || v === "Sí";
    },
    isBoolNo(key) {
      const v = this.field_values[key];
      return v === false || v === "false" || v === "False" || v === "No";
    },
    // Selector fields (USER_SELECTOR / SPECIAL_SELECTOR): persist and, once a
    // real option is chosen, advance the guided flow to the next question.
    onSelectorChange(key) {
      // Drop the native focus ring the <select> keeps after a change — without
      // this it visually stays "focused" even though the guided flow advances.
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      this.updateInput(key);
      const v = this.field_values[key];
      if (v !== "" && v != null) {
        this.goToNextQuestion(key);
      }
    },
    addUserTestTag(name, eje, key) {
      documentOnlineService.addUserTestTag({
        school: this.$store.state.login.school,
        name: name,
        eje: eje.id
      }).then((data) => {
        eje.user_test_tags.push(data);
        this.$toasted.success("User test tag added successfully");
        this.$set(this.addEjeOption, `${key}_${eje.id}`, "");
      });
    },
    showEjesAchievementSuggestions(fieldKey) {
      // Ensure the field value is a string before showing suggestions
      this.ensureEjesAchievementStructure(fieldKey);
      this.$set(this.focusedEjesAchievementFields, fieldKey, true);
      this.blockInput(fieldKey);
    },
    toggleEjesAchievementSuggestions(fieldKey) {
      if (this.focusedEjesAchievementFields[fieldKey]) {
        this.$set(this.focusedEjesAchievementFields, fieldKey, false);
        this.unblockInput(fieldKey);
      } else {
        this.showEjesAchievementSuggestions(fieldKey);
      }
    },
    hideEjesAchievementSuggestions(fieldKey, event) {
      // Check if the focus is moving to an element within the suggestions container
      const relatedTarget = event.relatedTarget || document.activeElement;
      const suggestionsRef = this.$refs['ejesAchievementSuggestions_' + fieldKey];
      
      // Handle both array and single element refs
      const suggestionsElement = Array.isArray(suggestionsRef) ? suggestionsRef[0] : suggestionsRef;
      
      if (suggestionsElement && suggestionsElement.contains && suggestionsElement.contains(relatedTarget)) {
        // Focus is moving within the suggestions container, don't hide
        return;
      }
      
      // Use setTimeout to allow click event on suggestions to fire before hiding
      setTimeout(() => {
        // Double-check that focus hasn't moved back to the suggestions container
        const currentActiveElement = document.activeElement;
        if (suggestionsElement && suggestionsElement.contains && suggestionsElement.contains(currentActiveElement)) {
          return;
        }
        this.$set(this.focusedEjesAchievementFields, fieldKey, false);
        this.unblockInput(fieldKey);
      }, 200);
    },
    generateEjesAchievementAI(fieldKey) {
      // Set loading state for this specific field
      this.$set(this.ejesAchievementAILoading, fieldKey, true);
      
      // Make request to backend with field key
      documentOnlineService.generateEjesAchievementAI({
        field_key: fieldKey,
        document: this.document.id
      }).then((data) => {
        this.$set(this.ejesAchievementAILoading, fieldKey, false);
        
        // Check for error response
        if (data.error) {
          this.$toasted.error(data.error);
          return;
        }
        
        // If text is generated, add it to the textarea
        if (data.text) {
          const currentValue = this.field_values[fieldKey] || "";
          const separator = currentValue.length > 0 && !currentValue.endsWith(" ") && !currentValue.endsWith("\n") ? "\n\n" : "";
          this.field_values[fieldKey] = currentValue + separator + data.text;
          this.updateInput(fieldKey);
          this.$toasted.success("Texto generado con IA.");
        } else {
          this.$toasted.error("No se recibió texto válido de la IA.");
        }
      }).catch((error) => {
        this.$set(this.ejesAchievementAILoading, fieldKey, false);
        this.$toasted.error("Error al generar texto con IA: " + (error.message || "Error desconocido"));
      });
    },
    getLevels() {
      informationService.getPieGrades().then((data) => {
        this.levels = data.grades;// data.grades.filter((grade) => grade[0] > 1);
      });
    },
    setManual(fieldKey, oaID, manual) {
      this.$set(this.field_values[fieldKey]['values'][oaID], 'manual', manual);
      this.updateInput(fieldKey);
    },
    setMode(fieldKey, oaID, mode) {
      // Buttons (no v-model) → set the mode here, then clear the other path's
      // value so manual/select stay mutually exclusive.
      this.$set(this.field_values[fieldKey]['values'][oaID], 'mode', mode);
      if (mode === 'select') {
        this.$set(this.field_values[fieldKey]['values'][oaID], 'manual', '');
      } else {
        this.$set(this.field_values[fieldKey]['values'][oaID], 'select', '');
      }
      this.updateInput(fieldKey);
    },
    // Current "Tipo de adecuación" selection for an OA: prefers the explicit
    // mode, falling back to legacy manual/select values. Returns 'manual',
    // 'select' or null (nothing chosen yet).
    progMode(fieldKey, oaID) {
      const fv = this.field_values[fieldKey];
      const val = fv && fv['values'] && fv['values'][oaID];
      if (!val) return null;
      if (val.mode) return val.mode;
      if (val.manual) return 'manual';
      if (val.select) return 'select';
      return null;
    },
    generateAI(oaID, criPro, oaDescription, subject) {
      const criProTranslate = {
        0: "Graduación del nivel de complejidad",
        1: "Priorización",
        2: "Temporalización",
        3: "Enriquecimiento del curriculum",
        4: "Eliminación del aprendizaje",
      }
      let criteria = "";
      criPro.forEach(cri => {
        criteria += criProTranslate[cri] + "\n";
      });
      this.AIButtonLoading = true;
      documentOnlineService.getAIOAMultiAdecuacy({
        subject: subject,
        oa: oaDescription,
        criteria: criteria,
        age: this.document.context.WW,
        diagnosis: this.document.context.AM
      }).then((data) => {
        this.AIButtonLoading = false;
        this.$set(this.AIButtons, oaID, JSON.parse(data));
      });
      // let vue_context = this;
      // documentOnlineService.getAIOAAdecuacy({
      //   subject: subject,
      //   oa: oaDescription,
      //   criteria: criteria,
      //   simplicity: simplicity,
      // }).then((body) => {
      //     const reader = body.getReader();
      //     const decoder = new TextDecoder();
      //     let manual = "";
      //     function processChunk({ done, value }) {
      //       if (value) {
      //         const decodedChunk = decoder.decode(value);
      //         manual += decodedChunk;
      //         vue_context.$set(vue_context.field_values[fieldKey]['values'][oaID], 'manual', manual);
      //       }
      //       if (done) {
      //         vue_context.updateInput(fieldKey);
      //         return;
      //       }
      //       return reader.read().then(processChunk);
      //     }
      //     reader.read().then(processChunk);
      //   });
    },
    setOA(oaID) {
      this.oaClicked = oaID;
    },
    setCheck(val) {
      this.check = val;
    },
    async getPageInfo() {
      if (!this.document.document_template.pages[this.pageIndex].rows.length) {
        documentOnlineService
          .getPageInfo(
            this.document.document_template.pages[this.pageIndex].id,
            this.is_backup ? this.document.document : this.document.id
          )
          .then((data) => {
            console.log(data)
            this.$set(
              this.document.document_template.pages[this.pageIndex],
              "rows",
              data.rows
            );
            data.rows.forEach(row => {
              row.fields.forEach(field => {
                if (field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) {
                  this.$set(this.ejesLevel, field.key, data.grade);
                  if (field.default_subarea) {
                    this.$set(this.ejesSubarea, field.key, field.default_subarea);
                    this.getFilteredEjes(field);
                  } else {
                    this.$set(this.ejesSubarea, field.key, null);
                  }
                }
                // Las dimensiones agregadas después de crear el documento no tienen
                // DocumentFieldValue, así que su key no llega en el context. Sin un
                // array, <b-form-checkbox> se comporta como single-select.
                if (
                  field.kind === this.questionKinds.CUSTOM_CHECKBOX &&
                  !Array.isArray(this.field_values[field.key])
                ) {
                  this.$set(this.field_values, field.key, []);
                }
              });
            });
            // Decide the reveal state synchronously, from the saved context, so
            // it's fixed BEFORE the user can mark any eje — otherwise a later
            // (nextTick) init would see the just-added achievement and wrongly
            // reveal the input, closing the section.
            this.initRevealedTextInput();

            // Transform achievements from backend format to frontend format
            // This needs to happen after rows are loaded so we have access to field.ejes
            this.$nextTick(() => {
              this.transformAchievementsFromBackend();
              
            // Generate text for fields that have achievements
            // BUT only if the field is empty - don't overwrite existing user content
            data.rows.forEach(row => {
              row.fields.forEach(field => {
                if (field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) {
                  const achievementsKey = `${field.key}_achievements`;
                  const fieldText = this.field_values[field.key] || '';
                  // Only generate if field is empty or only whitespace
                  if ((!fieldText || fieldText.trim() === '') &&
                      this.field_values[achievementsKey] &&
                      Object.keys(this.field_values[achievementsKey]).length > 0) {
                    this.generateEjesAchievementText(field.key);
                  }
                }
              });
            });
            this.initRevealedTextInput();
            this.prefetchAchievementSourcesForPage(
              this.document.document_template.pages[this.pageIndex]
            );
            // Guided flow: focus the first UNANSWERED question — done after the
            // achievements transform so a pre-filled ejes field isn't seen as
            // empty.
            this.focusFirstQuestion();
            });
          });
      } else {
        // Fix the reveal state up front (before any interaction), then
        // transform achievements.
        this.initRevealedTextInput();
        this.$nextTick(() => {
          this.transformAchievementsFromBackend();
          this.initRevealedTextInput();
          this.prefetchAchievementSourcesForPage(
            this.document.document_template.pages[this.pageIndex]
          );
          this.focusFirstQuestion();
        });
      }
    },
    deleteOption(optionID, optionsArray, optionIndex) {
      documentOnlineService.deleteOption({ id: optionID }).then((data) => {
        optionsArray.splice(optionIndex, 1);
        if (data.message) {
          this.$toasted.success(data.message);
        }
      });
    },
    getOAAchivementGraphData() {
      documentOnlineService
        .getOAAchievementGraphData(this.document.id)
        .then((data) => {
          this.achievementData = data;
          this.chartOptionsBar = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              containLabel: true,
            },
            xAxis: {
              type: "category",
              axisLabel: {
                rotate: 45,
                overflow: "break",
              },
              data: Object.keys(data),
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "bar",
                stack: "oli",
                showBackground: true,
                label: {
                  normal: {
                    show: true,
                    position: "insideRight",
                    formatter: "{c}%",
                    fontWeight: "bolder",
                    fontSize: 16,
                    padding: [0, 35, 0, 0],
                  },
                },
                itemStyle: {
                  color: (params) => {
                    if (params.value > 60) {
                      return "#3C9C18";
                    } else if (params.value > 40) {
                      return "#D5D545";
                    } else {
                      return "#FF5500";
                    }
                  },
                },
                data: Object.values(data),
              },
            ],
          };
        });
    },
    getPageGraphData() {
      documentOnlineService
        .getPageGraphData(this.document.id, this.pageIndex)
        .then((data) => {
          this.achievementData = data;
          this.chartOptionsBar = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              containLabel: true,
            },
            xAxis: {
              type: "category",
              axisLabel: {
                rotate: 45,
                overflow: "break",
              },
              data: Object.keys(data),
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "bar",
                stack: "oli",
                showBackground: true,
                label: {
                  normal: {
                    show: true,
                    formatter: "{c}%",
                    fontWeight: "bolder",
                    fontSize: 16,
                    align: "center",
                    verticalAlign: "middle",
                  },
                },
                itemStyle: {
                  color: (params) => {
                    if (params.value > 60) {
                      return "#00b9ae";
                    } else if (params.value > 40) {
                      return "#f8b500";
                    } else {
                      return "#e84855";
                    }
                  },
                },
                data: Object.values(data),
              },
            ],
          };
        });
    },
    addCheckOption(key, options) {
      let val = this.addCheckboxOption[key];
      if (val) {
        documentOnlineService
          .addOption({
            key: key,
            text: val,
            school: this.$store.state.login.school,
            document: this.document.id,
          })
          .then((data) => {
            options.push(data);
            this.addCheckboxOption[key] = "";
            // Collapse back to the "Añadir sugerencia" button.
            this.$set(this.addOptionRevealed, key, false);
            this.$toasted.success("Opción agregada!");
          });
      } else {
        this.$toasted.error("Ingresa una opción!");
      }
    },
    getEjeKey(eje) {
      // Use id if available, otherwise use name as unique identifier
      return eje.id || `${eje.name}_${eje.level}`;
    },
    transformAchievementsFromBackend() {
      // Transform backend achievements format to frontend format
      // Backend: context["achievements"][fieldKey][elementId] = achievement
      // Frontend: field_values[${fieldKey}_achievements][${ejeKey}_${oaId}] = achievement
      
      if (!this.field_values || !this.field_values["achievements"]) {
        return;
      }

      const backendAchievements = this.field_values["achievements"];
      
      // Iterate through all pages to find TEXT_EJES_ACHIEVEMENT fields
      if (!this.document || !this.document.document_template || !this.document.document_template.pages) {
        return;
      }

      this.document.document_template.pages.forEach(page => {
        if (!page.rows) return;
        
        page.rows.forEach(row => {
          if (!row.fields) return;
          
          row.fields.forEach(field => {
            if (field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT && backendAchievements[field.key]) {
              const fieldAchievements = backendAchievements[field.key];
              const achievementsKey = `${field.key}_achievements`;
              
              // Initialize the frontend achievements structure
              if (!this.field_values[achievementsKey]) {
                this.$set(this.field_values, achievementsKey, {});
              }
              
              // If field has ejes, map element IDs to ejeKey_oaId format
              if (field.ejes && Array.isArray(field.ejes)) {
                field.ejes.forEach(eje => {
                  const ejeKey = this.getEjeKey(eje);
                  
                  // Check regular OAs
                  // Backend stores element as string, so convert both to string for comparison
                  if (eje.oas && Array.isArray(eje.oas)) {
                    eje.oas.forEach(oa => {
                      // Try both string and number comparison since backend might return string
                      const oaIdStr = String(oa.id);
                      const oaIdNum = oa.id;
                      if (fieldAchievements[oaIdStr] !== undefined) {
                        const key = `${ejeKey}_${oa.id}`;
                        this.$set(this.field_values[achievementsKey], key, fieldAchievements[oaIdStr]);
                      } else if (fieldAchievements[oaIdNum] !== undefined) {
                        const key = `${ejeKey}_${oa.id}`;
                        this.$set(this.field_values[achievementsKey], key, fieldAchievements[oaIdNum]);
                      }
                    });
                  }
                  
                  // Check user_test_tags
                  if (eje.user_test_tags && Array.isArray(eje.user_test_tags)) {
                    eje.user_test_tags.forEach(userTag => {
                      // Try both string and number comparison since backend might return string
                      const tagIdStr = String(userTag.id);
                      const tagIdNum = userTag.id;
                      if (fieldAchievements[tagIdStr] !== undefined) {
                        const key = `${ejeKey}_${userTag.id}`;
                        this.$set(this.field_values[achievementsKey], key, fieldAchievements[tagIdStr]);
                      } else if (fieldAchievements[tagIdNum] !== undefined) {
                        const key = `${ejeKey}_${userTag.id}`;
                        this.$set(this.field_values[achievementsKey], key, fieldAchievements[tagIdNum]);
                      }
                    });
                  }
                });
              }
            }
          });
        });
      });
    },
    getAddEjeOptionValue(fieldKey, eje) {
      const optionKey = `${fieldKey}_${this.getEjeKey(eje)}`;
      return this.addEjeOption[optionKey] || '';
    },
    setAddEjeOptionValue(fieldKey, eje, value) {
      const optionKey = `${fieldKey}_${this.getEjeKey(eje)}`;
      this.$set(this.addEjeOption, optionKey, value);
    },
    getAchievementValue(fieldKey, ejeKey, oaId) {
      // Ensure field_values[fieldKey] exists and is properly structured
      this.ensureEjesAchievementStructure(fieldKey);
      const achievementsKey = `${fieldKey}_achievements`;
      if (!this.field_values[achievementsKey]) {
        this.$set(this.field_values, achievementsKey, {});
      }
      const key = `${ejeKey}_${oaId}`;
      return this.field_values[achievementsKey][key] || null;
    },
    // Composite key (ejeKey__oaId) of the first still-unmarked OA across the
    // visible eje cards — visibleOas / visibleUserTags already exclude answered
    // items, so the first visible item is the next one to mark.
    firstUnansweredOaKey(field) {
      const ejes = this.getFilteredEjes(field);
      for (const eje of ejes) {
        const ejeKey = this.getEjeKey(eje);
        const oas = this.visibleOas(field, eje);
        if (oas.length) {
          return ejeKey + "__" + oas[0].id;
        }
        const tags = this.visibleUserTags(field, eje);
        if (tags.length) {
          return ejeKey + "__" + tags[0].id;
        }
      }
      return null;
    },
    isFirstUnansweredOa(field, eje, oa) {
      return (
        this.firstUnansweredOaKey(field) ===
        this.getEjeKey(eje) + "__" + oa.id
      );
    },
    isEjesHintTarget(field, eje, oa) {
      // Show the "clickable" hint only on the very first OA of the first
      // visible card, and only until the user sets any achievement.
      if (this.ejesHintDismissed[field.key]) return false;
      const visible = this.getVisibleEjes(field);
      if (!visible.length) return false;
      if (this.getEjeKey(visible[0]) !== this.getEjeKey(eje)) return false;
      const oas = this.visibleOas(field, eje);
      if (oas.length) return oas[0].id === oa.id;
      const tags = this.visibleUserTags(field, eje);
      if (tags.length) return tags[0].id === oa.id;
      return false;
    },
    // Achievement kinds (OA_ACHIEVEMENT / CHECKBOX_ACHIEVEMENT /
    // USER_CHECKBOX_ACHIEVEMENT) use title buttons instead of checkboxes:
    // clicking sets the option's selected level; re-clicking the same one
    // clears it. The value (column index / 0-3) is stored per option id.
    setAchievementValue(fieldKey, optId, value) {
      if (!this.field_values[fieldKey]) {
        this.$set(this.field_values, fieldKey, {});
      }
      const cur = this.field_values[fieldKey][optId];
      this.$set(this.field_values[fieldKey], optId, cur === value ? null : value);
      this.updateInput(fieldKey);
    },
    setAchievement(fieldKey, ejeKey, oaId, value) {
      // The user interacted with the rubric — drop the first-OA hint.
      if (!this.ejesHintDismissed[fieldKey]) {
        this.$set(this.ejesHintDismissed, fieldKey, true);
      }
      documentOnlineService.addElementAchievement({
        field_key: fieldKey,
        document_id: this.document.id,
        element_id: oaId,
        achievement: value
      }).then((data) => {
        console.log(data);
      });
      // Ensure field_values[fieldKey] exists and is properly structured
      this.ensureEjesAchievementStructure(fieldKey);
      const achievementsKey = `${fieldKey}_achievements`;
      if (!this.field_values[achievementsKey]) {
        this.$set(this.field_values, achievementsKey, {});
      }
      const key = `${ejeKey}_${oaId}`;
      // Toggle: if clicking the same value, unset it
      if (this.field_values[achievementsKey][key] === value) {
        this.$set(this.field_values[achievementsKey], key, null);
      } else {
        this.$set(this.field_values[achievementsKey], key, value);
      }
      // Update only the specific eje section that changed
      this.updateEjeSection(fieldKey, ejeKey);
      this.updateInput(fieldKey);
      // Keep the (revealed) textarea sized to its generated content. No-op when
      // the textarea is still hidden in section mode.
      this.autoGrowAllTextareas();
    },
    ensureEjesAchievementStructure(fieldKey) {
      // Ensure field_values[fieldKey] is a string (for textarea)
      // If it's an object, convert it to a string and preserve any text
      if (this.field_values[fieldKey] && typeof this.field_values[fieldKey] === 'object' && !Array.isArray(this.field_values[fieldKey])) {
        // If it was accidentally set as an object, try to extract text or set to empty string
        const textValue = this.field_values[fieldKey].text || this.field_values[fieldKey].value || '';
        this.$set(this.field_values, fieldKey, textValue);
      } else if (!this.field_values[fieldKey]) {
        // Initialize as empty string if it doesn't exist
        this.$set(this.field_values, fieldKey, '');
      }
      // Ensure it's a string
      if (typeof this.field_values[fieldKey] !== 'string') {
        this.$set(this.field_values, fieldKey, String(this.field_values[fieldKey] || ''));
      }
    },
    capitalizeFirst(str) {
      const s = (str || "").trim();
      if (!s) return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    pickConjunction(nextText) {
      const t = (nextText || "").trim().toLowerCase();
      // En español, "y" pasa a "e" antes de sonido /i/ (i, hi)
      if (t.startsWith("i") || t.startsWith("hi")) return "e";
      return "y";
    },
    getSubareasText(field) {
      if (!field || !field.ejes) {
        return "lenguaje y matemáticas";
      }
      
      const currentLevel = this.ejesLevel[field.key];
      const filteredEjes = field.ejes.filter(e => e.level === currentLevel);
      
      // Get unique subareas from filtered ejes
      const subareas = [...new Set(
        filteredEjes
          .map(e => e.subarea)
          .filter(subarea => subarea && subarea.trim() !== '')
      )];
      
      if (subareas.length === 0) {
        return "lenguaje y matemáticas";
      }
      
      // Convert to lowercase and format
      const formattedSubareas = subareas.map(s => s.toLowerCase());
      
      if (formattedSubareas.length === 1) {
        return formattedSubareas[0];
      } else if (formattedSubareas.length === 2) {
        return `${formattedSubareas[0]} y ${formattedSubareas[1]}`;
      } else {
        // For 3 or more subareas: "subarea1, subarea2 y subarea3"
        const lastSubarea = formattedSubareas[formattedSubareas.length - 1];
        const otherSubareas = formattedSubareas.slice(0, -1);
        return `${otherSubareas.join(', ')} y ${lastSubarea}`;
      }
    },
    getAvailableSubareas(field) {
      if (!field || !field.ejes) {
        return [];
      }
      
      const currentLevel = this.ejesLevel[field.key];
      const filteredEjes = field.ejes.filter(e => e.level === currentLevel);
      
      // Get unique subareas from filtered ejes
      const subareas = [...new Set(
        filteredEjes
          .map(e => e.subarea)
          .filter(subarea => subarea && subarea.trim() !== '')
      )];
      
      return subareas.sort();
    },
    getFilteredEjes(field) {
      if (!field || !field.ejes) {
        return [];
      }
      
      const currentLevel = this.ejesLevel[field.key];
      const selectedSubarea = this.ejesSubarea[field.key];
      
      let filtered = field.ejes.filter(e => e.level === currentLevel);
      
      // Filter by subarea if one is selected
      if (selectedSubarea) {
        filtered = filtered.filter(e => e.subarea === selectedSubarea);
      }
      
      return filtered.sort((a, b) => a.subarea > b.subarea);
    },
    // A CUSTOM_CHECKBOX is "collapsed" (shown as a compact answered summary)
    // when it's NOT the focused question and has at least one option checked —
    // not while editing (admins manage the full list).
    isCheckboxCollapsed(field) {
      if (this.editing || this.focusedQuestionKey === field.key) {
        return false;
      }
      const vals = this.field_values[field.key];
      return Array.isArray(vals) && vals.length > 0;
    },
    // Whether to show a field's inline "add a new option / suggestion" controls.
    // Only while the field is focused (or in edit mode) — keeps the add-option
    // inputs hidden until the user is actively working that question.
    showAddOption(field) {
      return this.editing || this.focusedQuestionKey === field.key;
    },
    // CUSTOM_CHECKBOX option buttons (multi-select toggle, same look as the
    // CUSTOM_RADIO ones). field_values[key] is the array of selected option ids.
    isCheckboxOptionSelected(field, option) {
      const vals = this.field_values[field.key];
      return Array.isArray(vals) && vals.indexOf(option.id) !== -1;
    },
    toggleCheckboxOption(key, optionId) {
      const cur = Array.isArray(this.field_values[key])
        ? this.field_values[key]
        : [];
      const next =
        cur.indexOf(optionId) === -1
          ? cur.concat([optionId])
          : cur.filter((id) => id !== optionId);
      this.$set(this.field_values, key, next);
      this.updateInput(key);
    },
    // The CUSTOM_CHECKBOX options to render: all of them while focused / empty /
    // editing; only the checked ones once collapsed.
    visibleCheckboxOptions(field) {
      const opts = field.custom_checkbox_options || [];
      if (!this.isCheckboxCollapsed(field)) {
        return opts;
      }
      const vals = this.field_values[field.key] || [];
      return opts.filter((o) => vals.indexOf(o.id) !== -1);
    },
    // The card shows only the OAs / user_test_tags still pending — once an item
    // is answered it's removed (fades out via oa-fade), matching "las opciones
    // usadas se eliminarán". When the last one goes the card itself completes
    // and fades (getVisibleEjes).
    visibleOas(field, eje) {
      const ejeKey = this.getEjeKey(eje);
      return (eje.oas || []).filter(
        (oa) => !this.getAchievementValue(field.key, ejeKey, oa.id)
      );
    },
    visibleUserTags(field, eje) {
      const ejeKey = this.getEjeKey(eje);
      return (eje.user_test_tags || []).filter(
        (oa) => !this.getAchievementValue(field.key, ejeKey, oa.id)
      );
    },
    // True once every OA / user_test_tag in the card has an achievement value
    // (an empty card never counts as complete, so it stays visible).
    isEjeComplete(field, eje) {
      const oas = eje.oas || [];
      const tags = eje.user_test_tags || [];
      if (oas.length + tags.length === 0) {
        return false;
      }
      const ejeKey = this.getEjeKey(eje);
      return [...oas, ...tags].every(
        (item) => !!this.getAchievementValue(field.key, ejeKey, item.id)
      );
    },
    // The cards actually rendered: filtered ejes minus the completed ones, so
    // a card fades out (eje-fade transition) once all its options are answered.
    // The surrounding section panel is NOT affected — it stays open until the
    // user presses "Continuar" (driven by revealedTextInput, not card state).
    getVisibleEjes(field) {
      return this.getFilteredEjes(field).filter(
        (eje) => !this.isEjeComplete(field, eje)
      );
    },
    resetSubareaFilter(fieldKey) {
      this.$set(this.ejesSubarea, fieldKey, null);
    },
    domainIntroFromCounts(domain, L, P, N) {
      const d = this.capitalizeFirst(domain);
      if (L > 0 && P === 0 && N === 0) {
        return `En ${d}, se observa un desempeño sólido en los ejes evaluados.`;
      }
      if (L > 0 && P > 0 && N === 0) {
        return `En ${d}, se observan fortalezas y habilidades en consolidación.`;
      }
      if (L > 0 && N > 0 && P === 0) {
        return `En ${d}, se observan avances junto con aspectos específicos por reforzar.`;
      }
      if (L === 0 && (P > 0 || N > 0)) {
        return `En ${d}, se observan habilidades en desarrollo; a continuación se detallan focos de apoyo.`;
      }
      return `En ${d}, se observan avances con fortalezas, habilidades en consolidación y aspectos por reforzar.`;
    },
    updateEjeSection(fieldKey, targetEjeKey) {
      // Find the field to get ejes data
      let field = null;
      this.document.document_template.pages[this.pageIndex].rows.forEach(row => {
        row.fields.forEach(f => {
          if (f.key === fieldKey && f.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) {
            field = f;
          }
        });
      });

      if (!field || !field.ejes) {
        return;
      }

      const achievementsKey = `${fieldKey}_achievements`;
      const achievements = this.field_values[achievementsKey] || {};
      const currentText = this.field_values[fieldKey] || '';

      // Get current level
      const currentLevel = this.ejesLevel[fieldKey];
      const filteredEjes = field.ejes.filter(e => e.level === currentLevel);

      // Find the specific eje we're updating
      let targetEje = null;
      filteredEjes.forEach(eje => {
        const ejeKey = this.getEjeKey(eje);
        if (ejeKey === targetEjeKey) {
          targetEje = eje;
        }
      });

      if (!targetEje) {
        return;
      }

      const ejeKey = this.getEjeKey(targetEje);

      // Collect achievements for this specific eje
      const ejeData = {
        name: targetEje.name,
        L: [],
        P: [],
        N: []
      };
      const domainName = targetEje.subarea || 'otros';

      // Process regular OAs
      if (targetEje.oas && targetEje.oas.length > 0) {
        targetEje.oas.forEach(oa => {
          const key = `${ejeKey}_${oa.id}`;
          const achievement = achievements[key];
          if (achievement) {
            const oaText = oa.name || oa.description || '';
            if (oaText) {
              ejeData[achievement].push(oaText);
            }
          }
        });
      }

      // Process user_test_tags
      if (targetEje.user_test_tags && targetEje.user_test_tags.length > 0) {
        targetEje.user_test_tags.forEach(oa => {
          const key = `${ejeKey}_${oa.id}`;
          const achievement = achievements[key];
          if (achievement) {
            const oaText = oa.name || '';
            if (oaText) {
              ejeData[achievement].push(oaText);
            }
          }
        });
      }

      const hasL = ejeData.L.length > 0;
      const hasP = ejeData.P.length > 0;
      const hasN = ejeData.N.length > 0;

      // New format intro phrases
      const introL = 'Entre los elementos logrados se encuentran ';
      const introP = 'Los elementos logrados parcialmente y que hay que reforzar son ';
      const introN = 'Se necesita trabajar y reforzar para lograr ';

      if (!hasL && !hasP && !hasN) {
        // Remove eje section if no achievements
        const ejeNameEscapedForRemoval = this.escapeRegex(targetEje.name);
        const ejeSectionPattern = new RegExp(
          `(^|\\n)${ejeNameEscapedForRemoval}\\s*\\n[^\\n]*(?:\\n(?!${ejeNameEscapedForRemoval}|En [^,\\n]+|\\n\\n)[^\\n]*)*`,
          'm'
        );
        if (ejeSectionPattern.test(currentText)) {
          const cleaned = currentText.replace(ejeSectionPattern, (match, prefix) => {
            return prefix === '\n' ? '' : '';
          });
          this.$set(this.field_values, fieldKey, cleaned.trim());
        }
        return;
      }

      const ejeNameEscaped = this.escapeRegex(targetEje.name);
      const ejeTitlePattern = new RegExp(`(^|\\n)${ejeNameEscaped}\\s*\\n`, 'm');
      
      // Find eje title in the text
      if (ejeTitlePattern.test(currentText)) {
        const titleMatch = currentText.match(ejeTitlePattern);
        if (titleMatch) {
          const titleIndex = titleMatch.index;
          const titleEndIndex = titleIndex + titleMatch[0].length;
          
          // Find the end of the paragraph section
          const afterTitle = currentText.substring(titleEndIndex);
          const paragraphEndMatch = afterTitle.match(/\n\n+|\nEn [^,\n]+,|\n([A-ZÁÉÍÓÚÑ][^\n]+)\n/);
          const paragraphEndIndex = paragraphEndMatch 
            ? titleEndIndex + paragraphEndMatch.index 
            : currentText.length;
          
          // Get the existing paragraph text
          let existingParagraph = currentText.substring(titleEndIndex, paragraphEndIndex).trim();
          existingParagraph = existingParagraph.replace(/^\n+|\n+$/g, '');
          
          // Parse existing sections and extract user content
          const parsedSections = this.parseEjeParagraph(existingParagraph, introL, introP, introN);
          
          // Get all OAs for this eje to check if they're already in sections
          const allOAs = [];
          if (targetEje.oas && targetEje.oas.length > 0) {
            targetEje.oas.forEach(oa => {
              allOAs.push({
                text: oa.name || oa.description || '',
                id: oa.id
              });
            });
          }
          if (targetEje.user_test_tags && targetEje.user_test_tags.length > 0) {
            targetEje.user_test_tags.forEach(oa => {
              allOAs.push({
                text: oa.name || '',
                id: oa.id
              });
            });
          }
          
          // Remove items from old sections if they're being moved
          // Check each OA in current achievements to see if it's in a different section
          const itemsToRemoveFromL = new Set();
          const itemsToRemoveFromP = new Set();
          const itemsToRemoveFromN = new Set();
          
          allOAs.forEach(oa => {
            const key = `${ejeKey}_${oa.id}`;
            const currentAchievement = achievements[key];
            if (!currentAchievement) {
              // No current achievement - remove from all sections if found
              parsedSections.L.items.forEach(item => {
                if (this.itemsMatch(item, oa.text)) {
                  itemsToRemoveFromL.add(item);
                }
              });
              parsedSections.P.items.forEach(item => {
                if (this.itemsMatch(item, oa.text)) {
                  itemsToRemoveFromP.add(item);
                }
              });
              parsedSections.N.items.forEach(item => {
                if (this.itemsMatch(item, oa.text)) {
                  itemsToRemoveFromN.add(item);
                }
              });
              return;
            }
            
            // Check if this OA text is in any section
            parsedSections.L.items.forEach(item => {
              if (this.itemsMatch(item, oa.text)) {
                if (currentAchievement !== 'L') {
                  itemsToRemoveFromL.add(item);
                }
              }
            });
            parsedSections.P.items.forEach(item => {
              if (this.itemsMatch(item, oa.text)) {
                if (currentAchievement !== 'P') {
                  itemsToRemoveFromP.add(item);
                }
              }
            });
            parsedSections.N.items.forEach(item => {
              if (this.itemsMatch(item, oa.text)) {
                if (currentAchievement !== 'N') {
                  itemsToRemoveFromN.add(item);
                }
              }
            });
          });
          
          // Remove items from parsed sections
          parsedSections.L.items = parsedSections.L.items.filter(item => !itemsToRemoveFromL.has(item));
          parsedSections.P.items = parsedSections.P.items.filter(item => !itemsToRemoveFromP.has(item));
          parsedSections.N.items = parsedSections.N.items.filter(item => !itemsToRemoveFromN.has(item));
          
          // Add current achievement items to appropriate sections (if not already present)
          ejeData.L.forEach(item => {
            const alreadyPresent = parsedSections.L.items.some(existing => this.itemsMatch(existing, item));
            if (!alreadyPresent) {
              parsedSections.L.items.push(item);
            }
          });
          ejeData.P.forEach(item => {
            const alreadyPresent = parsedSections.P.items.some(existing => this.itemsMatch(existing, item));
            if (!alreadyPresent) {
              parsedSections.P.items.push(item);
            }
          });
          ejeData.N.forEach(item => {
            const alreadyPresent = parsedSections.N.items.some(existing => this.itemsMatch(existing, item));
            if (!alreadyPresent) {
              parsedSections.N.items.push(item);
            }
          });
          
          // Build new paragraph with updated sections and preserved user content
          let newParagraph = '';
          
          // L section
          if (parsedSections.L.items.length > 0) {
            newParagraph += introL;
            parsedSections.L.items.forEach((item, idx) => {
              newParagraph += item;
              if (idx < parsedSections.L.items.length - 1) {
                if (parsedSections.L.items.length === 2 && idx === 0) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.L.items[1])} `;
                } else if (idx === parsedSections.L.items.length - 2) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.L.items[parsedSections.L.items.length - 1])} `;
                } else {
                  newParagraph += ', ';
                }
              }
            });
            newParagraph += '.';
          }
          
          // P section
          if (parsedSections.P.items.length > 0) {
            if (parsedSections.L.items.length > 0) {
              newParagraph += ' ';
            }
            newParagraph += introP;
            parsedSections.P.items.forEach((item, idx) => {
              newParagraph += item;
              if (idx < parsedSections.P.items.length - 1) {
                if (parsedSections.P.items.length === 2 && idx === 0) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.P.items[1])} `;
                } else if (idx === parsedSections.P.items.length - 2) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.P.items[parsedSections.P.items.length - 1])} `;
                } else {
                  newParagraph += ', ';
                }
              }
            });
            newParagraph += '.';
          }
          
          // N section
          if (parsedSections.N.items.length > 0) {
            if (parsedSections.L.items.length > 0 || parsedSections.P.items.length > 0) {
              newParagraph += ' ';
            }
            newParagraph += introN;
            parsedSections.N.items.forEach((item, idx) => {
              newParagraph += item;
              if (idx < parsedSections.N.items.length - 1) {
                if (parsedSections.N.items.length === 2 && idx === 0) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.N.items[1])} `;
                } else if (idx === parsedSections.N.items.length - 2) {
                  newParagraph += ` ${this.pickConjunction(parsedSections.N.items[parsedSections.N.items.length - 1])} `;
                } else {
                  newParagraph += ', ';
                }
              }
            });
            newParagraph += '.';
          }
          
          // Append user content (everything after the last dot of structured sections)
          if (parsedSections.userContent) {
            if (newParagraph) {
              newParagraph += ' ' + parsedSections.userContent;
            } else {
              newParagraph = parsedSections.userContent;
            }
          }
          
          // Replace the paragraph
          const before = currentText.substring(0, titleEndIndex);
          const after = currentText.substring(paragraphEndIndex);
          
          let newText = before + newParagraph;
          
          if (after && after.trim()) {
            if (!after.startsWith('\n\n')) {
              newText += '\n\n';
            }
          }
          newText += after;
          
          newText = newText.replace(/\n{3,}/g, '\n\n').trim();
          this.$set(this.field_values, fieldKey, newText);
          
          // Update domain intro based on current achievement counts
          this.$nextTick(() => {
            this.updateDomainIntro(fieldKey, domainName, this.field_values[fieldKey], filteredEjes, achievements);
          });
          return;
        }
      }

      // Eje section doesn't exist, create it with new format
      // Build the eje paragraph
      let newParagraph = '';
      
      if (hasL) {
        newParagraph += introL;
        ejeData.L.forEach((item, idx) => {
          newParagraph += item;
          if (idx < ejeData.L.length - 1) {
            if (ejeData.L.length === 2 && idx === 0) {
              newParagraph += ` ${this.pickConjunction(ejeData.L[1])} `;
            } else if (idx === ejeData.L.length - 2) {
              newParagraph += ` ${this.pickConjunction(ejeData.L[ejeData.L.length - 1])} `;
            } else {
              newParagraph += ', ';
            }
          }
        });
        newParagraph += '.';
      }
      
      if (hasP) {
        if (hasL) {
          newParagraph += ' ';
        }
        newParagraph += introP;
        ejeData.P.forEach((item, idx) => {
          newParagraph += item;
          if (idx < ejeData.P.length - 1) {
            if (ejeData.P.length === 2 && idx === 0) {
              newParagraph += ` ${this.pickConjunction(ejeData.P[1])} `;
            } else if (idx === ejeData.P.length - 2) {
              newParagraph += ` ${this.pickConjunction(ejeData.P[ejeData.P.length - 1])} `;
            } else {
              newParagraph += ', ';
            }
          }
        });
        newParagraph += '.';
      }
      
      if (hasN) {
        if (hasL || hasP) {
          newParagraph += ' ';
        }
        newParagraph += introN;
        ejeData.N.forEach((item, idx) => {
          newParagraph += item;
          if (idx < ejeData.N.length - 1) {
            if (ejeData.N.length === 2 && idx === 0) {
              newParagraph += ` ${this.pickConjunction(ejeData.N[1])} `;
            } else if (idx === ejeData.N.length - 2) {
              newParagraph += ` ${this.pickConjunction(ejeData.N[ejeData.N.length - 1])} `;
            } else {
              newParagraph += ', ';
            }
          }
        });
        newParagraph += '.';
      }
      
      const newEjeSection = `${targetEje.name}\n${newParagraph}`;

      // Step 1: Calculate domain-level counts including this new eje
      // Use targetEje.subarea to ensure we're using the correct subject
      let domainL = 0, domainP = 0, domainN = 0;
      filteredEjes.forEach(eje => {
        const ejeDomain = (eje.subarea || 'otros').toLowerCase();
        if (ejeDomain !== domainName.toLowerCase()) return;
        const loopEjeKey = this.getEjeKey(eje);
        (eje.oas || []).forEach(oa => {
          const ach = achievements[`${loopEjeKey}_${oa.id}`];
          if (ach === 'L') domainL += 1;
          else if (ach === 'P') domainP += 1;
          else if (ach === 'N') domainN += 1;
        });
        (eje.user_test_tags || []).forEach(oa => {
          const ach = achievements[`${loopEjeKey}_${oa.id}`];
          if (ach === 'L') domainL += 1;
          else if (ach === 'P') domainP += 1;
          else if (ach === 'N') domainN += 1;
        });
      });
      
      // Step 2: Find the SPECIFIC domain intro line for this domain (using targetEje.subarea)
      // Search for all domain intros and find the one matching this domain
      const allDomainIntroPattern = /(^|\n)(En [^,]+, [^.]+\.)/gmi;
      let domainIntroMatch = null;
      let domainIntroIndex = -1;
      let domainIntroLength = 0;
      
      allDomainIntroPattern.lastIndex = 0;
      let match;
      while ((match = allDomainIntroPattern.exec(currentText)) !== null) {
        const fullMatch = match[0]; // Includes newline if present
        const introText = match[2]; // Just the intro text "En X, ..."
        
        // Extract domain name from intro
        const domainMatch = introText.match(/En ([^,]+),/i);
        if (domainMatch) {
          const matchedDomain = domainMatch[1].trim().toLowerCase();
          // Compare with targetEje's subarea (case-insensitive)
          if (matchedDomain === domainName.toLowerCase()) {
            domainIntroMatch = match;
            domainIntroIndex = match.index;
            domainIntroLength = fullMatch.length;
            break; // Found the correct domain intro
          }
        }
      }
      
      const isSubjectPresent = !!domainIntroMatch;
      let newText = '';
      
      if (isSubjectPresent) {
        // Subject is present
        // Step 3: Update the domain intro with new achievement counts
        const capitalizedDomain = this.capitalizeFirst(domainName);
        const newDomainIntro = this.domainIntroFromCounts(capitalizedDomain, domainL, domainP, domainN);
        
        // Replace the existing domain intro
        const beforeIntro = currentText.substring(0, domainIntroIndex);
        const afterIntro = currentText.substring(domainIntroIndex + domainIntroLength);
        const prefix = domainIntroMatch[1] === '\n' ? '\n' : '';
        let updatedText = beforeIntro + prefix + newDomainIntro + afterIntro;
        
        // Calculate the position right after the updated domain intro
        const introEndPos = beforeIntro.length + prefix.length + newDomainIntro.length;
        
        // Step 4: Check if eje is present between the already present ejes of the subject
        const ejeNameEscaped = this.escapeRegex(targetEje.name);
        const ejeTitlePattern = new RegExp(`(^|\\n)${ejeNameEscaped}\\s*\\n`, 'm');
        
        // Find where this domain's section ends (before the next domain intro)
        const nextDomainIntroPattern = /(^|\n)(En [^,]+, [^.]+\.)/gmi;
        let nextDomainIntroIndex = updatedText.length;
        nextDomainIntroPattern.lastIndex = 0;
        let nextMatch;
        while ((nextMatch = nextDomainIntroPattern.exec(updatedText)) !== null) {
          const nextIntroText = nextMatch[2];
          const nextDomainMatch = nextIntroText.match(/En ([^,]+),/i);
          if (nextDomainMatch) {
            const nextDomain = nextDomainMatch[1].trim().toLowerCase();
            // This is a different domain that comes after our domain intro
            if (nextDomain !== domainName.toLowerCase() && nextMatch.index > introEndPos) {
              if (nextMatch.index < nextDomainIntroIndex) {
                nextDomainIntroIndex = nextMatch.index;
              }
            }
          }
        }
        
        // Check if eje exists within this domain's section
        const ejeMatch = updatedText.match(ejeTitlePattern);
        const ejePresent = ejeMatch && ejeMatch.index >= introEndPos && ejeMatch.index < nextDomainIntroIndex;
        
        if (!ejePresent) {
          // Eje is not present - add it right after the subject intro (most recent first)
          const before = updatedText.substring(0, introEndPos);
          const after = updatedText.substring(introEndPos);
          newText = `${before}\n\n${newEjeSection}${after.trim() ? '\n\n' + after.trim() : ''}`;
        } else {
          // Eje is already present - this shouldn't happen here (should be handled above)
          // But if it does, just use the updated text
          newText = updatedText;
        }
      } else {
        // Subject is not present
        // Compute domain-level counts for the intro
        let domainL = 0, domainP = 0, domainN = 0;
        filteredEjes.forEach(eje => {
          if ((eje.subarea || 'otros').toLowerCase() !== domainName.toLowerCase()) return;
          const loopEjeKey = this.getEjeKey(eje);
          (eje.oas || []).forEach(oa => {
            const ach = achievements[`${loopEjeKey}_${oa.id}`];
            if (ach === 'L') domainL += 1;
            else if (ach === 'P') domainP += 1;
            else if (ach === 'N') domainN += 1;
          });
          (eje.user_test_tags || []).forEach(oa => {
            const ach = achievements[`${loopEjeKey}_${oa.id}`];
            if (ach === 'L') domainL += 1;
            else if (ach === 'P') domainP += 1;
            else if (ach === 'N') domainN += 1;
          });
        });
        
        const domainIntro = (domainL > 0 || domainP > 0 || domainN > 0)
          ? this.domainIntroFromCounts(domainName, domainL, domainP, domainN)
          : null;
        
        if (currentText.trim() === '') {
          // Text is empty: Add subject intro and eje at the beginning
          if (domainIntro) {
            newText = `${domainIntro}\n\n${newEjeSection}`;
          } else {
            newText = newEjeSection;
          }
        } else {
          // Text is not empty: Add subject intro at the end, then add eje after the intro
          if (domainIntro) {
            newText = `${currentText}\n\n${domainIntro}\n\n${newEjeSection}`;
          } else {
            newText = `${currentText}\n\n${newEjeSection}`;
          }
        }
      }
      
      newText = newText.replace(/\n{3,}/g, '\n\n').trim();
      this.$set(this.field_values, fieldKey, newText);
      
      // Update domain intro based on current achievement counts
      // Update all domain intros, not just the current one
      this.$nextTick(() => {
        const currentFieldText = this.field_values[fieldKey] || '';
        this.updateDomainIntro(fieldKey, null, currentFieldText, filteredEjes, achievements);
        this.autoGrowAllTextareas();
      });
    },
    updateDomainIntro(fieldKey, domainName, currentText, filteredEjes, achievements) {
      // Update ALL domain intros in the text, not just one
      // Get all unique domains (subareas) from filtered ejes with their original names
      const domainMap = new Map(); // normalized -> original
      filteredEjes.forEach(eje => {
        const domain = eje.subarea || 'otros';
        const normalizedDomain = domain.toLowerCase();
        if (!domainMap.has(normalizedDomain)) {
          domainMap.set(normalizedDomain, domain);
        }
      });
      
      let updatedText = currentText || this.field_values[fieldKey] || '';
      
      // Process each domain
      domainMap.forEach((originalDomain, normalizedDomain) => {
        // Calculate domain-level achievement counts for all ejes in this domain
        let domainL = 0, domainP = 0, domainN = 0;
        
        filteredEjes.forEach(eje => {
          const ejeDomain = (eje.subarea || 'otros').toLowerCase();
          // Case-insensitive comparison for domain matching
          if (ejeDomain !== normalizedDomain) return;
          const loopEjeKey = this.getEjeKey(eje);
          
          // Count from regular OAs
          (eje.oas || []).forEach(oa => {
            const ach = achievements[`${loopEjeKey}_${oa.id}`];
            if (ach === 'L') domainL += 1;
            else if (ach === 'P') domainP += 1;
            else if (ach === 'N') domainN += 1;
          });
          
          // Count from user_test_tags
          (eje.user_test_tags || []).forEach(oa => {
            const ach = achievements[`${loopEjeKey}_${oa.id}`];
            if (ach === 'L') domainL += 1;
            else if (ach === 'P') domainP += 1;
            else if (ach === 'N') domainN += 1;
          });
        });
        
        // Find existing domain intro line using regex (case-insensitive)
        // Pattern: "En [domain], [text]." (can be at start of line or after newline)
        const domainNameEscaped = this.escapeRegex(originalDomain);
        // Match "En Lenguaje" or "En lenguaje" etc. (case-insensitive)
        const domainIntroPattern = new RegExp(`(^|\\n)En ${domainNameEscaped}, [^.]+.`, 'mi');
        
        if (domainL > 0 || domainP > 0 || domainN > 0) {
          // Domain has achievements, update or add intro
          // Use capitalized domain name for the intro text
          const capitalizedDomain = this.capitalizeFirst(originalDomain);
          const newDomainIntro = this.domainIntroFromCounts(capitalizedDomain, domainL, domainP, domainN);
          
          if (domainIntroPattern.test(updatedText)) {
            // Replace existing domain intro (preserve newline before if exists)
            const match = updatedText.match(domainIntroPattern);
            if (match) {
              const before = updatedText.substring(0, match.index);
              const after = updatedText.substring(match.index + match[0].length);
              const prefix = match[1] === '\n' ? '\n' : '';
              updatedText = before + prefix + newDomainIntro + after;
            }
          } else {
            // Domain intro doesn't exist, find where to add it
            // Look for first eje of this domain
            let firstEjeIndex = -1;
            
            filteredEjes.forEach(eje => {
              const ejeDomain = (eje.subarea || 'otros').toLowerCase();
              if (ejeDomain !== normalizedDomain) return;
              const ejeNameEscaped = this.escapeRegex(eje.name);
              const ejePattern = new RegExp(`^${ejeNameEscaped}\\s*$`, 'm');
              const match = updatedText.match(ejePattern);
              if (match && (firstEjeIndex === -1 || match.index < firstEjeIndex)) {
                firstEjeIndex = match.index;
              }
            });
            
            if (firstEjeIndex > -1) {
              // Insert domain intro before first eje
              const before = updatedText.substring(0, firstEjeIndex);
              const after = updatedText.substring(firstEjeIndex);
              updatedText = `${before}${newDomainIntro}\n\n${after}`;
            } else {
              // No eje found, add at the beginning if text exists
              if (updatedText.trim()) {
                updatedText = `${newDomainIntro}\n\n${updatedText}`;
              } else {
                updatedText = newDomainIntro;
              }
            }
          }
        } else {
          // No achievements for this domain, remove domain intro if it exists
          if (domainIntroPattern.test(updatedText)) {
            const match = updatedText.match(domainIntroPattern);
            if (match) {
              const before = updatedText.substring(0, match.index);
              const after = updatedText.substring(match.index + match[0].length);
              // Remove the intro and clean up extra newlines
              updatedText = before + after;
              updatedText = updatedText.replace(/\n{3,}/g, '\n\n').trim();
            }
          }
        }
      });
      
      // Update the field value with all domain intros updated
      if (updatedText !== currentText) {
        this.$set(this.field_values, fieldKey, updatedText);
      }
    },
    async clearEjesAchievements(fieldKey, field) {
      try {
        await documentOnlineService.clearElementAchievements({
          field_key: fieldKey,
          document_id: this.document.id
        });

        const achievementsKey = `${fieldKey}_achievements`;
        this.$set(this.field_values, achievementsKey, {});

        // Remove structured sections for current level ejes
        const currentLevel = this.ejesLevel[fieldKey];
        const ejes = (field && field.ejes ? field.ejes : []).filter(e => e.level === currentLevel);
        ejes.forEach(eje => {
          this.updateEjeSection(fieldKey, this.getEjeKey(eje));
        });

        this.updateInput(fieldKey);
        this.$toasted.success("Logros reiniciados.");
      } catch (error) {
        this.$toasted.error("No se pudo reiniciar los logros.");
        console.error("Error clearing achievements:", error);
      }
    },
    generateEjesAchievementText(fieldKey) {
      // Find the field to get ejes data
      let field = null;
      this.document.document_template.pages[this.pageIndex].rows.forEach(row => {
        row.fields.forEach(f => {
          if (f.key === fieldKey && f.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) {
            field = f;
          }
        });
      });

      if (!field || !field.ejes) {
        return;
      }

      const achievementsKey = `${fieldKey}_achievements`;
      const achievements = this.field_values[achievementsKey] || {};
      const currentText = this.field_values[fieldKey] || '';

      // Organize achievements by domain (subarea) -> eje -> achievement level -> OA text
      const domainData = {};

      // Get current level
      const currentLevel = this.ejesLevel[fieldKey];
      const filteredEjes = field.ejes.filter(e => e.level === currentLevel);

      filteredEjes.forEach(eje => {
        const ejeKey = this.getEjeKey(eje);
        const domain = eje.subarea || 'otros';
        
        if (!domainData[domain]) {
          domainData[domain] = {};
        }

        // Process regular OAs
        if (eje.oas && eje.oas.length > 0) {
          eje.oas.forEach(oa => {
            const key = `${ejeKey}_${oa.id}`;
            const achievement = achievements[key];
            if (achievement) {
              if (!domainData[domain][ejeKey]) {
                domainData[domain][ejeKey] = {
                  name: eje.name,
                  L: [],
                  P: [],
                  N: []
                };
              }
              const oaText = oa.name || oa.description || '';
              if (oaText) {
                domainData[domain][ejeKey][achievement].push(oaText);
              }
            }
          });
        }

        // Process user_test_tags
        if (eje.user_test_tags && eje.user_test_tags.length > 0) {
          eje.user_test_tags.forEach(oa => {
            const key = `${ejeKey}_${oa.id}`;
            const achievement = achievements[key];
            if (achievement) {
              if (!domainData[domain][ejeKey]) {
                domainData[domain][ejeKey] = {
                  name: eje.name,
                  L: [],
                  P: [],
                  N: []
                };
              }
              const oaText = oa.name || '';
              if (oaText) {
                domainData[domain][ejeKey][achievement].push(oaText);
              }
            }
          });
        }
      });

      // Smart update: only modify eje sections that have achievements, preserve everything else
      let updatedText = currentText;
      
      // Process each domain and eje
      Object.keys(domainData).forEach(domain => {
        const ejes = domainData[domain];
        const ejeKeys = Object.keys(ejes);

        if (ejeKeys.length === 0) return;

        // Count achievements per domain for domain intro
        let domainL = 0, domainP = 0, domainN = 0;
        ejeKeys.forEach(ejeKey => {
          domainL += ejes[ejeKey].L.length;
          domainP += ejes[ejeKey].P.length;
          domainN += ejes[ejeKey].N.length;
        });

        // Process each eje in the domain
        ejeKeys.forEach(ejeKey => {
          const ejeData = ejes[ejeKey];
          const hasL = ejeData.L.length > 0;
          const hasP = ejeData.P.length > 0;
          const hasN = ejeData.N.length > 0;

          // Build the new paragraph for this eje using new format
          const introL = 'Entre los elementos logrados se encuentran ';
          const introP = 'Los elementos logrados parcialmente y que hay que reforzar son ';
          const introN = 'Se necesita trabajar y reforzar para lograr ';
          
          let paragraph = '';

          if (!hasL && !hasP && !hasN) {
            // Remove eje section if no achievements
            const ejeNameEscaped = this.escapeRegex(ejeData.name);
            const ejeSectionPattern = new RegExp(
              `\\n?${ejeNameEscaped}\\s*\\n[^\\n]*(?:\\n(?!${ejeNameEscaped}|En [^,]+|\\n)[^\\n]*)*`,
              'g'
            );
            updatedText = updatedText.replace(ejeSectionPattern, '');
            return;
          }

          // L section
          if (hasL) {
            paragraph += introL;
            ejeData.L.forEach((item, idx) => {
              paragraph += item;
              if (idx < ejeData.L.length - 1) {
                if (ejeData.L.length === 2 && idx === 0) {
                  paragraph += ` ${this.pickConjunction(ejeData.L[1])} `;
                } else if (idx === ejeData.L.length - 2) {
                  paragraph += ` ${this.pickConjunction(ejeData.L[ejeData.L.length - 1])} `;
                } else {
                  paragraph += ', ';
                }
              }
            });
            paragraph += '.';
          }

          // P section
          if (hasP) {
            if (hasL) {
              paragraph += ' ';
            }
            paragraph += introP;
            ejeData.P.forEach((item, idx) => {
              paragraph += item;
              if (idx < ejeData.P.length - 1) {
                if (ejeData.P.length === 2 && idx === 0) {
                  paragraph += ` ${this.pickConjunction(ejeData.P[1])} `;
                } else if (idx === ejeData.P.length - 2) {
                  paragraph += ` ${this.pickConjunction(ejeData.P[ejeData.P.length - 1])} `;
                } else {
                  paragraph += ', ';
                }
              }
            });
            paragraph += '.';
          }

          // N section
          if (hasN) {
            if (hasL || hasP) {
              paragraph += ' ';
            }
            paragraph += introN;
            ejeData.N.forEach((item, idx) => {
              paragraph += item;
              if (idx < ejeData.N.length - 1) {
                if (ejeData.N.length === 2 && idx === 0) {
                  paragraph += ` ${this.pickConjunction(ejeData.N[1])} `;
                } else if (idx === ejeData.N.length - 2) {
                  paragraph += ` ${this.pickConjunction(ejeData.N[ejeData.N.length - 1])} `;
                } else {
                  paragraph += ', ';
                }
              }
            });
            paragraph += '.';
          }

          const newEjeSection = `${ejeData.name}\n${paragraph}`;
          const ejeNameEscaped = this.escapeRegex(ejeData.name);

          // Try to find existing eje section (title on its own line, followed by paragraph)
          // Match: eje title line + paragraph until next eje title, domain intro, double newline, or end
          const ejeTitlePattern = new RegExp(`^${ejeNameEscaped}\\s*$`, 'm');
          const ejeSectionPattern = new RegExp(
            `(${ejeNameEscaped}\\s*\\n)([^\\n]*(?:\\n(?!${ejeNameEscaped}|En [^,]+|\\n\\n)[^\\n]*)*)`,
            'm'
          );

          if (ejeSectionPattern.test(updatedText)) {
            // Replace existing eje section (title + paragraph only)
            updatedText = updatedText.replace(ejeSectionPattern, newEjeSection);
          } else if (ejeTitlePattern.test(updatedText)) {
            // Eje title exists but we need to replace just the paragraph part
            const titleMatch = updatedText.match(ejeTitlePattern);
            if (titleMatch) {
              const titleIndex = titleMatch.index + titleMatch[0].length;
              // Find where the paragraph ends (next eje title, domain intro, double newline, or end)
              const restOfText = updatedText.substring(titleIndex);
              const paragraphEndMatch = restOfText.match(/\n\n|\n(En [^,]+)|\n([A-Z][^\n]+\n)/);
              const paragraphEnd = paragraphEndMatch ? titleIndex + paragraphEndMatch.index : updatedText.length;
              
              // Replace from after title to paragraph end
              updatedText = updatedText.substring(0, titleIndex) + '\n' + paragraph + updatedText.substring(paragraphEnd);
            }
          } else {
            // Eje section doesn't exist, append it
            // First check if domain intro exists
            const domainIntroPattern = new RegExp(`(En ${this.escapeRegex(domain)}, [^\\n]+\\n\\n)`, 'm');
            
            if (domainIntroPattern.test(updatedText)) {
              // Insert after domain intro
              updatedText = updatedText.replace(domainIntroPattern, `$1${newEjeSection}\n\n`);
            } else {
              // Check if we need domain intro
              if (domainL > 0 || domainP > 0 || domainN > 0) {
                const domainIntro = this.domainIntroFromCounts(domain, domainL, domainP, domainN);
                // Check if any eje from this domain already exists
                const hasDomainEje = ejeKeys.some(ek => {
                  const otherEjeName = this.escapeRegex(ejes[ek].name);
                  return new RegExp(`^${otherEjeName}\\s*$`, 'm').test(updatedText);
                });
                
                if (hasDomainEje) {
                  // Insert before first eje of this domain
                  const firstEjeName = this.escapeRegex(ejes[ejeKeys[0]].name);
                  const firstEjePattern = new RegExp(`(${firstEjeName})`, 'm');
                  if (firstEjePattern.test(updatedText)) {
                    updatedText = updatedText.replace(firstEjePattern, `${domainIntro}\n\n$1`);
                  }
                } else {
                  // Add domain intro and eje section at the end
                  if (updatedText.trim()) {
                    updatedText += `\n\n${domainIntro}\n\n${newEjeSection}`;
                  } else {
                    updatedText = `${domainIntro}\n\n${newEjeSection}`;
                  }
                }
              } else {
                // Just add eje section at the end
                if (updatedText.trim()) {
                  updatedText += `\n\n${newEjeSection}`;
                } else {
                  updatedText = newEjeSection;
                }
              }
            }
          }
        });

        // Update domain intro if it exists
        if (domainL > 0 || domainP > 0 || domainN > 0) {
          const domainIntro = this.domainIntroFromCounts(domain, domainL, domainP, domainN);
          const domainIntroPattern = new RegExp(`(En ${this.escapeRegex(domain)}, [^\\n]+)`, 'm');
          
          if (domainIntroPattern.test(updatedText)) {
            updatedText = updatedText.replace(domainIntroPattern, domainIntro);
          }
        }
      });

      // Clean up extra newlines (max 2 consecutive)
      updatedText = updatedText.replace(/\n{3,}/g, '\n\n').trim();

      // Update the textarea value
      this.$set(this.field_values, fieldKey, updatedText);
    },
    escapeRegex(str) {
      // Escape special regex characters
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    parseEjeParagraph(paragraph, introL, introP, introN) {
      // Parse paragraph to extract L, P, N sections and user content
      const result = {
        L: { present: false, items: [] },
        P: { present: false, items: [] },
        N: { present: false, items: [] },
        userContent: ''
      };
      
      // Extract L section
      const lPattern = new RegExp(`${this.escapeRegex(introL)}([^.]+)\\.`, 'g');
      const lMatch = lPattern.exec(paragraph);
      if (lMatch) {
        result.L.present = true;
        const lContent = lMatch[1].trim();
        // Split items more carefully - handle commas, "y", "e" but preserve item integrity
        result.L.items = this.extractItemsFromSection(lContent);
      }
      
      // Extract P section
      const pPattern = new RegExp(`${this.escapeRegex(introP)}([^.]+)\\.`, 'g');
      const pMatch = pPattern.exec(paragraph);
      if (pMatch) {
        result.P.present = true;
        const pContent = pMatch[1].trim();
        result.P.items = this.extractItemsFromSection(pContent);
      }
      
      // Extract N section
      const nPattern = new RegExp(`${this.escapeRegex(introN)}([^.]+)\\.`, 'g');
      const nMatch = nPattern.exec(paragraph);
      if (nMatch) {
        result.N.present = true;
        const nContent = nMatch[1].trim();
        result.N.items = this.extractItemsFromSection(nContent);
      }
      
      // Find the last dot of structured sections
      // User content is everything after the last section's dot
      const lastSectionEnd = Math.max(
        lMatch ? lMatch.index + lMatch[0].length : -1,
        pMatch ? pMatch.index + pMatch[0].length : -1,
        nMatch ? nMatch.index + nMatch[0].length : -1
      );
      
      if (lastSectionEnd > -1) {
        // Extract user content after last section
        const afterLastSection = paragraph.substring(lastSectionEnd).trim();
        // Remove any leading spaces, dots, or newlines
        result.userContent = afterLastSection.replace(/^[\s.\n]+/, '').trim();
      } else {
        // No structured sections found, entire paragraph is user content
        result.userContent = paragraph.trim();
      }
      
      return result;
    },
    extractItemsFromSection(sectionContent) {
      // Extract items from a section, handling commas, "y", "e" as separators
      // This is a best-effort extraction - if items are edited, we preserve what we can find
      const items = [];
      
      // Try to split by common patterns: comma, " y ", " e "
      let remaining = sectionContent.trim();
      
      // Pattern to match separators: comma, or " y " / " e " (with spaces before and after)
      const separatorPattern = /(?:,\s*|\s+y\s+|\s+e\s+)/i;
      
      while (remaining.length > 0) {
        const match = remaining.search(separatorPattern);
        if (match > 0) {
          const item = remaining.substring(0, match).trim();
          if (item) {
            items.push(item);
          }
          // Find the end of the separator
          const separatorMatch = remaining.substring(match).match(separatorPattern);
          if (separatorMatch) {
            remaining = remaining.substring(match + separatorMatch[0].length).trim();
          } else {
            remaining = remaining.substring(match + 1).trim();
          }
        } else {
          // Last item or no separator found
          if (remaining) {
            items.push(remaining.trim());
          }
          break;
        }
      }
      
      return items.filter(item => item.length > 0);
    },
    itemsMatch(item1, item2) {
      // Check if two items match (handles user edits)
      // Normalize both items for comparison
      const normalize = (str) => str.toLowerCase().trim().replace(/\s+/g, ' ');
      const norm1 = normalize(item1);
      const norm2 = normalize(item2);
      
      // Exact match
      if (norm1 === norm2) return true;
      
      // One contains the other (handles partial matches from user edits)
      if (norm1.includes(norm2) || norm2.includes(norm1)) {
        // But only if the shorter one is at least 10 characters (avoid false matches)
        const shorter = norm1.length < norm2.length ? norm1 : norm2;
        if (shorter.length >= 10) {
          return true;
        }
      }
      
      return false;
    },
    autoGrowTextarea(event) {
      // Auto-resize textarea to fit content
      const textarea = event.target;
      if (!textarea) return;
      
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = 'auto';
      // Set height to scrollHeight (content height)
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    autoGrowAllTextareas() {
      // Auto-grow all textareas in the component
      this.$nextTick(() => {
        const textareas = this.$el.querySelectorAll('.auto-grow-textarea, textarea.form-control, b-textarea textarea');
        textareas.forEach(textarea => {
          if (textarea && !textarea.disabled) {
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
          }
        });
      });
    },
    addEjeOptionItem(fieldKey, ejeId) {
      const optionKey = `${fieldKey}_${ejeId}`;
      const val = this.addEjeOption[optionKey];
      if (val && val.trim()) {
        // Ensure field structure is correct
        this.ensureEjesAchievementStructure(fieldKey);
        
        // Store custom options in a separate key
        const customOptionsKey = `${fieldKey}_customOptions`;
        if (!this.field_values[customOptionsKey]) {
          this.$set(this.field_values, customOptionsKey, {});
        }
        if (!this.field_values[customOptionsKey][ejeId]) {
          this.$set(this.field_values[customOptionsKey], ejeId, []);
        }
        
        // Add the new option
        this.field_values[customOptionsKey][ejeId].push({
          id: Date.now(), // Temporary ID
          text: val.trim()
        });
        
        // Clear the input
        this.$set(this.addEjeOption, optionKey, "");
        this.updateInput(fieldKey);
        this.$toasted.success("Ítem agregado!");
      } else {
        this.$toasted.error("Ingresa un ítem!");
      }
    },
    openExtraOAs(extraOAs, key) {
      this.extraOAs = extraOAs;
      this.extraKey = key;
      this.subjectFilter = "";
      this.$refs["extra-oas-modal"].show();
    },
    updateOas(key, oaID) {
      if (oaID === this.oaClicked) {
        if (
          this.field_values[key]["oas"] &&
          this.field_values[key]["oas"].includes(oaID)
        ) {
          // this.field_values[key]["values"] = Object.assign(
          //   {},
          //   this.field_values[key]["values"],
          //   { [oaID]: { criteria: [], target: "" } }
          // );
          if (!this.field_values[key]["values"][oaID]) {
            this.$set(this.field_values[key]["values"], oaID, {
              criteria: [],
              criPro: [0],
              manual: "",
              select: "",
              target: "",
              mode: "manual",
            });
            this.updateInput(key);
          }
          // this.field_values[key]["values"][oaID] = { criteria: [], target: "" };
        } else {
          this.$delete(this.field_values[key]["values"], oaID);
          // const { [oaID], ...cleanObject} = this.field_values[key]["values"]
          // delete this.field_values[key]["values"][oaID];
          this.updateInput(key);
        }

        // this.updateInput(key);
      }
    },
    getSubject(oaName) {
      if (oaName.includes("LE")) {
        return "Lenguaje";
      } else if (oaName.includes("MA")) {
        return "Matemáticas";
      } else {
        return "OTRO - " + oaName.substring(0, 2);
      }
    },
    addSpecialOption() {
      documentOnlineService
        .addSpecialOption({
          key: this.selectedField.key,
          data: this.newOption,
          // the backend prefers the document's school (that is what filters the
          // list on read); the session school stays as a fallback.
          document: this.document ? this.document.id : null,
          school: this.$store.state.login.school,
        })
        .then((data) => {
          this.selectedField.special_select_options.push(data);
          // "Agregar" means "add this professional to THIS document": registering
          // the entry without selecting it left the checkbox unticked, so nothing
          // was ever saved and the person never reached the printed document.
          const key = this.selectedField.key;
          if (
            this.selectedField.kind === this.questionKinds.SPECIAL_MULTI_SELECTOR
          ) {
            const current = Array.isArray(this.field_values[key])
              ? this.field_values[key].slice()
              : [];
            if (!current.includes(data.id)) current.push(data.id);
            this.$set(this.field_values, key, current);
            this.updateInput(key);
          } else if (
            this.selectedField.kind === this.questionKinds.SPECIAL_SELECTOR
          ) {
            this.$set(this.field_values, key, data.id);
            this.updateInput(key);
          }
          this.$refs["adminSpecialModal"].hide();
        });
    },
    saveSpecialOption(payload) {
      documentOnlineService.saveSpecialOption(payload).then((data) => {
        this.$toasted.success(data.message);
      });
    },
    deleteSpecialOption(payload, index) {
      documentOnlineService.deleteSpecialOption(payload).then((data) => {
        this.selectedField.special_select_options.splice(index, 1);
        this.$toasted.success(data.message);
      });
    },
    openAddOption(field) {
      this.selectedField = field;
      this.selectedSelector = field.special_select_fields;
      this.newOption = {};
      this.$refs["adminSpecialModal"].show();
    },
    // SPECIAL_MULTI_SELECTOR: the value is an array of option ids.
    isMultiSelected(key, optionId) {
      const v = this.field_values[key];
      return Array.isArray(v) && v.includes(optionId);
    },
    onMultiSelectToggle(key, optionId) {
      const current = Array.isArray(this.field_values[key])
        ? this.field_values[key].slice()
        : [];
      const at = current.indexOf(optionId);
      if (at === -1) {
        current.push(optionId);
      } else {
        current.splice(at, 1);
      }
      this.$set(this.field_values, key, current);
      this.updateInput(key);
    },
    // Label = the declared sub-fields joined, e.g. "Ana Díaz — Fonoaudióloga".
    multiOptionLabel(field, option) {
      const parts = (field.special_select_fields || [])
        .map((f) => (option.data || {})[f])
        .filter((x) => x !== undefined && x !== null && String(x).trim() !== "");
      return parts.length ? parts.join(" — ") : "(sin datos)";
    },
    customUnblock(key, value) {
      this.touchedFields.push(key);
      this.unblockInput(key, value);
    },
    slugifyHeader(text) {
      const stripped = (text || "").replace(/^[IVX]+\.-?\s*/, "");
      const normalized = stripped
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");
      return normalized
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    computeAreas(page) {
      const areas = [];
      let current = null;
      for (const row of page.rows) {
        const firstField = row.fields && row.fields[0];
        const isHeader = firstField && firstField.is_title && firstField.style === 3;
        if (isHeader) {
          if (current) areas.push(current);
          const headerText = (firstField.text || firstField.name || "").trim();
          current = {
            headerRow: row,
            headerText,
            slug: this.slugifyHeader(headerText),
            lastRowId: row.id,
          };
        } else if (current) {
          current.lastRowId = row.id;
        }
      }
      if (current) areas.push(current);
      return areas;
    },
    areaEndingAt(rowId, pageId) {
      const areas = this.pageAreasByPageId[pageId] || [];
      return areas.find((a) => a.lastRowId === rowId);
    },
    headerAreaOf(rowId, pageId) {
      const areas = this.pageAreasByPageId[pageId] || [];
      return areas.find((a) => a.headerRow.id === rowId);
    },
    isMirrorAchievementField(field) {
      if (!field || !field.key) return false;
      const isMirror =
        field.key.startsWith("MARK_") || field.key.startsWith("SPECIALMARK_");
      return (
        isMirror &&
        (field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT ||
          field.kind === this.questionKinds.OA_ACHIEVEMENT)
      );
    },
    getAreaAchievementFields(area, page) {
      if (!area || !page || !page.rows) return [];
      const rows = page.rows;
      const startIdx = rows.findIndex((r) => r.id === area.headerRow.id);
      if (startIdx < 0) return [];
      const fields = [];
      for (let i = startIdx + 1; i < rows.length; i++) {
        const row = rows[i];
        const first = row.fields && row.fields[0];
        if (first && first.is_title && first.style === 3) break;
        (row.fields || []).forEach((field) => {
          if (this.isMirrorAchievementField(field)) fields.push(field);
        });
      }
      return fields;
    },
    isEmptyMirrorAchievementArea(area, page) {
      if (!this.isEdaDocument || this.is_backup || this.localMode) return false;
      const fields = this.getAreaAchievementFields(area, page);
      if (!fields.length) return false;
      return fields.every((field) => {
        if (field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT) {
          return !(field.checkbox_achievement_options || []).length;
        }
        if (field.kind === this.questionKinds.OA_ACHIEVEMENT) {
          return !(field.oa_achievement_options || []).length;
        }
        return true;
      });
    },
    shouldHideEmptyMirrorRow(row, page) {
      if (!this.isEdaDocument || this.is_backup || this.localMode || !page) {
        return false;
      }
      const areas = this.pageAreasByPageId[page.id] || [];
      const rowIdx = page.rows.findIndex((r) => r.id === row.id);
      if (rowIdx < 0) return false;
      for (const area of areas) {
        if (!this.isEmptyMirrorAchievementArea(area, page)) continue;
        const startIdx = page.rows.findIndex((r) => r.id === area.headerRow.id);
        if (rowIdx <= startIdx) continue;
        let endIdx = page.rows.length;
        for (let i = startIdx + 1; i < page.rows.length; i++) {
          const first = page.rows[i].fields && page.rows[i].fields[0];
          if (first && first.is_title && first.style === 3) {
            endIdx = i;
            break;
          }
        }
        if (rowIdx > startIdx && rowIdx < endIdx) return true;
      }
      return false;
    },
    stripEnumPrefix(text) {
      // Remove leading numbering such as "II.-", "III.-", "A)", "1." so the
      // area label reads cleanly.
      return (text || "")
        .replace(/^\s*(?:[IVXLCDM]+|[A-Z]|\d+)\s*[.)\-–]+\s*/i, "")
        .trim();
    },
    extractAreaLabel(headerText) {
      const t = (headerText || "").trim();
      const areaMatch = t.match(/ÁREA DE\s+(.+)/i);
      if (areaMatch) return this.stripEnumPrefix(areaMatch[1]) || areaMatch[1].trim();
      return this.stripEnumPrefix(t) || t.replace(/^[-–\s]+/, "");
    },
    sourceInfoForArea(area) {
      return (area && this.achievementSourceCache[area.slug]) || {};
    },
    sourceActionLabel(area) {
      const info = this.sourceInfoForArea(area);
      const name = info.source_document_name || "documento";
      return info.needs_create ? `Iniciar ${name}` : `Ir a ${name}`;
    },
    prefetchAchievementSourcesForPage(page) {
      if (!this.isEdaDocument || this.is_backup || this.localMode || !page) {
        return;
      }
      const areas = this.pageAreasByPageId[page.id] || [];
      areas.forEach((area) => {
        if (!this.isEmptyMirrorAchievementArea(area, page)) return;
        if (this.achievementSourceCache[area.slug]) return;
        const fields = this.getAreaAchievementFields(area, page);
        const markField = fields[0];
        if (!markField) return;
        documentOnlineService
          .resolveAchievementSource({
            document_id: this.document.id,
            mark_field_key: markField.key,
          })
          .then((info) => {
            this.$set(this.achievementSourceCache, area.slug, info);
          })
          .catch(() => {});
      });
    },
    openAchievementSource(area, page) {
      if (!area || this.achievementSourceLoading[area.slug]) return;
      const fields = this.getAreaAchievementFields(area, page);
      const markField = fields[0];
      if (!markField) return;
      this.$set(this.achievementSourceLoading, area.slug, true);
      const done = (info) => {
        this.$set(this.achievementSourceCache, area.slug, info);
        if (info && info.no_source) return;
        this.$emit("open-source-document", {
          ...info,
          eda_document_id: this.document.id,
          eda_student_grade_document_type_id:
            this.document.student_grade_document_type,
          eda_page_index: this.pageIndex,
          eda_focus_key: markField.key,
        });
      };
      const cached = this.achievementSourceCache[area.slug];
      if (cached) {
        done(cached);
        this.$set(this.achievementSourceLoading, area.slug, false);
        return;
      }
      documentOnlineService
        .resolveAchievementSource({
          document_id: this.document.id,
          mark_field_key: markField.key,
        })
        .then((info) => {
          done(info);
        })
        .catch(() => {
          this.$toasted.error(
            "No se pudo abrir el documento fuente. Intenta de nuevo."
          );
        })
        .finally(() => {
          this.$set(this.achievementSourceLoading, area.slug, false);
        });
    },
    scrollToSourceField(fieldKey, attempt = 0) {
      const el = document.getElementById("question-" + fieldKey);
      if (!el) {
        // Rows may still be rendering; retry a few times.
        if (attempt < 10) {
          setTimeout(() => this.scrollToSourceField(fieldKey, attempt + 1), 200);
        }
        return;
      }
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("source-field-highlight");
      setTimeout(() => {
        el.classList.remove("source-field-highlight");
      }, 2600);
    },
    openAddDimensionModal(page, area) {
      this.newDimensionName = "";
      this.addDimensionTarget = { page, area };
      this.$refs["add-dimension-modal"].show();
    },
    confirmAddDimension() {
      const target = this.addDimensionTarget;
      if (!target || !this.newDimensionName.trim()) return;
      const { page, area } = target;
      const afterRowId = area ? area.lastRowId : page.rows[page.rows.length - 1].id;
      documentOnlineService
        .addDimension({
          page_id: page.id,
          after_row_id: afterRowId,
          school_id: this.$store.state.login.school,
          name: this.newDimensionName.trim(),
          document_id: this.document.id,
        })
        .then((data) => {
          page.rows.push(data.row);
          page.rows.sort((a, b) => a.order - b.order);
          // Inicializar el array del checkbox para que sea multiselect de inmediato
          // (sin esperar a un reload que traiga la key en el context).
          if (data.field_key) {
            this.$set(this.field_values, data.field_key, []);
          }
          this.$toasted.success(
            `Dimensión creada. field_key: ${data.field_key}`
          );
        })
        .catch(() => {
          this.$toasted.error("Error al crear la dimensión");
        });
    },
    deleteDimension(row, page) {
      if (!confirm(`¿Eliminar la dimensión "${row.fields[0] && row.fields[0].text}"?`)) return;
      documentOnlineService
        .deleteDimension({ row_id: row.id })
        .then(() => {
          const idx = page.rows.indexOf(row);
          if (idx !== -1) page.rows.splice(idx, 1);
          this.$toasted.success("Dimensión eliminada");
        })
        .catch(() => {
          this.$toasted.error("Error al eliminar la dimensión");
        });
    },
    addOption(key, options, level, title) {
      if (!title) {
        title = { id: null };
      }
      documentOnlineService
        .addOption({
          school: this.$store.state.login.school,
          key: key,
          text: title.id? this.addExtra[key+title.id] : this.addExtra[key],
          document: this.document.id,
          level: level,
          title: title.id ? title.id : null,
        })
        .then((data) => {
          options.push(data);
          title.options.push(data.id);
          title.id? this.addExtra[key+title.id] = "" : this.addExtra[key] = "";
          this.$toasted.success("Opción agregada!");
        });
    },
    getFormatter: function (maxLen) {
      if (maxLen) return (text) => String(text).substring(0, maxLen);
      else return (text) => text;
    },
    showTextOptionsSuggestions(fieldKey) {
      this.$set(this.focusedTextOptionsFields, fieldKey, true);
      this.blockInput(fieldKey);
    },
    // "Continuar" from a suggestions / ejes section: reveal the text input
    // (even if still empty), close the section, then advance the guided flow to
    // the next question (or the next page when this was the last one).
    continueFromSection(fieldKey) {
      this.$set(this.revealedTextInput, fieldKey, true);
      this.$set(this.focusedTextOptionsFields, fieldKey, false);
      this.$set(this.focusedEjesAchievementFields, fieldKey, false);
      this.unblockInput(fieldKey);
      // The textarea was just revealed with its (programmatically generated)
      // content — size it to fit instead of leaving it at its default rows.
      this.autoGrowAllTextareas();
      // Guided flow: advance to the next question / page.
      this.goToNextQuestion(fieldKey);
    },
    // A "question" is any interactive field (kind !== NON_INTERACTABLE) with a
    // key; NON_INTERACTABLE titles/paragraphs are skipped.
    isQuestionField(field) {
      return !!field.kind && !!field.key;
    },
    // Ordered interactive fields on the current page.
    pageQuestionFields() {
      const page = this.document.document_template.pages[this.pageIndex];
      if (!page || !page.rows) {
        return [];
      }
      const out = [];
      page.rows.forEach((row) => {
        (row.fields || []).forEach((field) => {
          if (this.isQuestionField(field)) {
            out.push(field);
          }
        });
      });
      return out;
    },
    // Ordered keys of the questions on the current page.
    pageQuestionKeys() {
      return this.pageQuestionFields().map((f) => f.key);
    },
    // Whether an interactive field has no answer yet — used to skip already
    // filled fields when auto-focusing a page's first question.
    isFieldEmpty(field) {
      const key = field.key;
      // Ejes: the answer is the achievements map (the textarea text is just
      // generated from it), so either being present means it's answered.
      if (field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) {
        const ach = this.field_values[`${key}_achievements`];
        if (ach && Object.keys(ach).some((k) => ach[k])) {
          return false;
        }
      }
      const v = this.field_values[key];
      // BOOL: both "Sí" and "No" count as answered (any representation).
      if (field.kind === this.questionKinds.BOOL) {
        return !this.isBoolYes(key) && !this.isBoolNo(key);
      }
      if (v == null || v === "" || v === false) {
        return true;
      }
      if (Array.isArray(v)) {
        return v.length === 0;
      }
      if (typeof v === "object") {
        // OA_FIELD / OA_PROGRESSION carry { oas: [], values: {} }.
        if (Array.isArray(v.oas)) {
          return v.oas.length === 0;
        }
        // Achievement maps / typed user object: answered if any truthy value.
        return !Object.keys(v).some(
          (k) => v[k] !== "" && v[k] != null && v[k] !== false
        );
      }
      if (typeof v === "string") {
        return v.trim() === "";
      }
      return false;
    },
    // Highlight a question and smoothly scroll it into view.
    focusQuestion(key, scroll = true, block = "center") {
      this.focusedQuestionKey = key || null;
      const field = key ? this.getQuestionFieldByKey(key) : null;
      // Achievement fields run a row-level guided flow: focus their first
      // unanswered option row instead of highlighting the whole field.
      if (field && this.isAchievementField(field)) {
        this.$nextTick(() => this.focusFirstAchievementRow(field, scroll));
        return;
      }
      this.focusedAchievementRow = null;
      if (key && scroll) {
        // nextTick + a short delay so the (possibly just-loaded) page rows are
        // rendered before we look up and scroll to the element.
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.getElementById("question-" + key);
            if (el && el.scrollIntoView) {
              el.scrollIntoView({ behavior: "smooth", block });
            }
          }, 80);
        });
      }
    },
    isAchievementField(field) {
      return (
        field.kind === this.questionKinds.OA_ACHIEVEMENT ||
        field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT ||
        field.kind === this.questionKinds.USER_CHECKBOX_ACHIEVEMENT
      );
    },
    getQuestionFieldByKey(key) {
      return this.pageQuestionFields().find((f) => f.key === key) || null;
    },
    // The option rows of an achievement field (its "elements" to answer).
    achievementOptions(field) {
      if (field.kind === this.questionKinds.OA_ACHIEVEMENT) {
        return field.oa_achievement_options || [];
      }
      if (field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT) {
        return field.checkbox_achievement_options || [];
      }
      if (field.kind === this.questionKinds.USER_CHECKBOX_ACHIEVEMENT) {
        return (field.options || []).filter((o) => o.level === field.level);
      }
      return [];
    },
    isAchievementAnswered(field, optId) {
      const fv = this.field_values[field.key];
      return fv != null && fv[optId] != null && fv[optId] !== false;
    },
    // Focus the first option row of an achievement field that has no value yet.
    focusFirstAchievementRow(field, scroll = true) {
      const target = this.achievementOptions(field).find(
        (o) => !this.isAchievementAnswered(field, o.id)
      );
      if (target) {
        this.setAchievementRowFocus(field.key, target.id, scroll);
      } else {
        this.focusedAchievementRow = null;
      }
    },
    setAchievementRowFocus(fieldKey, optId, scroll = true) {
      const rowKey = fieldKey + "__" + optId;
      this.focusedAchievementRow = rowKey;
      if (scroll) {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.getElementById("ach-row-" + rowKey);
            if (el && el.scrollIntoView) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 80);
        });
      }
    },
    // Achievement button click: set the value, then move the row focus down to
    // the next unanswered option. When no unanswered rows remain, run the
    // field-level continue protocol (advance to the next empty field / page).
    onAchievementSelect(field, optId, value) {
      this.setAchievementValue(field.key, optId, value);
      // Toggled off (re-clicked the same level) → stay on this row.
      if (!this.isAchievementAnswered(field, optId)) {
        this.setAchievementRowFocus(field.key, optId, false);
        return;
      }
      const opts = this.achievementOptions(field);
      const idx = opts.findIndex((o) => o.id === optId);
      const next =
        opts
          .slice(idx + 1)
          .find((o) => !this.isAchievementAnswered(field, o.id)) ||
        opts.find((o) => !this.isAchievementAnswered(field, o.id));
      if (next) {
        this.setAchievementRowFocus(field.key, next.id, true);
      } else {
        this.focusedAchievementRow = null;
        this.goToNextQuestion(field.key);
      }
    },
    // Clicking / focusing anything inside an interactive field highlights it
    // (no scroll — the user is already there).
    onQuestionInteract(field) {
      if (this.isQuestionField(field) && field.key !== this.focusedQuestionKey) {
        this.focusQuestion(field.key, false);
      }
    },
    // Focus the first UNANSWERED question of the page (Redpie docs usually have
    // the first field pre-filled, so the very first field isn't useful). If
    // every field is already answered, focus nothing. Scrolls to its top so a
    // page change is visible even if the user was scrolled down.
    focusFirstQuestion(scroll = true) {
      const fields = this.pageQuestionFields();
      const target = fields.find((f) => this.isFieldEmpty(f));
      if (!target) {
        // No empty fields on the page → don't focus anything.
        this.focusQuestion(null, false);
        return;
      }
      this.focusQuestion(target.key, scroll, "start");
    },
    // Advance the guided flow to the next EMPTY question after the current one
    // on this page. When none remain empty, move focus to the page's
    // "Página siguiente" button so the user just presses it to continue.
    goToNextQuestion(currentKey) {
      const fields = this.pageQuestionFields();
      const idx = fields.findIndex((f) => f.key === currentKey);
      const next = fields
        .slice(idx + 1)
        .find((f) => this.isFieldEmpty(f));
      if (next) {
        this.focusQuestion(next.key);
      } else {
        this.focusNextPageButton();
      }
    },
    // No empty fields left on the page: clear the field highlight and move
    // focus to the bottom "Página siguiente" button (scrolled into view). On
    // the last page there is no such button, so nothing happens.
    focusNextPageButton() {
      this.focusQuestion(null, false);
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = document.getElementById(
            "page-next-btn-" + this.pageIndex
          );
          if (btn) {
            btn.focus();
            if (btn.scrollIntoView) {
              btn.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }, 80);
      });
    },
    // Manual page navigation (the buttons at the bottom of each page). Changing
    // pageIndex triggers the watcher → getPageInfo (lazy-loads the page rows and
    // focuses its first unanswered question).
    goToPrevPage() {
      if (this.pageIndex > 0) {
        this.pageIndex -= 1;
      }
    },
    goToNextPage() {
      if (
        this.pageIndex <
        this.document.document_template.pages.length - 1
      ) {
        this.pageIndex += 1;
      }
    },
    // Decide, once per TEXT_OPTIONS / TEXT_EJES_ACHIEVEMENT field, whether its
    // text input starts revealed: a field that loads with content (text or
    // saved achievements) shows the textarea; an empty one starts in section
    // mode (textarea hidden, suggestions / ejes shown). Driven by this flag —
    // NOT by field_values[key] live — because the ejes section auto-generates
    // text into field_values[key], which must not close the section. Idempotent
    // (only sets keys it hasn't decided yet); run after achievements load.
    initRevealedTextInput() {
      const pages =
        (this.document &&
          this.document.document_template &&
          this.document.document_template.pages) ||
        [];
      pages.forEach((page) => {
        (page.rows || []).forEach((row) => {
          (row.fields || []).forEach((field) => {
            if (
              (field.kind === this.questionKinds.TEXT_OPTIONS ||
                field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT) &&
              this.revealedTextInput[field.key] === undefined
            ) {
              const hasText = !!this.field_values[field.key];
              const ach = this.field_values[`${field.key}_achievements`];
              const hasAch =
                ach && Object.keys(ach).some((k) => ach[k]);
              this.$set(
                this.revealedTextInput,
                field.key,
                !!(hasText || hasAch)
              );
            }
          });
        });
      });
    },
    toggleTextOptionsSuggestions(fieldKey) {
      if (this.focusedTextOptionsFields[fieldKey]) {
        this.$set(this.focusedTextOptionsFields, fieldKey, false);
        this.unblockInput(fieldKey);
      } else {
        this.showTextOptionsSuggestions(fieldKey);
      }
    },
    hideTextOptionsSuggestions(fieldKey, event) {
      // Check if the focus is moving to an element within the suggestions container
      const relatedTarget = event.relatedTarget || document.activeElement;
      const suggestionsRef = this.$refs['textOptionsSuggestions_' + fieldKey];
      
      // Handle both array and single element refs
      const suggestionsElement = Array.isArray(suggestionsRef) ? suggestionsRef[0] : suggestionsRef;
      
      if (suggestionsElement && suggestionsElement.contains && suggestionsElement.contains(relatedTarget)) {
        // Focus is moving within the suggestions container, don't hide
        return;
      }
      
      // Use setTimeout to allow click event on suggestions to fire before hiding
      setTimeout(() => {
        // Double-check that focus hasn't moved back to the suggestions container
        const currentActiveElement = document.activeElement;
        const suggestionsRefCheck = this.$refs['textOptionsSuggestions_' + fieldKey];
        const suggestionsElementCheck = Array.isArray(suggestionsRefCheck) ? suggestionsRefCheck[0] : suggestionsRefCheck;
        
        if (suggestionsElementCheck && suggestionsElementCheck.contains && suggestionsElementCheck.contains(currentActiveElement)) {
          // Focus is still within the suggestions container, don't hide
          return;
        }
        
        this.$set(this.focusedTextOptionsFields, fieldKey, false);
        this.unblockInput(fieldKey);
      }, 200);
    },
    handleClickOutsideSuggestions(event) {
      // Check all fields with kind 13 (TEXT_OPTIONS) and kind 14 (TEXT_EJES_ACHIEVEMENT)
      const clickTarget = event.target;
      
      // Check if click is on a toggle link or its children (don't hide in this case)
      const isToggleLink = clickTarget.closest && (
        clickTarget.closest('.view-suggestions-link') !== null
      );
      if (isToggleLink) {
        return; // Let the toggle handler manage the visibility
      }
      
      // Get all fields from the current page
      const currentPage = this.document.document_template.pages[this.pageIndex];
      if (!currentPage || !currentPage.rows) return;
      
      // Iterate through all rows and fields to find TEXT_OPTIONS and TEXT_EJES_ACHIEVEMENT fields
      currentPage.rows.forEach(row => {
        if (!row.fields) return;
        
        row.fields.forEach(field => {
          // Handle TEXT_OPTIONS (kind 13)
          if (field.kind === this.questionKinds.TEXT_OPTIONS && this.focusedTextOptionsFields[field.key]) {
            const textarea = document.getElementById(field.key);
            const suggestionsRef = this.$refs['textOptionsSuggestions_' + field.key];
            const suggestionsElement = Array.isArray(suggestionsRef) ? suggestionsRef[0] : suggestionsRef;
            
            // Check if click is outside both textarea and suggestions container
            const isClickOutside = 
              textarea && !textarea.contains(clickTarget) &&
              (!suggestionsElement || !suggestionsElement.contains(clickTarget));
            
            if (isClickOutside) {
              this.$set(this.focusedTextOptionsFields, field.key, false);
              this.unblockInput(field.key);
            }
          }
          
          // Handle TEXT_EJES_ACHIEVEMENT (kind 14)
          if (field.kind === this.questionKinds.TEXT_EJES_ACHIEVEMENT && this.focusedEjesAchievementFields[field.key]) {
            const textarea = document.getElementById(field.key);
            const suggestionsRef = this.$refs['ejesAchievementSuggestions_' + field.key];
            const suggestionsElement = Array.isArray(suggestionsRef) ? suggestionsRef[0] : suggestionsRef;
            
            // Check if click is outside both textarea and suggestions container
            const isClickOutside = 
              textarea && !textarea.contains(clickTarget) &&
              (!suggestionsElement || !suggestionsElement.contains(clickTarget));
            
            if (isClickOutside) {
              this.$set(this.focusedEjesAchievementFields, field.key, false);
              this.unblockInput(field.key);
            }
          }
        });
      });
    },
    isTextFieldEmpty(key) {
      const v = this.field_values[key];
      return !v || String(v).trim() === "";
    },
    // A field with related keys pulls its AI context from those other fields;
    // without them the AI can only rework the text already written here.
    hasRelatedKeys(field) {
      return !!field && Array.isArray(field.related_keys) && field.related_keys.length > 0;
    },
    // Canned suggestions: they seed an empty field, so they are offered only
    // while it is empty (single_option, or any field with no related keys).
    // A field without max_length has no room to protect: its suggestions stay
    // available and can be combined freely.
    canPickTextOption(field) {
      if (!field || !field.max_length) return true;
      if (field.single_option || !this.hasRelatedKeys(field)) {
        return this.isTextFieldEmpty(field.key);
      }
      return true;
    },
    // AI suggestions: the mirror case — with no related keys the user's own
    // text IS the context, so they only make sense once something is written.
    canUseTextOptionAI(field) {
      if (!field) return true;
      if (this.hasRelatedKeys(field)) return true;
      return !this.isTextFieldEmpty(field.key);
    },
    // AI options rewrite what is there rather than appending to it.
    applyTextOptionAI(field, optionText) {
      if (!field || !optionText) return;
      const key = field.key;
      if (!this.hasRelatedKeys(field)) {
        this.$set(this.field_values, key, optionText);
        this.$set(this.revealedTextInput, key, true);
        this.updateInput(key);
        this.$nextTick(() => {
          this.autoGrowAllTextareas();
          const ta = document.getElementById(key);
          if (ta) {
            ta.focus();
            ta.setSelectionRange(ta.value.length, ta.value.length);
          }
        });
        return;
      }
      // fields with related keys keep the previous append behaviour
      this.addTextOption(key, optionText);
    },
    addTextOption(fieldKey, optionText, customOptions) {
      // Keep suggestions visible after adding option
      this.$set(this.focusedTextOptionsFields, fieldKey, true);
      const currentValue = this.field_values[fieldKey] || "";
      const field = this.getQuestionFieldByKey(fieldKey);
      if (field && field.single_option && field.max_length) {
        // one option only: replace whatever is there, no trailing newline
        if (!this.canPickTextOption(field)) return;
        this.$set(this.field_values, fieldKey, optionText);
        // reveal the textarea so the pasted text is visible and editable
        this.$set(this.revealedTextInput, fieldKey, true);
        this.updateInput(fieldKey);
        this.$nextTick(() => {
          this.autoGrowAllTextareas();
          const ta = document.getElementById(fieldKey);
          if (ta) {
            ta.focus();
            ta.setSelectionRange(ta.value.length, ta.value.length);
          }
        });
        return;
      }
      const separator = "\n"; //currentValue.length > 0 && !currentValue.endsWith(" ") && !currentValue.endsWith("\n") ? " " : "";
      this.field_values[fieldKey] = currentValue + optionText + separator;
      this.updateInput(fieldKey);
      if (customOptions) {
      // Remove the selected option from customOptions array so it's not shown anymore
        const index = customOptions.findIndex(opt => opt.text === optionText);
        if (index !== -1) {
          customOptions.splice(index, 1);
        }
      }
      // Keep the field focused after adding option
      this.$nextTick(() => {
        const textarea = document.getElementById(fieldKey);
        if (textarea) {
          textarea.focus();
          // Move cursor to end
          textarea.setSelectionRange(textarea.value.length, textarea.value.length);
        }
      });
    },
    generateTextOptionsAI(fieldKey) {
      // Set loading state for this specific field
      this.$set(this.textOptionsAILoading, fieldKey, true);
      
      // Make request to backend with field key
      documentOnlineService.generateTextOptionsAI({
        field_key: fieldKey,
        document: this.document.id
      }).then((data) => {
        this.$set(this.textOptionsAILoading, fieldKey, false);
        
        // Check for error response
        if (data.error) {
          this.$toasted.error(data.error);
          return;
        }
        
        // Store the AI-generated options
        if (data.brief || data.medium || data.detailed) {
          this.$set(this.aiGeneratedOptions, fieldKey, {
            brief: data.brief || "",
            medium: data.medium || "",
            detailed: data.detailed || ""
          });
          
          // Show suggestions panel and ensure field is focused
          this.showTextOptionsSuggestions(fieldKey);
          
          this.$toasted.success("Opciones generadas con IA. Selecciona una opción de abajo.");
        } else {
          this.$toasted.error("No se recibieron opciones válidas de la IA.");
        }
      }).catch((error) => {
        this.$set(this.textOptionsAILoading, fieldKey, false);
        let errorMessage = "Error desconocido";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.$toasted.error("Error al generar con IA: " + errorMessage);
        console.error("Error generating text options with AI:", error);
      });
    },
    manualSave: function () {
      var customFields = {};
      this.touchedFields.forEach((key) => {
        customFields[key] = this.field_values[key];
      });
      redpieService
        .manualSaveFureev({
          fields: customFields,
          document: this.document.id,
        })
        .then((data) => {
          this.$toasted.success(data.message);
        });
    },
    checkAutoUpdateDocument: function () {
      redpieService
        .checkAutoUpdateDocument({
          document: this.document.id,
        })
        .then((data) => {
          this.retrievedContext = data;
        });
    },
    getEmptyFields() {
      let fields = [];
      this.document.document_template.pages.forEach((page) => {
        let current_state = { main_keys: [] };
        let last_1_key = null;
        let last_2_key = null;
        let last_3_key = null;
        page.rows.forEach((row) => {
          row.fields.forEach((field) => {
            if (field.style === 3 && field.kind === 0) {
              last_1_key = field.id;
              current_state.main_keys.push(field.id);
              current_state[field.id] = { main_keys: [], has_elements: false };
            }
            if (field.style === 4 && field.kind === 0) {
              current_state[last_1_key].main_keys.push(field.id);
              current_state[last_1_key][field.id] = {
                main_keys: [],
                has_elements: false,
              };
              last_2_key = field.id;
            }
            if (field.style === 5 && field.kind === 0) {
              current_state[last_1_key][last_2_key].main_keys.push(field.id);
              current_state[last_1_key][last_2_key][field.id] = {
                has_elements: false,
              };
              last_3_key = field.id;
            }
            if (field.kind > 0) {
              if (
                field.kind === this.questionKinds.OA_ACHIEVEMENT &&
                !field.oa_achievement_options.length
              ) {
                fields.push(field.id);
              } else if (
                field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT &&
                !field.checkbox_achievement_options.length
              ) {
                fields.push(field.id);
              } else {
                if (last_1_key) {
                  current_state[last_1_key].has_elements = true;
                  if (last_2_key) {
                    current_state[last_1_key][last_2_key].has_elements = true;
                    if (last_3_key) {
                      current_state[last_1_key][last_2_key][
                        last_3_key
                      ].has_elements = true;
                    }
                  }
                }
              }
            }
          });
        });
        if (current_state.main_keys.length) {
          current_state.main_keys.forEach((key) => {
            if (!current_state[key].has_elements) {
              fields.push(key);
            }
            if (current_state[key].main_keys.length) {
              current_state[key].main_keys.forEach((key2) => {
                if (!current_state[key][key2].has_elements) {
                  fields.push(key2);
                }
                if (current_state[key][key2].main_keys.length) {
                  current_state[key][key2].main_keys.forEach((key3) => {
                    if (!current_state[key][key2][key3].has_elements) {
                      fields.push(key3);
                    }
                  });
                }
              });
            }
          });
        }
      });
      return fields;
    },
  },
  computed: {
    isEdaDocument() {
      const name =
        (this.document &&
          this.document.document_template &&
          this.document.document_template.name) ||
        "";
      return /estado de avance/i.test(name);
    },
    pageAreasByPageId() {
      const map = {};
      if (!this.document || !this.document.document_template) return map;
      for (const page of this.document.document_template.pages || []) {
        if (!page.rows || !page.rows.length) continue;
        map[page.id] = this.computeAreas(page);
      }
      return map;
    },
    errors() {
      let errors = {};
      errors["amount"] = 0;
      errors["pages"] = [];
      this.document.document_template.pages.forEach((page, pIndex) => {
        let page_errors = {};
        let current_state = {};
        page_errors.name = page.name ? page.name : "Página " + (pIndex + 1);
        page.rows.forEach((row) => {
          row.fields.forEach((field) => {
            if (field.style === 3) {
              current_state = {};
              current_state.sub1 = field.name;
            }
            if (field.style === 4) {
              delete current_state.sub3;
              current_state.sub2 = field.name;
            }
            if (field.style === 5) {
              current_state.sub3 = field.name;
            }
            if (
              field.style === 1 &&
              field.is_required &&
              (!this.field_values[field.key] ||
                this.field_values[field.key] === "" ||
                this.field_values[field.key].length === 0 ||
                this.field_values[field.key] === {} ||
                (this.field_values[field.key].oas &&
                  this.field_values[field.key].oas.length === 0))
            ) {
              errors["amount"] += 1;
              if (current_state.sub1) {
                page_errors[current_state.sub1]
                  ? ""
                  : (page_errors[current_state.sub1] = {});
              }
              if (current_state.sub2) {
                page_errors[current_state.sub1][current_state.sub2]
                  ? ""
                  : (page_errors[current_state.sub1][current_state.sub2] = {});
              }
              if (current_state.sub3) {
                page_errors[current_state.sub1][current_state.sub2][
                  current_state.sub3
                ]
                  ? ""
                  : (page_errors[current_state.sub1][current_state.sub2][
                      current_state.sub3
                    ] = {});
                page_errors[current_state.sub1][current_state.sub2][
                  current_state.sub3
                ].fields
                  ? page_errors[current_state.sub1][current_state.sub2][
                      current_state.sub3
                    ].fields.push({
                      name: field.name,
                      text: field.text,
                      kind: field.kind,
                    })
                  : (page_errors[current_state.sub1][current_state.sub2][
                      current_state.sub3
                    ].fields = [
                      { name: field.name, text: field.text, kind: field.kind },
                    ]);
              } else {
                if (current_state.sub2) {
                  page_errors[current_state.sub1][current_state.sub2].fields
                    ? page_errors[current_state.sub1][
                        current_state.sub2
                      ].fields.push({
                        name: field.name,
                        text: field.text,
                        kind: field.kind,
                      })
                    : (page_errors[current_state.sub1][
                        current_state.sub2
                      ].fields = [
                        {
                          name: field.name,
                          text: field.text,
                          kind: field.kind,
                        },
                      ]);
                } else {
                  if (current_state.sub1) {
                    page_errors[current_state.sub1].fields
                      ? page_errors[current_state.sub1].fields.push({
                          name: field.name,
                          text: field.text,
                          kind: field.kind,
                        })
                      : (page_errors[current_state.sub1].fields = [
                          {
                            name: field.name,
                            text: field.text,
                            kind: field.kind,
                          },
                        ]);
                  } else {
                    if (current_state.title) {
                      page_errors.fields
                        ? page_errors.fields.push({
                            name: field.name,
                            text: field.text,
                            kind: field.kind,
                          })
                        : (page_errors.fields = [
                            {
                              name: field.name,
                              text: field.text,
                              kind: field.kind,
                            },
                          ]);
                    } else {
                      page_errors.fields
                        ? page_errors.fields.push({
                            name: field.name,
                            text: field.text,
                            kind: field.kind,
                          })
                        : (page_errors.fields = [
                            {
                              name: field.name,
                              text: field.text,
                              kind: field.kind,
                            },
                          ]);
                    }
                  }
                }
              }
            }
          });
        });
        errors.pages.push(page_errors);
      });
      return errors;
    },
    fillableFields() {
      var fields = [];
      this.document.document_template.pages[this.pageIndex].rows.forEach(
        (row) => {
          row.fields.forEach((field) => {
            if (
              (field.kind !== this.questionKinds.BOOL &&
                ((this.field_values[field.key] &&
                  !this.field_values[field.key].length) ||
                  !this.field_values[field.key]) &&
                this.retrievedContext.includes(field.key)) ||
              (field.kind === this.questionKinds.BOOL &&
                !this.field_values[field.key] &&
                this.retrievedContext.includes(field.key))
            ) {
              fields.push(field.name);
            }
          });
        }
      );
      return fields;
    },
    subjectOptions() {
      let subjects = [];
      this.extraOAs.forEach((oa) =>
        subjects.includes(oa.subject) ? "" : subjects.push(oa.subject)
      );
      return subjects;
    },
    pageRequireGraph() {
      if (this.is_backup) {
        return false;
      }
      if (
        !this.document.document_template.pages[this.pageIndex] ||
        !this.document.document_template.pages[this.pageIndex].rows.length
      ) {
        return false;
      }
      let value = false;
      this.document.document_template.pages[this.pageIndex].rows.forEach(
        (row) =>
          row.fields.filter(
            (field) =>
              field.kind === this.questionKinds.CHECKBOX_ACHIEVEMENT ||
              field.kind === this.questionKinds.USER_CHECKBOX_ACHIEVEMENT ||
              field.kind === this.questionKinds.OA_ACHIEVEMENT
          ).length
            ? (value = true)
            : ""
      );
      return value;
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-header {
  background-color: #dddddd !important;
}
.custom-col {
  border: 1px black solid !important;
  min-height: 38px !important;
}
.content-1 {
  overflow-wrap: break-word !important;
  justify-content: flex-start !important;
}
.content-2 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(155, 187, 89) !important;
  justify-content: flex-start !important;
}
.content-3 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(214, 227, 188) !important;
  justify-content: flex-start !important;
}
.content-4 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(234, 241, 221) !important;
  justify-content: flex-start !important;
}
.content-5 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(234, 241, 221) !important;
  justify-content: flex-start !important;
}

/* CUSTOM_RADIO redesign — clickable option cards (both modes).
   Design language matches the .adaptation-button examples: white bg,
   #F8B500 accent, #374151 text. Responsive via auto-fit grid (1 col on
   phones, 2+ on wider screens) with clear hover affordance. */
.cr-card {
  margin: 0.75rem 0 1.25rem;
}
.cr-title {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1rem;
}
.cr-title-bar {
  flex: 0 0 auto;
  width: 5px;
  align-self: stretch;
  min-height: 1.5rem;
  background-color: #f8b500;
  border-radius: 3px;
}
.cr-title-text {
  font-size: clamp(1.05rem, 2.4vw, 1.3rem);
  font-weight: 700;
  line-height: 1.3;
  color: #1f3b63;
}
.cr-required {
  display: block;
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
}
.cr-options {
  display: grid;
  // Default (narrower / half-row field): one option per row (list).
  grid-template-columns: 1fr;
  gap: 0.85rem;
}
// Full-row field (size 12): exactly two options per row on desktop, one per
// row on phones. Compound selector (.cr-options.cr-options--cols) + an explicit
// desktop media query so the two-column rule always wins regardless of source
// order, and stays a single column on small screens.
.cr-options.cr-options--cols {
  grid-template-columns: 1fr;
}
@media (min-width: 769px) {
  .cr-options.cr-options--cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.cr-option {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  min-height: 76px;
  text-align: left;
  padding: 0.95rem 1.15rem;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  background-color: #fff;
  color: #374151;
  font-size: clamp(0.9rem, 1.6vw, 0.98rem);
  line-height: 1.45;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  transition: border-color 0.18s ease, background-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
}
.cr-option:hover {
  border-color: #f8b500;
  background-color: #fffaf2;
  box-shadow: 0 6px 16px rgba(248, 181, 0, 0.2);
  transform: translateY(-2px);
}
.cr-option:focus-visible {
  outline: none;
  border-color: #f8b500;
  box-shadow: 0 0 0 3px rgba(248, 181, 0, 0.3);
}
.cr-option-selected,
.cr-option-selected:hover {
  border-color: #f8b500;
  background-color: #fff6e6;
  box-shadow: 0 0 0 1.5px #f8b500, 0 6px 16px rgba(248, 181, 0, 0.18);
  font-weight: 600;
}
.cr-option-check {
  flex: 0 0 auto;
  font-size: 1.15rem;
  color: #f8b500;
}
.cr-toggle {
  margin-top: 0.9rem;
  padding: 0;
  border: none;
  background: none;
  color: #d98c10;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.15s ease;
}
.cr-toggle:hover {
  color: #b5740a;
}

/* Self-contained, vertically-scrollable option list for CUSTOM_CHECKBOX /
   CUSTOM_RADIO. The list scrolls inside itself (max 50vh) while the
   add-suggestion / continue controls stay below it, always reachable. */
.cr-scroll {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 4px 2px 2px;
  margin-bottom: 0.25rem;
}

/* Footer row that holds the add-suggestion control (left) and the continue
   button (right), outside the scroll area. */
.cr-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.85rem;
}
.cr-footer-add {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}
/* "Añadir sugerencia" reveal button (the new-option input is hidden until
   this is clicked). */
.cr-add-toggle {
  background-color: #fff7e6 !important;
  border: 1.5px solid #f3cd84 !important;
  color: #b5740a !important;
  font-weight: 600 !important;
  padding: 0.45rem 1.1rem !important;
  box-shadow: none !important;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.cr-add-toggle:hover {
  background-color: #fdecc8 !important;
  border-color: #f8b500 !important;
  color: #8a5a08 !important;
}
/* Revealed input + confirm button. */
.cr-add-input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
}
.cr-add-input .form-control {
  flex: 1 1 220px;
  min-width: 0;
}
.cr-add-confirm {
  background-color: #f8b500 !important;
  border: none !important;
  color: #fff !important;
  width: 38px;
  height: 38px;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.cr-add-confirm:hover {
  background-color: #e6a400 !important;
}
.cr-add-hint {
  flex: 1 1 100%;
  color: #9ca3af;
  font-size: 0.78rem;
}

/* Custom button group styling to match the image design */
.adaptation-button-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.adaptation-button {
  background-color: white !important;
  border: 1px solid #d1d5db !important;
  color: #374151 !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  min-width: 120px !important;
  text-align: center !important;
}

.adaptation-button:hover {
  background-color: #f9fafb !important;
  border-color: #9ca3af !important;
  color: #374151 !important;
}

.adaptation-button:focus {
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.3) !important;
  outline: none !important;
  border-color: #F8B500 !important;
  border-width: 2px !important;
}

.adaptation-button.selected {
  background-color: white !important;
  border: 2px solid #F8B500 !important;
  color: #374151 !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 1px #F8B500 !important;
}

/* More specific selector to ensure it overrides other styles */
.adaptation-button-group .adaptation-button.selected {
  background-color: white !important;
  border: 2px solid #F8B500 !important;
  color: #374151 !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 1px #F8B500 !important;
}

.adaptation-button.selected:hover {
  background-color: white !important;
  border-color: #F8B500 !important;
  color: #374151 !important;
  box-shadow: 0 0 0 1px #F8B500 !important;
}

/* ---- OA_PROGRESSION redesign ---- */

/* Subject chip floating above the OA name. */
.oa-subject-chip {
  display: inline-block;
  background-color: #fff3dc;
  color: #b5740a;
  border: 1px solid #f8d68a;
  border-radius: 999px;
  padding: 2px 12px;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 6px;
  max-width: 100%;
  white-space: normal;
}
.oa-name-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.oa-name-line strong {
  color: #1f2937;
}

/* "Tipo de adecuación" — two toggle buttons (replaces the radios). */
.tipo-button-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tipo-button {
  background-color: #fff;
  border: 1px solid #d1d5db;
  color: #374151;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: all 0.18s ease;
}
.tipo-button:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}
.tipo-button.selected {
  border: 2px solid #f8b500;
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 0 0 1px #f8b500;
  background-color: #fffaf0;
}

/* "Generar con IA" call-to-action button. */
.generar-ia-btn {
  border-radius: 999px !important;
}

/* Pulse to flag a not-yet-chosen action (tipo buttons / Generar con IA). */
.pulse-attention {
  animation: tipo-pulse 1.7s ease-in-out infinite;
}
@keyframes tipo-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(248, 181, 0, 0.45);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(248, 181, 0, 0);
  }
}

/* Brand-colour the checkboxes inside the progression table (#f8b500). */
.oa-progression-table::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #f8b500;
  border-color: #f8b500;
}
.oa-progression-table::v-deep .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(248, 181, 0, 0.35);
}
.oa-progression-table::v-deep .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #f8b500;
}

.adaptation-button.selected:focus {
  background-color: white !important;
  border: 2px solid #F8B500 !important;
  color: #374151 !important;
  box-shadow: 0 0 0 2px rgba(255, 107, 0, 0.3) !important;
}

.navigation-arrow {
  background-color: #f3f4f6 !important;
  border: 1px solid #d1d5db !important;
  color: #6b7280 !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
  min-width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.navigation-arrow:hover {
  background-color: #e5e7eb !important;
  border-color: #9ca3af !important;
  color: #374151 !important;
}

.text-options-suggestions {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  // No bottom padding: the sticky footer sits flush against the bottom edge.
  padding-bottom: 0;
  background-color: #f9fafb;
  // Cap the height so a long list of suggestions / ejes cards doesn't take
  // up infinite space — the content scrolls within instead.
  max-height: 50vh;
  // Scroll only vertically; the inner bootstrap .row negative margins must
  // never produce a horizontal scrollbar.
  overflow-y: auto;
  overflow-x: hidden;
}
// Keep the inner card grid inside the container's horizontal bounds so it
// can't trigger an x-axis scrollbar.
.text-options-suggestions .row {
  margin-left: 0;
  margin-right: 0;
}

// Footer pinned to the bottom of the scrollable section: spans the full
// container width and sits flush against the bottom edge so cards scroll
// cleanly underneath it. Its "Continuar" button closes the section.
.suggestions-footer {
  position: sticky;
  bottom: 0;
  // Extend to the container edges (cancel the 12px side padding) and stay
  // flush with the bottom — no gap between the bar and the cards behind it.
  margin: 12px -12px 0;
  padding: 12px;
  background-color: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  z-index: 2;
  box-shadow: 0 -6px 12px rgba(249, 250, 251, 0.95);
}
/* Split footer: add-suggestion control on the left, continue on the right. */
.suggestions-footer--split {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.suggestions-continue-btn {
  background-color: #f8b500 !important;
  border: none !important;
  color: #fff !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  padding: 0.5rem 1.25rem !important;
  box-shadow: 0 2px 6px rgba(248, 181, 0, 0.3);
  transition: background-color 0.18s ease, transform 0.18s ease,
    box-shadow 0.18s ease;
}
.suggestions-continue-btn:hover {
  background-color: #e6a400 !important;
  color: #fff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(248, 181, 0, 0.4);
}
.suggestions-continue-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(248, 181, 0, 0.4);
}

/* Guided flow: every interactive field reserves the focus-box border/padding
   (so focusing causes no layout shift); the focused one gets the rounded,
   shadowed container. */
.question-field {
  border: 2px solid transparent;
  border-radius: 14px;
  padding: 0.85rem 1rem !important;
  transition: border-color 0.25s ease, box-shadow 0.25s ease,
    background-color 0.25s ease;
}
.question-focused {
  border-color: #f8b500 !important;
  background-color: #ffffff;
  box-shadow: 0 10px 28px rgba(248, 181, 0, 0.22),
    0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.suggestions-label {
  font-weight: 500;
  color: #6b7280;
}

.suggestions-list-vertical {
  display: flex;
  flex-direction: column;
}
/* Full-row (size 12) question: lay the suggestions out in two columns on
   desktop, a single column on phones. The grid gap handles spacing, so the
   per-button bottom margin is dropped in this mode. */
.suggestions-list-vertical--cols {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}
@media (min-width: 769px) {
  .suggestions-list-vertical--cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.suggestions-list-vertical--cols .suggestion-button {
  // Grid gap handles spacing; clear Bootstrap's btn-block sibling margins
  // (.btn-block + .btn-block adds margin-top to all but the first button,
  // which would misalign the first cell against the rest of its row).
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.suggestion-button {
  cursor: pointer;
  transition: border-color 0.18s ease, background-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
  border: 1.5px solid #e5e7eb !important;
  border-radius: 12px !important;
  background-color: #fff !important;
  color: #374151 !important;
  font-weight: normal !important;
  padding: 0.7rem 1rem !important;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  white-space: normal;
}

.suggestion-button:hover {
  background-color: #fffaf2 !important;
  border-color: #f8b500 !important;
  box-shadow: 0 6px 16px rgba(248, 181, 0, 0.2);
  transform: translateY(-2px);
}

.suggestion-button:focus-visible {
  outline: none;
  border-color: #f8b500 !important;
  box-shadow: 0 0 0 3px rgba(248, 181, 0, 0.3);
}

.suggestion-button:active {
  transform: translateY(0);
}

.suggestion-button-vertical {
  text-align: left;
}

.view-suggestions-link {
  color: #374151;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  transition: all 0.2s ease;
  border-bottom: 2px solid #F97316;
  padding-bottom: 2px;
}

.view-suggestions-link:hover {
  color: #F97316;
  text-decoration: none;
  border-bottom-color: #ea580c;
}

.view-suggestions-link:focus {
  outline: none;
  text-decoration: none;
}

.view-suggestions-link.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* Eje cards styling */
.eje-card {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

/* Disappear effect when an eje card is completed (all options answered).
   The leaving card fades + shrinks; remaining cards slide into place. */
.eje-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.eje-fade-leave-to {
  opacity: 0;
  transform: scale(0.85);
}
.eje-fade-move {
  transition: transform 0.4s ease;
}

/* Answered OA / tag rows inside a card fade out (used options are removed). */
.oa-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.oa-fade-leave-to {
  opacity: 0;
  transform: translateX(12px);
}
.oa-fade-move {
  transition: transform 0.3s ease;
}

/* First-OA hint: pulses until the user sets their first achievement, so the
   L/P/N options read as clickable. */
.eje-hint-row {
  border-radius: 8px;
  padding: 4px 6px;
  margin: -4px -6px 0.5rem;
  animation: eje-hint-pulse 1.6s ease-in-out infinite;
}
@keyframes eje-hint-pulse {
  0%,
  100% {
    background-color: rgba(248, 181, 0, 0.08);
    box-shadow: 0 0 0 0 rgba(248, 181, 0, 0.35);
  }
  50% {
    background-color: rgba(248, 181, 0, 0.22);
    box-shadow: 0 0 0 5px rgba(248, 181, 0, 0);
  }
}

.eje-card .card-title {
  font-size: 1.1rem;
  color: #1f2937;
}

.oa-item {
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
}

.oa-item:last-child {
  border-bottom: none;
}

.oa-text {
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.4;
}

/* Achievement selector — individual, circular, separated buttons (no longer a
   connected group). */
.achievement-selector {
  flex-shrink: 0;
  display: flex;
  gap: 6px;
}

.achievement-btn {
  width: 34px;
  height: 34px;
  min-width: 34px;
  padding: 0;
  border: 1.5px solid #e5e7eb;
  border-radius: 50%;
  background-color: #fff;
  color: #9ca3af;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  transition: border-color 0.18s ease, background-color 0.18s ease,
    color 0.18s ease, box-shadow 0.18s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.achievement-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
/* The selected (active) button stays fully opaque and filled. */
.achievement-btn.active {
  opacity: 1;
  color: #fff;
}

.achievement-l:hover {
  border-color: #10b981;
  color: #10b981;
  background-color: #f0fdf4;
}
.achievement-l.active {
  border-color: #10b981;
  background-color: #10b981;
}

.achievement-p:hover {
  border-color: #f97316;
  color: #f97316;
  background-color: #fff7ed;
}
.achievement-p.active {
  border-color: #f97316;
  background-color: #f97316;
}

.achievement-n:hover {
  border-color: #ef4444;
  color: #ef4444;
  background-color: #fef2f2;
}
.achievement-n.active {
  border-color: #ef4444;
  background-color: #ef4444;
}

/* The first still-unmarked OA across the cards — highlighted so the user knows
   where to continue. */
.oa-item-focused {
  background-color: #fff8e8;
  border: 1.5px solid #f8b500 !important;
  border-radius: 12px;
  padding: 10px 12px !important;
}
.oa-item-focused .achievement-btn:not(.active) {
  border-color: #f5cd7a;
  color: #d98c10;
}

/* Add option section */
.add-option-section {
  border-top: 1px solid #e5e7eb !important;
}

/* Bottom-of-page previous / next navigation. */
.page-nav-row {
  border-top: 1px solid #e5e7eb;
  padding-top: 1rem;
}
.page-nav-btn {
  font-weight: 600 !important;
}
/* Prominent, pulsing focus ring when the continue protocol moves focus here
   (no empty fields left on the page). */
.page-nav-btn:focus,
.page-nav-btn:focus-visible {
  outline: none;
  animation: page-nav-pulse 1.5s ease-in-out infinite;
}
@keyframes page-nav-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(248, 181, 0, 0.5);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(248, 181, 0, 0);
  }
}

.add-option-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8b500;
  border: none;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-option-btn:hover {
  background-color: #e6a400;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.add-option-btn:active {
  transform: scale(0.95);
}

/* ---- Achievement questions (OA_ACHIEVEMENT / CHECKBOX_ACHIEVEMENT /
   USER_CHECKBOX_ACHIEVEMENT): description / badges on the left, title buttons
   on the right (replacing the old per-column checkboxes). ---- */
.ach-row {
  align-items: center;
  padding: 0.65rem 0;
  border-bottom: 1px solid #eef0f2;
  border-radius: 12px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
/* Guided row focus: the achievement option currently being answered. Uses an
   inset ring + tint (not an outer shadow) so it doesn't overflow the bootstrap
   .row negative margins, and keeps the same padding to avoid a layout jump. */
.ach-row-focused {
  background-color: #fff8e8;
  border-bottom-color: transparent;
  box-shadow: inset 0 0 0 2px #f8b500;
}
.ach-info {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.ach-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.ach-badge {
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  padding: 0.32rem 0.65rem !important;
  border-radius: 999px !important;
}
.ach-badge-subject {
  background-color: #e7f0ff !important;
  color: #1d4ed8 !important;
}
.ach-badge-name {
  background-color: #fff3dc !important;
  color: #b5740a !important;
}
.ach-desc {
  color: #1f2937;
  line-height: 1.45;
  font-weight: 500;
}
.ach-target {
  font-size: 0.85rem;
  color: #6b7280;
}
.ach-target-label {
  font-weight: 700;
  color: #9ca3af;
}
.ach-actions {
  display: flex;
  justify-content: flex-end;
}
.ach-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: flex-end;
}
.ach-btn {
  border: 1.5px solid #e5e7eb;
  background-color: #fff;
  color: #6b7280;
  border-radius: 999px;
  padding: 0.4rem 0.95rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}
.ach-btn:hover {
  border-color: #f8b500;
  color: #b5740a;
  background-color: #fffaf2;
}
/* Selected — generic (amber). */
.ach-btn-selected,
.ach-btn-selected:hover {
  border-color: #f8b500;
  background-color: #f8b500;
  color: #fff;
}
/* Selected — semantic colours for the fixed OA_ACHIEVEMENT levels. */
.ach-btn.ach-l.ach-btn-selected,
.ach-btn.ach-l.ach-btn-selected:hover {
  background-color: #37ba7b;
  border-color: #37ba7b;
  color: #fff;
}
.ach-btn.ach-p.ach-btn-selected,
.ach-btn.ach-p.ach-btn-selected:hover {
  background-color: #f59e0b;
  border-color: #f59e0b;
  color: #fff;
}
.ach-btn.ach-n.ach-btn-selected,
.ach-btn.ach-n.ach-btn-selected:hover {
  background-color: #ef4444;
  border-color: #ef4444;
  color: #fff;
}
.ach-btn.ach-nt.ach-btn-selected,
.ach-btn.ach-nt.ach-btn-selected:hover {
  background-color: #9ca3af;
  border-color: #9ca3af;
  color: #fff;
}

/* Source field highlight: when the PAI/PACI is opened at the exact section
   that needs completing, briefly pulse it so the user finds it. */
.source-field-highlight {
  animation: source-field-pulse 2.4s ease-out;
  border-radius: 10px;
}
@keyframes source-field-pulse {
  0% {
    box-shadow: 0 0 0 3px rgba(248, 181, 0, 0.55);
    background-color: rgba(248, 181, 0, 0.14);
  }
  70% {
    box-shadow: 0 0 0 3px rgba(248, 181, 0, 0.35);
    background-color: rgba(248, 181, 0, 0.08);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(248, 181, 0, 0);
    background-color: transparent;
  }
}

/* Empty EDA mirror section: prompt to complete source document first. */
.eda-empty-source-wrap {
  display: flex;
  justify-content: center;
  padding: 1.25rem 0.75rem 1.5rem;
}
.eda-empty-source {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 1rem 1.15rem;
  border-radius: 12px;
  background: #fff8e8;
  border: 1.5px solid rgba(248, 181, 0, 0.45);
  text-align: center;
}
.eda-empty-source-lead {
  margin: 0 0 0.5rem;
  color: #1f2937;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.35;
}
.eda-empty-source-text {
  margin: 0 0 0.65rem;
  color: #374151;
  line-height: 1.5;
  font-size: 0.88rem;
}
.eda-empty-source-student {
  margin: 0 0 0.85rem;
  color: #6b7280;
  font-size: 0.82rem;
}
.eda-empty-source-btn {
  border: 1.5px solid #f8b500;
  background: #fff;
  color: #9a6700;
  border-radius: 999px;
  padding: 0.45rem 1.15rem;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.eda-empty-source-btn:hover:not(:disabled) {
  background: #f8b500;
  color: #fff;
}
.eda-empty-source-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* Grouped USER_CHECKBOX_ACHIEVEMENT: one row per option inside the group. */
.ach-group-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.ach-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.6rem;
  border-bottom: 1px solid #eef0f2;
  padding: 0.4rem 0;
}
.ach-group-item .ach-info {
  flex: 1 1 200px;
}

/* STRING field: the input + an "OK" continue button (shown while focused). */
.text-input-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.text-input-control {
  flex: 1 1 auto;
}
.text-input-ok {
  flex: 0 0 auto;
  background-color: #f8b500 !important;
  border: none !important;
  color: #fff !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  padding: 0 1.1rem !important;
  display: inline-flex !important;
  align-items: center;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(248, 181, 0, 0.3);
}
.text-input-ok:hover,
.text-input-ok:focus {
  background-color: #e6a400 !important;
  color: #fff !important;
}

/* BOOL field: a Sí / No button pair (replaces the checkbox). */
.bool-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.bool-label {
  font-size: 16px;
  margin-bottom: 2px;
}
.bool-options {
  display: flex;
  gap: 8px;
}
.bool-btn {
  min-width: 78px;
  padding: 0.45rem 1.2rem;
  border: 1.5px solid #e5e7eb;
  border-radius: 999px;
  background-color: #fff;
  color: #6b7280;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    color 0.15s ease;
}
.bool-btn:hover {
  border-color: #f8b500;
  color: #b5740a;
  background-color: #fffaf2;
}
.bool-btn-yes.bool-btn-active,
.bool-btn-yes.bool-btn-active:hover {
  border-color: #37ba7b;
  background-color: #37ba7b;
  color: #fff;
}
.bool-btn-no.bool-btn-active,
.bool-btn-no.bool-btn-active:hover {
  border-color: #ef4444;
  background-color: #ef4444;
  color: #fff;
}

/* Ejes rubric — mobile responsiveness. The eje cards already stack to one
   per row on xs via cols="12"; here we adapt the header filters and each
   OA item so nothing is cramped on a phone. */
@media (max-width: 767.98px) {
  // Header: title + the two filter selects stack, each full width.
  .ejes-rubric-header > [class*="col"] {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0.5rem;
  }
  .ejes-rubric-header .custom-select,
  .ejes-rubric-header select {
    width: 100%;
  }
  // OA item: put the achievement buttons under the text (instead of beside),
  // and let them grow into bigger, easier tap targets.
  .ejes-rubric .oa-item {
    flex-direction: column;
    align-items: stretch !important;
  }
  .ejes-rubric .oa-text {
    margin-right: 0 !important;
    margin-bottom: 0.5rem;
  }
  .ejes-rubric .achievement-selector {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }
  /* Keep the buttons circular (just a touch larger) instead of stretching. */
  .ejes-rubric .achievement-selector .achievement-btn {
    width: 40px;
    height: 40px;
    min-width: 40px;
    flex: 0 0 auto;
  }

  /* Table → cards on mobile: every <tr> becomes a self-contained card and
     every <td> stacks full-width with its column name (data-label) above it,
     so the user fills one OA at a time instead of scrolling a wide table. */
  .responsive-card-table,
  .responsive-card-table tbody,
  .responsive-card-table tr,
  .responsive-card-table td {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .responsive-card-table thead {
    display: none !important;
  }
  .responsive-card-table tr {
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb !important;
    border-radius: 12px;
    padding: 14px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }
  .responsive-card-table td {
    border: none !important;
    padding: 8px 0 !important;
  }
  .responsive-card-table td + td {
    border-top: 1px solid #f1f1f1 !important;
  }
  .responsive-card-table td[data-label]::before {
    content: attr(data-label);
    display: block;
    font-weight: 700;
    font-size: 0.7rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #b5740a;
    margin-bottom: 6px;
  }
  /* Inputs/areas should fill the card width on mobile. */
  .responsive-card-table .auto-grow-textarea,
  .responsive-card-table textarea,
  .responsive-card-table .custom-select,
  .responsive-card-table select {
    width: 100% !important;
  }
  /* Tipo toggles already stack (flex-direction: column) — make them full width. */
  .responsive-card-table .tipo-button,
  .responsive-card-table .adaptation-button {
    width: 100%;
  }

  /* USER_CHECKBOX_ACHIEVEMENT: the b-row/b-col grid behaves like a table. On
     mobile the column-title header is hidden and each option row becomes a
     card — the option text on top, the checkboxes below, each labelled by its
     column (data-label) so the user answers one item at a time. */
  .uca-title-head {
    display: none !important;
  }
  .uca-option-row {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 14px;
    margin: 0 0 1rem;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }
  .uca-option-row .uca-option-text {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .uca-check-col {
    flex: 1 1 0 !important;
    max-width: none !important;
    text-align: center;
    padding: 6px 2px !important;
  }
  .uca-check-col::before {
    content: attr(data-label);
    display: block;
    font-size: 0.64rem;
    font-weight: 700;
    line-height: 1.1;
    text-transform: uppercase;
    color: #b5740a;
    margin-bottom: 4px;
  }
  /* Centre the (label-less) checkbox under its column label. */
  .uca-check-col::v-deep .custom-control {
    width: 1.5rem;
    margin: 0 auto;
    padding-left: 1.5rem;
  }

  /* Achievement rows on mobile: info and buttons stack (cols=12); the card
     (uca-option-row) provides separation, and the title buttons left-align. */
  .ach-row {
    border-bottom: none;
  }
  .ach-info {
    margin-bottom: 0.6rem;
  }
  .ach-actions,
  .ach-options {
    justify-content: flex-start;
  }

  /* OA_ACHIEVEMENT data columns (Asignatura / Habilidades): full width with a
     small label above the value. */
  .uca-data-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 4px 0 !important;
  }
  .uca-data-col[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #b5740a;
    margin-bottom: 2px;
  }
  /* OA_ACHIEVEMENT achievement options: the four long-labelled checkboxes stack
     vertically, each a checkbox + inline label (a 4-across grid would be far
     too cramped for labels like "No Trabajado en este período"). */
  .oaa-check-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    text-align: left !important;
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 7px 0 !important;
    border-top: 1px solid #f1f1f1;
  }
  .oaa-check-col::after {
    content: attr(data-label);
    font-size: 0.92rem;
    color: #374151;
  }
  .oaa-check-col::v-deep .custom-control {
    flex: 0 0 auto;
    width: 1.5rem;
    min-height: auto;
    margin: 0;
    padding-left: 1.5rem;
  }

  /* Grouped variant (field.titles.length): each group is a card; its title
     spans full width, the option labels and their checkbox grid stay paired
     side by side instead of collapsing into an unreadable wide grid. */
  .uca-group-row {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 14px;
    margin: 0 0 0.5rem;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }
  .uca-group-title {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }
  .uca-group-labels {
    flex: 0 0 42% !important;
    max-width: 42% !important;
  }
  .uca-group-checks {
    flex: 0 0 58% !important;
    max-width: 58% !important;
  }

  /* "Añadir sugerencia" rows stack full width on mobile. */
  .uca-add-row > [class*="col"] {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }
  .uca-add-row .btn {
    width: 100%;
  }
}

// Auto-grow textareas
.auto-grow-textarea,
.form-control[rows],
textarea[rows] {
  resize: vertical;
  overflow-y: hidden;
  min-height: calc(1.5em + 0.75rem + 2px);
  transition: height 0.1s ease;
}

// Bootstrap Vue textarea auto-grow
textarea.form-control,
.auto-grow-textarea textarea {
  height: auto;
  overflow-y: hidden !important;
}
</style>
